/**
 * Traducciones del panel de administración V2
 * ─────────────────────────────────────────────
 * Idiomas soportados: es (Español), en (English), pt (Português)
 * Para agregar un nuevo idioma, copiá el bloque "es" y traducilo.
 */

import reservationsNew from "./reservationsNew";
import cashRegister from "./cashRegister";
import comandas from "./comandas";
import costs from "./costs";
import costsV3 from "./costsV3";
import pedidosPos from "./pedidos/pos";
import editorV2 from "./editorV2";
import landing from "./landing";

const translations = {

  // ═══════════════════════════════════════════
  //  ESPAÑOL (default)
  // ═══════════════════════════════════════════
  es: {
    // ─── Editor layout ───
    "editor.loading": "Cargando menú...",
    "editor.notFound": "Menú no encontrado",
    "editor.backToProfile": "Volver al Perfil",
    "editor.brand": "RestaurAdmin",
    "editor.brandSub": "Editor V2",
    "editor.viewMenu": "Ver Menú",
    "editor.save": "🚀 Subir Menú",
    "editor.saveMobile": "🚀 Subir",
    "editor.saving": "⏳ Subiendo...",
    "editor.unsaved": "● Cambios sin subir",
    "editor.unsavedMobile": "● Sin subir",
    "editor.published": "✓ Publicado",

    // ─── Navigation ───
    "nav.general": "General",
    "nav.generalShort": "General",
    "nav.restaurant": "Info del Restaurante",
    "nav.restaurantShort": "Info",
    "nav.catalog": "Catálogo",
    "nav.catalogShort": "Catálogo",
    "nav.modules": "Módulos",
    "nav.modulesShort": "Módulos",
    "nav.preview": "Vista Previa",
    "nav.previewShort": "Preview",

    // ─── General Section ───
    "general.languages": "🌐 Idiomas del Menú",
    "general.languagesDesc": "Configura los idiomas disponibles. El idioma por defecto se muestra primero a tus clientes.",
    "general.defaultLang": "Idioma por Defecto",
    "general.additionalLangs": "Idiomas Adicionales",
    "general.addLang": "+ Agregar Idioma",
    "general.removeLangTitle": "¿Eliminar idioma?",
    "general.removeLangMsg": "Se eliminará el idioma {lang} y todas sus traducciones.",
    "general.removeLangConfirm": "Eliminar",
    "general.aboutLangs": "Sobre los idiomas",
    "general.aboutLangsDesc": "Al agregar un nuevo idioma, podrás traducir automáticamente todo el contenido existente o completar las traducciones manualmente en cada sección.",
    "general.autoTranslateTitle": "¿Traducir automáticamente?",
    "general.autoTranslateMsg": "Agregaste \"{lang}\". ¿Querés traducir automáticamente todo el contenido?",
    "general.autoTranslateManual": "Traduzco manual",
    "general.autoTranslateAuto": "✨ Traducir todo",
    "general.autoTranslating": "⏳ Traduciendo...",
    "general.currency": "Moneda",
    "general.timezone": "🕐 Zona Horaria",
    "general.timezoneDesc": "Configurá la zona horaria de tu restaurante. Se usa para mostrar u ocultar categorías según el horario (franjas horarias).",
    "general.timezoneLabel": "Zona Horaria del Restaurante",
    "general.fonts": "🔤 Tipografías",
    "general.fontsDesc": "Usá las flechas para ir pasando y ver cómo queda cada fuente en vivo.",
    "general.fontHeading": "FUENTE DE TÍTULOS",
    "general.fontHeadingPreview": "Entradas · Platos Principales",
    "general.fontBody": "FUENTE DEL CUERPO",
    "general.fontBodyPreview": "Hamburguesa clásica con queso cheddar, lechuga y tomate.",

    "general.colors": "🎨 Colores del Menú",
    "general.colorsDesc": "Personalizá los colores del fondo, tipografía y portada del menú.",
    "general.colorReset": "Restablecer",

    "general.themeAccent": "ACENTO",
    "general.themeAccentReset": "↩ Restablecer",
    "general.themeAdvanced": "AJUSTES AVANZADOS",
    "general.themeAdvancedClearAll": "Limpiar todo",
    "general.themeAdvancedHint": "Ajustá colores individuales sobre el tema base. El botón ↩ restaura el valor original del tema.",
    "general.themeGroupBody": "Cuerpo del menú",
    "general.themeGroupHero": "Portada / Hero",
    "general.tokenBg": "Fondo general",
    "general.tokenSurface": "Cards / Superficies",
    "general.tokenText": "Texto principal",
    "general.tokenTextSec": "Texto secundario",
    "general.tokenTextMuted": "Texto atenuado",
    "general.tokenBorder": "Bordes",
    "general.tokenDivider": "Divisor productos",
    "general.tokenHeaderBg": "Fondo de portada",
    "general.tokenHeaderText": "Texto de portada",
    "general.previewHeroSub": "Portada",
    "general.previewCat1": "Entradas",
    "general.previewCat2": "Principales",
    "general.previewProduct": "Hamburguesa clásica",
    "general.previewProductDesc": "Con queso cheddar, lechuga y tomate.",
    "general.previewAllergens": "(V) (G)",
    "general.previewHoursLabel": "🕐 Horarios",
    "general.previewHoursDay": "● Lunes",
    "general.previewHoursTime": "12:00 – 23:00",
    "general.previewFooter": "Menú digital por",

    // ─── Currency names ───
    "currency.ARS": "Peso Argentino",
    "currency.USD": "Dólar Estadounidense",
    "currency.EUR": "Euro",
    "currency.BRL": "Real Brasileño",
    "currency.MXN": "Peso Mexicano",

    // ─── Timezone names ───
    "tz.ar": "🇦🇷 Argentina (Buenos Aires)",
    "tz.mx": "🇲🇽 México (Ciudad de México)",
    "tz.cl": "🇨🇱 Chile (Santiago)",
    "tz.co": "🇨🇴 Colombia (Bogotá)",
    "tz.pe": "🇵🇪 Perú (Lima)",
    "tz.uy": "🇺🇾 Uruguay (Montevideo)",
    "tz.br": "🇧🇷 Brasil (São Paulo)",
    "tz.ve": "🇻🇪 Venezuela (Caracas)",
    "tz.ec": "🇪🇨 Ecuador (Guayaquil)",
    "tz.py": "🇵🇾 Paraguay (Asunción)",
    "tz.bo": "🇧🇴 Bolivia (La Paz)",
    "tz.pa": "🇵🇦 Panamá",
    "tz.cr": "🇨🇷 Costa Rica",
    "tz.usEast": "🇺🇸 Estados Unidos (Este)",
    "tz.usPacific": "🇺🇸 Estados Unidos (Pacífico)",
    "tz.usCentral": "🇺🇸 Estados Unidos (Central)",
    "tz.es": "🇪🇸 España (Madrid)",
    "tz.gb": "🇬🇧 Reino Unido (Londres)",
    "tz.fr": "🇫🇷 Francia (París)",
    "tz.it": "🇮🇹 Italia (Roma)",
    "tz.de": "🇩🇪 Alemania (Berlín)",

    // ─── Restaurant Info Section ───
    "info.images": "📷 Imágenes del Restaurante",
    "info.logo": "Logo",
    "info.cover": "Portada",
    "info.coverBgColor": "Color de Fondo de Portada",
    "info.uploading": "Subiendo...",
    "info.clickUpload": "Click para subir {type}",
    "info.dropHint": "o arrastrá una imagen aquí",
    "info.dropActive": "Soltá para subir",
    "info.imgFormats": "PNG, JPG",
    "info.uploadError": "Error al subir la imagen.",
    "info.basic": "ℹ️ Información Básica",
    "info.default": "Predeterminado",
    "info.name": "Nombre del Restaurante",
    "info.namePlaceholder": "Nombre...",
    "info.description": "Descripción",
    "info.descPlaceholder": "Descripción breve...",
    "info.social": "🔗 Redes Sociales",
    "info.instagram": "📸 Instagram",
    "info.instagramPlaceholder": "@usuario",
    "info.facebook": "👤 Facebook",
    "info.facebookPlaceholder": "URL o usuario",
    "info.whatsapp": "💬 WhatsApp",
    "info.whatsappPlaceholder": "+54 9 11 1234-5678",
    "info.website": "🌐 Sitio Web",
    "info.websitePlaceholder": "https://...",
    "info.googleMaps": "⭐ Google Maps / Reseñas",
    "info.googleMapsPlaceholder": "https://maps.google.com/...",
    "info.wifi": "📶 WiFi del Local",
    "info.wifiName": "Nombre de Red",
    "info.wifiNamePlaceholder": "WiFi-Restaurant",
    "info.wifiPassword": "Contraseña",
    "info.wifiPasswordPlaceholder": "contraseña123",
    "info.hours": "🕐 Horarios de Atención",
    "info.timeTo": "a",
    "info.addRange": "+ Agregar franja",
    "info.closed": "Cerrado",

    // ─── Days of week ───
    "day.monday": "Lunes",
    "day.tuesday": "Martes",
    "day.wednesday": "Miércoles",
    "day.thursday": "Jueves",
    "day.friday": "Viernes",
    "day.saturday": "Sábado",
    "day.sunday": "Domingo",

    // ─── Catalog Section ───
    "catalog.search": "Buscar...",
    "catalog.newCategory": "Nueva Categoría",
    "catalog.newCategoryShort": "Categoría",
    "catalog.empty": "No hay categorías aún",
    "catalog.createFirst": "Crear Primera Categoría",
    "catalog.hidden": "OCULTA",
    "catalog.paused": "PAUSADA",
    "catalog.items": "ítems",
    "catalog.visible": "👁️ Visible",
    "catalog.hiddenBtn": "🚫 Oculta",
    "catalog.prices": "💲 Precios",
    "catalog.edit": "✏️ Editar",
    "catalog.delete": "🗑️",
    "catalog.addSubcategory": "📂 + Sub-categoría",
    "catalog.addProduct": "+ Producto",
    "catalog.noProducts": "Sin productos",
    "catalog.addProductLink": "+ Agregar producto",
    "catalog.noName": "Sin nombre",
    "catalog.bulkAdjust": "Ajustar:",
    "catalog.bulkApply": "Aplicar",
    "catalog.bulkTitle": "Ajuste masivo",
    "catalog.bulkIncrease": "¿Aumentar precios de \"{name}\" en {pct}%?",
    "catalog.bulkDecrease": "¿Disminuir precios de \"{name}\" en {pct}%?",
    "catalog.bulkFixedIncrease": "¿Sumar ${amount} a todos los precios de \"{name}\"?",
    "catalog.bulkFixedDecrease": "¿Restar ${amount} a todos los precios de \"{name}\"?",
    "catalog.editPrice": "Editar precio",
    "catalog.hide": "Ocultar",
    "catalog.show": "Mostrar",
    "catalog.editAction": "Editar",
    "catalog.deleteAction": "Eliminar",
    "catalog.deleteTitle": "¿Eliminar categoría?",
    "catalog.deleteMsg": "Se eliminará \"{name}\" y todos sus productos.",
    "catalog.deleteConfirm": "Eliminar",
    "catalog.deleteProductTitle": "¿Eliminar producto?",
    "catalog.deleteProductMsg": "Se eliminará este producto del catálogo.",
    "catalog.deleteProductConfirm": "Eliminar",

    // ─── Product Modal ───
    "product.edit": "✏️ Editar Producto",
    "product.new": "✨ Nuevo Producto",
    "product.tabBasic": "Básico",
    "product.tabLangs": "Idiomas",
    "product.tabTags": "Tags",
    "product.tabExtras": "Extras",
    "product.image": "Imagen del Producto",
    "product.uploadImage": "Subir imagen",
    "product.dropHint": "o arrastrala aquí",
    "product.dropActive": "Soltá para subir",
    "product.uploading": "Subiendo...",
    "product.imgFormats": "PNG, JPG (máx 800px)",
    "product.name": "Nombre ({lang}) *",
    "product.namePlaceholder": "Ej: Hamburguesa Clásica",
    "product.desc": "Descripción ({lang})",
    "product.descPlaceholder": "Descripción del producto...",
    "product.prices": "Precios ({symbol})",
    "product.enabled": "Producto Habilitado",
    "product.enabledDesc": "Visible en el menú público",
    "product.noLangs": "No hay idiomas adicionales configurados",
    "product.noLangsDesc": "Agregá idiomas en la sección General",
    "product.translate": "🌐 Traducir",
    "product.translating": "⏳ Traduciendo...",
    "product.translateAll": "🌐 Traducir a todos los idiomas",
    "product.translatingAll": "⏳ Traduciendo a todos los idiomas...",
    "product.tags": "Tags",
    "product.customTag": "+ Tag personalizado",
    "product.allergens": "Alérgenos",
    "product.customAllergen": "+ Agregar Alérgeno",
    "product.modifiers": "Modificadores / Extras",
    "product.modifiersDesc": "Opciones adicionales para este producto (ej: extra queso, sin sal)",
    "product.addModifier": "+ Agregar Modificador",
    "product.modName": "Nombre ({lang})",
    "product.modPrice": "Precio",
    "product.save": "Guardar Cambios",
    "product.create": "Crear Producto",
    "product.cancel": "Cancelar",

    // ─── Predefined tags ───
    "tag.vegan": "🌱 Vegano",
    "tag.vegetarian": "🥬 Vegetariano",
    "tag.glutenFree": "🌾 Sin TACC",
    "tag.popular": "🔥 Popular",
    "tag.new": "✨ Nuevo",
    "tag.spicy": "🌶️ Picante",
    "tag.recommended": "⭐ Recomendado",
    "tag.noMeat": "🐟 Sin Carne",
    "tag.nutFree": "🥜 Sin Frutos Secos",
    "tag.organic": "🍃 Orgánico",

    // ─── Category Modal ───
    "category.edit": "✏️ Editar Categoría",
    "category.new": "📂 Nueva Categoría",
    "category.newSub": "📂 Nueva Sub-categoría",
    "category.name": "Nombre de la Categoría *",
    "category.descLabel": "Descripción (Opcional)",
    "category.descPlaceholder": "Descripción breve de esta categoría...",
    "category.priceTypes": "💲 Tipos de Precio",
    "category.priceTypesAdd": "+ Agregar",
    "category.priceTypesDesc": "Ej: \"Chica\", \"Mediana\", \"Grande\" para bebidas.",
    "category.priceTypePlaceholder": "Nombre del tipo de precio",
    "category.status": "Estado de la Categoría",
    "category.statusDesc": "Las pausadas no se muestran en el menú",
    "category.schedule": "🕐 Franja Horaria",
    "category.scheduleDesc": "Si está activo, esta categoría solo se muestra durante el horario configurado.",
    "category.scheduleFrom": "Desde",
    "category.scheduleTo": "Hasta",
    "category.addRange": "+ Agregar franja",
    "category.save": "Guardar Cambios",
    "category.create": "Crear Categoría",
    "category.cancel": "Cancelar",
    "category.translate": "🌐 Traducir",
    "category.translating": "⏳ Traduciendo...",
    "category.nameRequired": "El nombre en {lang} es obligatorio",
    "category.minPriceType": "Debe haber al menos un tipo de precio",
    "category.maxPriceType": "Máximo 4 tipos de precios permitidos",
    "category.namePlaceholder": "Ej: Entradas, Platos Principales...",
    "category.priceDefault": "Precio",
    "category.priceNew": "Nuevo Tipo",
    "category.deletePriceType": "Eliminar tipo de precio",
    "modules.dailyTitleDefault": "Plato del Día",
    "modules.announcementCta": "¡Entendido!",
    "bulkPrice.simple": "Simple",
    "bulkPrice.doble": "Doble",
    "bulkPrice.variante": "Variante",
    "bulkPrice.noName": "Producto sin nombre",
    "bulkPrice.errorApply": "Ocurrió un error al aplicar los cambios: {error}",
    "bulkPrice.errorPreview": "Error al generar vista previa: {error}",
    "bulkPrice.exPercent": "Ej: 10",
    "bulkPrice.exFixed": "Ej: 500",

    // ─── Modules Section ───
    "modules.title": "Módulos",
    "modules.desc": "Activa funcionalidades extras para tu menú digital",
    "modules.daily": "🍽️ Platos del Día",
    "modules.dailyDesc": "Destaca platos especiales en la parte superior de tu menú",
    "modules.dailyTitle": "Título de la sección",
    "modules.dailyTitlePlaceholder": "🍽️ Platos del Día",
    "modules.dailyDescLabel": "Descripción (opcional)",
    "modules.dailyDescPlaceholder": "Ej: Disponible solo hoy",
    "modules.displayStyle": "Estilo de visualización",
    "modules.styleBanner": "Banner",
    "modules.styleCard": "Tarjeta",
    "modules.styleHighlight": "Resaltado",
    "modules.selectedItems": "Platos seleccionados ({count})",
    "modules.noItemsYet": "No hay platos seleccionados aún",
    "modules.noItemsDesc": "Seleccioná productos del catálogo o creá uno personalizado",
    "modules.itemNoName": "Sin nombre",
    "modules.itemNamePlaceholder": "Nombre del plato",
    "modules.originalPrice": "Precio original: ",
    "modules.customItem": "Plato personalizado",
    "modules.price": "Precio",
    "modules.specialPrice": "Precio especial",
    "modules.activateItem": "Activar plato",
    "modules.pauseItem": "Pausar plato (no se mostrará)",
    "modules.itemHidden": "🚫 Oculto",
    "modules.itemDescPlaceholder": "Descripción (opcional)",
    "modules.itemUploading": "⏳ Subiendo...",
    "modules.itemPhoto": "📸 Foto",
    "modules.deletedProduct": "Producto eliminado",
    "modules.uploadError": "Error al subir la imagen. Intentá nuevamente.",

    // Daily specials creator
    "modules.createCustom": "🍽️ Crear plato personalizado",
    "modules.newCustomItem": "Nuevo plato personalizado",
    "modules.customNamePlaceholder": "Nombre del plato",
    "modules.customPricePlaceholder": "Precio",
    "modules.customDescPlaceholder": "Descripción (opcional)",
    "modules.customAdd": "Agregar",
    "modules.customCancel": "Cancelar",

    // Product selector
    "modules.selectProduct": "Seleccionar producto del catálogo",
    "modules.addFromCatalog": "⭐ Agregar plato del catálogo",
    "modules.searchCatalogPlaceholder": "🔍 Buscar en tu catálogo...",
    "modules.searchProducts": "Buscar productos...",
    "modules.noResults": "No se encontraron coincidencias",
    "modules.noResultsFor": "No hay resultados para \"{term}\"",
    "modules.noCatalogProducts": "No hay productos en el catálogo",
    "modules.noCatalogProductsDesc": "Creá uno nuevo o agregá productos en Catálogo",
    "modules.createNew": "+ Crear producto nuevo",
    "modules.selectorCancel": "Cancelar",
    "modules.addProductsFirst": "⚠️ Primero agrega productos en la sección Catálogo",
    "modules.annTimeTo": "a",

    // Announcements
    "modules.announcements": "📢 Anuncios",
    "modules.announcementsDesc": "Popup que aparece al abrir el menú con novedades o promos",
    "modules.annTitle": "Título del anuncio",
    "modules.annTitlePlaceholder": "Ej: ¡Novedad! 🎉",
    "modules.annMessage": "Mensaje",
    "modules.annMsgPlaceholder": "Escribe el mensaje que verán tus clientes...",
    "modules.annImage": "Imagen del anuncio",
    "modules.annDeleteImage": "✕ Eliminar",
    "modules.annUploading": "Subiendo imagen...",
    "modules.annClickUpload": "Click para subir imagen",
    "modules.annImgFormats": "PNG, JPG (máx 1000px)",
    "modules.annCtaText": "Texto del botón",
    "modules.annCtaPlaceholder": "¡Entendido!",
    "modules.annCtaUrl": "URL del botón (opcional)",
    "modules.annBgColor": "Color de fondo",
    "modules.annAccentColor": "Color de acento (botón)",
    "modules.annShowOnce": "Mostrar solo una vez por sesión",
    "modules.annShowOnceDesc": "Si está activo, el popup solo aparece la primera vez que abren el menú",
    "modules.annSchedule": "🕐 Franja Horaria",
    "modules.annScheduleDesc": "Mostrar el anuncio solo durante ciertos horarios",
    "modules.annAddRange": "+ Agregar franja",
    "modules.annPreview": "👁️ Vista previa del anuncio",
    "modules.annPreviewLabel": "Así verán tus clientes el anuncio",
    "modules.annNoTitle": "Sin título",
    "modules.annClose": "Cerrar",

    // ─── Preview Section ───
    "preview.title": "Vista Previa",
    "preview.mobile": "Móvil",
    "preview.desktop": "Desktop",
    "preview.viewMenu": "👁️ Ver Menú",
    "preview.notAvailable": "Vista previa no disponible",
    "preview.saveFirst": "Guardá el menú para generar la vista previa",
    "preview.updateHint": "ℹ️ La vista previa se actualiza al guardar cambios",

    // ─── Confirm Dialog ───
    "confirm.default": "Confirmar",
    "confirm.cancel": "Cancelar",
    "confirm.noPricesTitle": "Sin precios definidos",
    "confirm.noPricesMsg": "No has definido precios para este producto. ¿Deseas continuar de todas formas?",
    "confirm.continue": "Continuar",

    // ─── Catalog tooltips ───
    "catalog.dragReorder": "Arrastrar para reordenar",
    "catalog.drag": "Arrastrar",

    // ─── Product Modal extra labels ───
    "product.transName": "Nombre",
    "product.transDesc": "Descripción",
    "product.transNamePh": "Nombre del producto...",
    "product.transDescPh": "Descripción...",
    "product.quickTags": "Tags rápidos",
    "product.customTagPh": "Tag personalizado...",
    "product.allergenPh": "Nombre del alérgeno...",
    "product.modifierPh": "Nombre del extra...",
    "product.modExtraPh": "Ej: Extra queso ({lang})",

    // ─── Context toasts ───
    "toast.saveSuccess": "Menú guardado exitosamente",
    "toast.saveError": "Error al guardar el menú",
    "toast.translating": "Traduciendo a {lang}...",
    "toast.translateSuccess": "¡Traducción a {lang} completada!",
    "toast.translateError": "Error al traducir. Algunos campos pueden no haberse traducido.",
    "toast.cannotRemoveDefault": "No puedes eliminar el idioma por defecto",
    "toast.minOnePriceType": "Debe haber al menos un tipo de precio",

    // ═══════════════════════════════════════════
    //  NON-V2 APP STRINGS
    // ═══════════════════════════════════════════

    // ─── Navbar / Auth ───
    "navbar.brand": "RestaurAdmin",
    "navbar.home": "Inicio",
    "navbar.myAccount": "Mis Menús",
    "navbar.signOut": "Cerrar Sesión",
    "navbar.signIn": "Iniciar Sesión",
    "navbar.auth.emptyFields": "Por favor, completa todos los campos",
    "navbar.auth.genericError": "Error al iniciar sesión. Intenta nuevamente.",
    "navbar.auth.userNotFound": "No existe una cuenta con este correo electrónico.",
    "navbar.auth.wrongPassword": "Contraseña incorrecta. Verifica e intenta de nuevo.",
    "navbar.auth.invalidEmail": "El correo electrónico no es válido.",
    "navbar.auth.tooManyRequests": "Demasiados intentos fallidos. Intenta más tarde.",
    "navbar.auth.invalidCredential": "Credenciales inválidas. Verifica e intenta de nuevo.",
    "navbar.auth.emailLabel": "Correo electrónico",
    "navbar.auth.emailPlaceholder": "Ingresa tu correo",
    "navbar.auth.passwordLabel": "Contraseña",
    "navbar.auth.passwordPlaceholder": "Ingresa tu contraseña",
    "navbar.auth.showPassword": "Mostrar contraseña",
    "navbar.auth.hidePassword": "Ocultar contraseña",
    "navbar.auth.cancel": "Cancelar",
    "navbar.auth.signingIn": "Iniciando sesión...",

    // ─── Home / Landing ───
    "home.trustBadge": "Usado por +200 restaurantes",
    "home.weekBadge": "{count} restaurantes crearon su menú esta semana",
    "home.hero.title": "Tu Menú Digital ",
    "home.hero.titleHighlight": "Listo en 24hs",
    "home.hero.subtitle1": "Sin imprentas. Sin errores. Sin límites.",
    "home.hero.subtitle2": "Actualizá precios, platos y fotos desde tu celular",
    "home.hero.benefit1": "QR personalizado para tu negocio",
    "home.hero.benefit2": "Menú en varios idiomas incluido",
    "home.hero.benefit3": "Soporte técnico cuando lo necesites",
    "home.hero.statValue": "+30%",
    "home.hero.statLabel": "Ventas promedio",
    "home.hero.ctaButton": "Crear Mi Menú Ahora",
    "home.hero.ctaInfo": "⚡ Sin tarjeta de crédito • Configuración en minutos",
    "home.testimonials.badge": "+200 Clientes Satisfechos",
    "home.testimonials.viewTestimonial": "Ver testimonio de {author}",
    "home.testimonials.title": "Historias Reales de Éxito",
    "home.testimonials.subtitle": "Restaurantes que confiaron en nosotros y aumentaron sus ventas",
    "home.features.title": "Todo lo que necesitás en un solo lugar",
    "home.features.photos": "Fotos ilimitadas",
    "home.features.instantUpdate": "Actualización instantánea",
    "home.features.multiLanguage": "Multi-idioma",
    "home.features.customQr": "QR personalizado",
    "home.features.support": "Soporte 24/7",
    "home.features.editor": "Editor intuitivo",
    "home.finalCta.title": "¿Listo para modernizar tu restaurante?",
    "home.finalCta.subtitle": "Unite a los +200 restaurantes que ya digitalizaron su menú y aumentaron sus ventas",
    "home.finalCta.benefit1": "Setup en 24hs",
    "home.finalCta.benefit2": "Sin costos ocultos",
    "home.finalCta.benefit3": "Cancelá cuando quieras",
    "home.finalCta.button": "Crear Mi Menú Digital Ahora",
    "home.finalCta.guarantee": "Garantía 100% sin riesgo - Si no te gusta en los primeros 7 días, te devolvemos tu dinero",
    "home.footer.title": "¿Tenés dudas? Hablemos",
    "home.footer.subtitle": "Respondemos todas tus preguntas en menos de 2 horas",
    "home.footer.contactButton": "Hablar con el Equipo",
    "home.whatsapp.tooltip": "¿Necesitás ayuda? Escribinos",
    "home.whatsapp.message": "¡Hola! Quiero crear mi menú digital",

    // ─── Client Carousel ───
    "clientCarousel.badge": "MENÚS DIGITALES EN ACCIÓN",
    "clientCarousel.title": "¡Cientos de restaurantes confían en nosotros!",
    "clientCarousel.subtitle": "Descubrí cómo transformamos sus negocios",
    "clientCarousel.viewMenu": "Ver Menú",
    "clientCarousel.goToPage": "Ir a página {page}",
    "clientCarousel.previous": "Anterior",
    "clientCarousel.next": "Siguiente",
    "clientCarousel.ctaText": "¿Te gustaría tener un menú como estos?",
    "clientCarousel.ctaButton": "Crear Mi Menú Digital",

    // ─── Contact Modal ───
    "contact.success.title": "¡Mensaje Enviado! 🎉",
    "contact.success.message": "Gracias por tu interés. Nos pondremos en contacto contigo muy pronto para ayudarte a crear tu menú digital personalizado.",
    "contact.success.button": "Perfecto",
    "contact.close": "Cerrar",
    "contact.form.title": "¡Creemos Tu Menú Digital Juntos! 🚀",
    "contact.form.subtitle": "Dejanos tus datos y te contactaremos para ayudarte a transformar tu negocio con un menú digital profesional",
    "contact.form.nameLabel": "Tu Nombre",
    "contact.form.namePlaceholder": "Ej: Juan Pérez",
    "contact.form.phoneLabel": "WhatsApp / Teléfono",
    "contact.form.phonePlaceholder": "Ej: +54 9 11 1234-5678",
    "contact.form.emailLabel": "Email",
    "contact.form.emailPlaceholder": "tu@email.com",
    "contact.form.businessLabel": "Nombre de tu Negocio",
    "contact.form.businessPlaceholder": "Ej: Restaurante La Esquina",
    "contact.form.messageLabel": "Contanos qué necesitás",
    "contact.form.messagePlaceholder": "Ej: Quiero un menú digital para mi restaurante con 50 productos...",
    "contact.benefits.title": "✨ Lo que obtendrás:",
    "contact.benefits.item1": "✅ Menú digital profesional y personalizado",
    "contact.benefits.item2": "✅ QR descargable para imprimir",
    "contact.benefits.item3": "✅ Actualización ilimitada desde tu panel",
    "contact.benefits.item4": "✅ Soporte técnico incluido",
    "contact.form.sending": "Enviando...",
    "contact.form.submitButton": "Enviar Consulta",

    // ─── Profile ───
    "profile.sectionHeader": "Tus Menús",
    "profile.categories": "Categorías",
    "profile.products": "Productos",
    "profile.lastUpdate": "Última actualización: ",
    "profile.viewMenu": "Ver Menú",
    "profile.editMenu": "Editar Menú",
    "profile.qrCode": "Código QR",
    "profile.deleteMenu": "Eliminar Menú",
    "profile.print": "Imprimir",
    "profile.createNewMenu": "Crear Nuevo Menú",
    "profile.emptyState": "No tienes menús disponibles.",
    "profile.menuType.complete": "Completo",
    "profile.menuType.standard": "Estándar",
    "profile.menuType.basic": "Básico",
    "profile.dateNotAvailable": "No disponible",
    "profile.deleteModal.title": "Confirmar Eliminación",
    "profile.deleteModal.message": "¿Estás seguro de que quieres eliminar este menú? Perderás toda la información.",
    "profile.deleteModal.passwordLabel": "Ingresa tu contraseña para confirmar:",
    "profile.deleteModal.passwordPlaceholder": "Contraseña",
    "profile.deleteModal.verifying": "Verificando...",
    "profile.toast.menuExists": "Ya existe un menú con ese nombre. Por favor, elige otro nombre.",
    "profile.toast.menuCreatedSuccess": "Menú creado exitosamente. Recargando...",
    "profile.toast.htmlError": "Error al crear el archivo HTML.",
    "profile.toast.jsonError": "Error al crear el archivo JSON.",
    "profile.toast.menuV2CreatedSuccess": "✨ Menú V2 creado exitosamente. Redirigiendo al editor...",
    "profile.toast.enterPassword": "Ingresa tu contraseña para confirmar",
    "profile.toast.menuDeleted": "Menú eliminado exitosamente. Recargando...",
    "profile.toast.wrongPassword": "Contraseña incorrecta",
    "profile.toast.deleteError": "Error al eliminar el menú",
    "profile.prompt.menuName": "Ingresa el nombre de tu menú:",
    "profile.subtitle.one": "Tu menú. Tocá para entrar.",
    "profile.subtitle.many": "{count} menús. Elegí uno para gestionarlo.",

    // ─── Menu Dashboard ───
    "menuDashboard.eyebrow": "Menú",
    "menuDashboard.back": "Mis menús",
    "menuDashboard.qrButton": "Código QR",
    "menuDashboard.viewPublic": "Ver menú público",
    "menuDashboard.sectionTitle": "¿Qué querés hacer?",
    "menuDashboard.feature.edit.title": "Editar menú digital",
    "menuDashboard.feature.edit.desc": "Agregar o modificar categorías, platos, precios y fotos.",
    "menuDashboard.feature.pdf.title": "PDF para imprimir",
    "menuDashboard.feature.pdf.desc": "Descargá tu menú como PDF listo para imprimir.",
    "menuDashboard.feature.pdf.badge": "Nuevo",
    "menuDashboard.feature.costs.title": "Costos y ganancia",
    "menuDashboard.feature.costs.desc": "Calculá cuánto te cuesta hacer cada plato y cuánto te queda de ganancia.",
    "menuDashboard.feature.costsStock.desc": "Cuánto te deja cada plato y cuánto te queda de cada insumo.",
    "menuDashboard.feature.reservations.title": "Reservas",
    "menuDashboard.feature.reservations.desc": "Recibí reservas desde tu menú y gestionalas acá.",
    "menuDashboard.feature.reservations.badge": "Nuevo",
    "menuDashboard.comingSoon": "Próximamente",
    "menuDashboard.feature.online.title": "Pedidos online",
    "menuDashboard.feature.online.desc": "Tu link para pedir, el envío y los pagos: prendé tu tienda.",

    // ─── Reservations feature ───
    "reservations.title": "Reservas",
    "reservations.subtitle": "Gestioná las reservas de tu local",
    "reservations.back": "Volver",
    "reservations.loading": "Cargando...",
    "reservations.empty.title": "Activá las reservas en 1 minuto",
    "reservations.empty.desc": "Tus clientes van a poder reservar mesa desde tu menú digital. Vos recibís el pedido por WhatsApp y confirmás con un toque.",
    "reservations.empty.step1": "Poné tu número de WhatsApp",
    "reservations.empty.step1Desc": "Acá te van a llegar las reservas",
    "reservations.empty.step2": "Dibujá tus mesas (opcional)",
    "reservations.empty.step2Desc": "Para que el cliente vea dónde se sienta",
    "reservations.empty.step3": "Definí turnos (opcional)",
    "reservations.empty.step3Desc": "Horarios disponibles por día",
    "reservations.empty.cta": "Empezar",
    "reservations.setup.title": "Configuración inicial",
    "reservations.setup.waLabel": "Número de WhatsApp del local",
    "reservations.setup.waPlaceholder": "Ej: 11 1234-5678",
    "reservations.setup.waHelp": "Acá te van a llegar las reservas de tus clientes. Poné tu número con código de área (sin el 0 ni el 15) — le agregamos el +54 9 solos.",
    "reservations.setup.save": "Guardar y continuar",
    "reservations.setup.saving": "Guardando...",
    "reservations.setup.invalidPhone": "Revisá el número: necesitamos código de área + número (ej: 11 5746-3566). No pongas el 0 ni el 15.",
    "reservations.setup.savedTitle": "¡Listo!",
    "reservations.setup.savedDesc": "Ya podés empezar a recibir reservas. Te recomendamos dibujar tus mesas para una mejor experiencia.",
    "reservations.month.today": "Hoy",
    "reservations.month.weekdays": "Lun,Mar,Mié,Jue,Vie,Sáb,Dom",
    "reservations.month.months": "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
    "reservations.month.empty": "Todavía no hay reservas este mes.",
    "reservations.month.shareLink": "Compartí este link con tus clientes:",
    "reservations.month.shareLinkNotReady": "Tu link de reservas se va a generar cuando tu menú tenga un slug público asignado en /admin. Avisanos para configurarlo.",

    // ─── Claim slug self-service ───
    "reservations.claim.title": "Elegí tu link de reservas",
    "reservations.claim.desc": "Tu local todavía no tiene un link público. Elegí un nombre corto y memorable.",
    "reservations.claim.placeholder": "mi-restaurante",
    "reservations.claim.claim": "Crear link",
    "reservations.claim.creating": "Creando...",
    "reservations.claim.checking": "Verificando disponibilidad...",
    "reservations.claim.available": "Disponible, podés usarlo.",
    "reservations.claim.taken": "Ese link ya está tomado. Probá con otro.",
    "reservations.claim.invalidFormat": "Solo letras minúsculas, números y guiones. Entre 3 y 30 caracteres.",
    "reservations.claim.checkError": "No pudimos verificar. Probá de nuevo.",
    "reservations.claim.createError": "No pudimos crear el link. Intentá más tarde.",
    "reservations.claim.claimedToast": "Link creado.",
    "reservations.claim.rules": "Reglas del link",
    "reservations.claim.rule1": "Solo letras minúsculas, números y guiones.",
    "reservations.claim.rule2": "Entre 3 y 30 caracteres.",
    "reservations.claim.rule3": "Una vez creado no se puede cambiar (pedinos ayuda si te equivocaste).",
    "reservations.month.copyLink": "Copiar link",
    "reservations.month.linkCopied": "¡Link copiado!",
    "reservations.legend.pending": "Pendientes",
    "reservations.legend.confirmed": "Confirmadas",
    "reservations.legend.full": "Lleno",
    "reservations.placeholder.calendarTitle": "Tu calendario de reservas",
    "reservations.placeholder.calendarDesc": "Acá vas a ver todas las reservas de cada día. Tocá cualquier día para ver el detalle.",
    "reservations.placeholder.mapTitle": "Próximamente: dibujá tu salón",
    "reservations.placeholder.mapDesc": "Vas a poder dibujar tus mesas con drag-and-drop y subir fotos por zona. Tu cliente las ve antes de reservar.",
    "reservations.placeholder.turnsTitle": "Próximamente: turnos por día",
    "reservations.placeholder.turnsDesc": "Configurá qué días aceptás reservas y a qué horarios. Días que no atendés se desactivan solos.",

    // ─── Editor de mapa ───
    "reservations.editor.cta": "Dibujar mis mesas",
    "reservations.editor.ctaDesc": "Dibujá tu salón. Tus clientes van a poder elegir mesa al reservar.",
    "reservations.editor.title": "Editor de mesas",
    "reservations.editor.subtitle": "Arrastrá las mesas para acomodarlas",
    "reservations.editor.toolRect": "Mesa",
    "reservations.editor.toolCircle": "Redonda",
    "reservations.editor.toolLarge": "Larga",
    "reservations.editor.toolArea": "Sector",
    "reservations.editor.toolWall": "Pared",
    "reservations.editor.toolLabel": "Texto",
    "reservations.editor.toolPhoto": "Foto",
    "reservations.editor.tapToSelect": "Tocá una mesa para editarla",
    "reservations.editor.itemTable": "Mesa",
    "reservations.editor.itemLabel": "Texto",
    "reservations.editor.itemPhoto": "Foto",
    "reservations.editor.itemWall": "Pared",
    "reservations.editor.itemArea": "Sector",
    "reservations.editor.areaName": "Nombre del sector",
    "reservations.editor.areaNamePlaceholder": "Salón, Terraza, Barra...",
    "reservations.editor.zoomIn": "Acercar",
    "reservations.editor.zoomOut": "Alejar",
    "reservations.editor.zoomFit": "Centrar el plano",
    "reservations.editor.drawWallsHint": "Modo paredes: tocá las esquinas, arrastrá para moverte.",
    "reservations.editor.drawWallsStart": "Tocá la primera esquina de la pared.",
    "reservations.editor.drawWallsNext": "Tocá la próxima esquina · {n} tramos",
    "reservations.editor.number": "Número de mesa",
    "reservations.editor.numberPlaceholder": "1, 2, B3...",
    "reservations.editor.label": "Nombre o zona",
    "reservations.editor.labelPlaceholder": "Ventana, Patio, Barra...",
    "reservations.editor.seats": "Personas",
    "reservations.editor.minSeats": "Mínimo de personas",
    "reservations.editor.minSeatsHint": "El cliente no puede reservar esta mesa para menos personas que esto. 0 = sin mínimo (ej: una mesa de 4 con mínimo 3 no se reserva para 1).",
    "reservations.editor.rotation": "Rotación",
    "reservations.editor.rotate90": "Rotar 90°",
    "reservations.editor.width": "Ancho",
    "reservations.editor.height": "Alto",
    "reservations.editor.diameter": "Diámetro",
    "reservations.editor.wallLength": "Largo",
    "reservations.editor.wallThickness": "Espesor",
    "reservations.editor.text": "Texto",
    "reservations.editor.textPlaceholder": "VENTANA",
    "reservations.editor.size": "Tamaño",
    "reservations.editor.photo": "Foto (opcional)",
    "reservations.editor.uploadPhoto": "Subir foto",
    "reservations.editor.uploading": "Subiendo...",
    "reservations.editor.uploadError": "No se pudo subir la foto.",
    "reservations.editor.caption": "Descripción",
    "reservations.editor.captionPlaceholder": "Vista desde el frente...",
    "reservations.editor.delete": "Eliminar",
    "reservations.editor.deleteItem": "Eliminar {item}",
    "reservations.editor.hintEmpty": "Tocá una herramienta para agregar mesas.",
    "reservations.editor.hintSelected": "Arrastrá para mover. Editá las propiedades a la derecha.",
    "reservations.editor.save": "Guardar mapa",
    "reservations.editor.saving": "Guardando...",
    "reservations.editor.undo": "Deshacer",
    "reservations.editor.redo": "Rehacer",
    "reservations.editor.duplicate": "Duplicar",
    "reservations.editor.unsaved": "Cambios sin guardar",
    "reservations.editor.allSaved": "Todo guardado",
    "reservations.editor.savedToast": "Mapa guardado",
    "reservations.editor.saveError": "No se pudo guardar el mapa.",
    "reservations.editor.overrideSubtitle": "Mapa especial para el {date}",
    "reservations.editor.overrideActive": "Este día usa un mapa personalizado.",
    "reservations.editor.overrideStartHint": "Editá las mesas. Los cambios solo se aplican a este día.",
    "reservations.editor.emptyState": "Tocá una herramienta para agregar tu primera mesa.",
    "reservations.dayView.emptyTitle": "Sin reservas todavía",
    "reservations.dayView.emptyDesc": "Compartí tu link de reservas en tus redes para empezar a recibir.",
    "reservations.editor.revertToBase": "Volver al mapa base",
    "reservations.editor.revertConfirm": "¿Borrar el mapa personalizado y volver al base?",
    "reservations.editor.revertedToast": "Volvió al mapa base.",
    "reservations.dayView.editMapForDay": "Editar mapa para hoy",

    // ─── Config screen ───
    "reservations.config.cta": "Turnos y horarios",
    "reservations.config.ctaDesc": "Definí qué días aceptás reservas, fechas bloqueadas y mensajes automáticos.",
    "reservations.config.title": "Configuración",
    "reservations.config.subtitle": "Turnos, fechas bloqueadas y mensajes.",
    "reservations.config.nameTitle": "Nombre del local",
    "reservations.config.nameHint": "Se muestra como título en la página donde reservan tus clientes.",
    "reservations.config.namePlaceholder": "Ej: La Parrilla de Don Juan",
    "reservations.config.waTitle": "📱 WhatsApp del local",
    "reservations.config.waHint": "Acá llegan las reservas que te mandan tus clientes. Poné tu número con código de área (sin el 0 ni el 15) — le agregamos el +54 9 solos.",
    "reservations.config.modeTitle": "Modo de reserva",
    "reservations.config.modeHint": "Elegí cómo aceptás reservas.",
    "reservations.config.modeFree": "Horario libre",
    "reservations.config.modeFreeDesc": "El cliente elige cualquier hora dentro de tus horarios de atención.",
    "reservations.config.modeTurns": "Por turnos",
    "reservations.config.modeTurnsDesc": "Definís turnos específicos (ej: 20-22 y 22:30-00:30). El cliente elige un turno.",
    "reservations.config.presetsTitle": "Plantillas rápidas",
    "reservations.config.presetsHint": "Empezá con una plantilla y ajustá lo que quieras.",
    "reservations.config.presetNone": "Sin turnos",
    "reservations.config.presetWeekendDinner": "Cena vie/sáb/dom",
    "reservations.config.presetDinnerEveryday": "Cena todos los días",
    "reservations.config.presetLunchDinner": "Almuerzo y cena",
    "reservations.config.daysTitle": "Días y turnos",
    "reservations.config.daysHint": "Activá los días que aceptás reservas. Tocá cada uno para definir sus turnos.",
    "reservations.config.openHoursTitle": "Días y horarios de atención",
    "reservations.config.openHoursHint": "Activá los días que abrís. Tus clientes solo van a poder elegir horas dentro de estos rangos.",
    "reservations.config.addTurn": "Agregar turno",
    "reservations.config.addRange": "Agregar rango",
    "reservations.config.removeTurn": "Eliminar turno",
    "reservations.config.blockedTitle": "📅 Fechas bloqueadas",
    "reservations.config.blockedHint": "Feriados, días que no atendés, eventos privados. No se aceptan reservas estos días.",
    "reservations.config.blockDate": "Bloquear",
    "reservations.config.blockedEmpty": "Sin fechas bloqueadas.",
    "reservations.config.unblock": "Desbloquear",
    "reservations.config.specialOpenTitle": "🗓️ Días especiales que SÍ abrís",
    "reservations.config.specialOpenHint": "Feriados u otras fechas sueltas donde abrís aunque no sea tu día habitual. Se podrán reservar con el horario que pongas.",
    "reservations.config.specialOpenAdd": "Agregar día",
    "reservations.config.specialOpenEmpty": "Sin días especiales. Agregá un feriado para abrir reservas ese día.",
    "reservations.config.specialOpenRemove": "Quitar",
    "reservations.config.specialOpenBeyondWindow": "Está más allá de tu ventana de reservas ({days} días): se va a poder reservar recién cuando se acerque la fecha.",
    "reservations.config.messagesTitle": "💬 Plantillas de mensaje",
    "reservations.config.messagesHint": "Cuando confirmes o rechaces una reserva se abre WhatsApp con estos mensajes pre-armados (siempre editables antes de mandar).",
    "reservations.config.variables": "Variables disponibles:",
    "reservations.config.tplConfirm": "Confirmar reserva",
    "reservations.config.tplConfirmHint": "Se manda cuando aceptás una reserva.",
    "reservations.config.tplReject": "Rechazar reserva",
    "reservations.config.tplRejectHint": "Cuando no podés tomarla.",
    "reservations.config.tplChange": "Cambio de mesa",
    "reservations.config.tplChangeHint": "Cuando confirmás pero le asignás otra mesa.",
    "reservations.config.tplReminder": "Recordatorio",
    "reservations.config.tplReminderHint": "El mensaje del botón 🔔 Recordar (el mismo día de la reserva).",
    "reservations.config.save": "Guardar configuración",
    "reservations.config.savedToast": "Configuración guardada",
    "reservations.config.saveError": "No se pudo guardar.",

    // ─── Public booking page ───
    "reservations.booking.title": "Reservá tu mesa",
    "reservations.booking.step1": "Elegí la fecha",
    "reservations.booking.step2": "Elegí el horario",
    "reservations.booking.step4": "Elegí tu mesa (opcional)",
    "reservations.booking.step4Hint": "Tocá una mesa para pedirla. Si no, el local te asigna una.",
    "reservations.booking.step5": "Tus datos",
    "reservations.booking.people": "¿Cuántos son?",
    "reservations.booking.personSingular": "persona",
    "reservations.booking.personPlural": "personas",
    "reservations.booking.yourName": "Tu nombre",
    "reservations.booking.yourNamePh": "Juan Pérez",
    "reservations.booking.yourPhone": "Tu WhatsApp",
    "reservations.booking.yourPhonePh": "11 3456 7890",
    "reservations.booking.notes": "Notas (opcional)",
    "reservations.booking.notesPh": "Cumpleaños, alergias, preferencia indoor/outdoor...",
    "reservations.booking.submitCta": "Reservar por WhatsApp",
    "reservations.booking.submitHint": "Se abre WhatsApp con tu pedido pre-armado. Mandalo al restaurante y esperá la confirmación.",
    "reservations.booking.sending": "Enviando...",
    "reservations.booking.submitError": "No pudimos guardar tu reserva. Probá de nuevo.",
    "reservations.booking.tableTakenError": "Esa mesa la acaban de reservar. Elegí otra y volvé a intentar.",
    "reservations.booking.duplicateError": "Ya tenés una reserva para ese día con este teléfono. Si querés cambiarla, escribinos por WhatsApp.",
    "reservations.booking.missingTime": "Falta: elegí un horario",
    "reservations.booking.missingZone": "Falta: elegí una zona",
    "reservations.booking.missingName": "Falta: tu nombre",
    "reservations.booking.missingPhone": "Falta: tu teléfono (WhatsApp)",
    "reservations.booking.phoneTooShort": "El teléfono parece incompleto",
    "reservations.booking.outOfHoursError": "El horario que elegiste está fuera del horario de atención. Mirá los horarios del día.",
    "reservations.booking.tooSoonError": "Ese horario es demasiado pronto. Elegí uno con más anticipación.",
    "reservations.booking.dateChangedError": "Cambió el día. Volvé a elegir la fecha y el horario.",
    "reservations.booking.noTurns": "No hay turnos disponibles para este día.",
    "reservations.booking.freeTimeLabel": "Elegí la hora",
    "reservations.booking.endsAt": "Te quedás hasta las {time}",
    "reservations.booking.openHours": "Horario de atención",
    "reservations.booking.legendAvailable": "Disponible",
    "reservations.booking.legendReserved": "Reservada",
    "reservations.booking.legendPending": "Pendiente",
    "reservations.booking.legendTooSmall": "Muy chica",
    "reservations.booking.notFoundTitle": "Restaurante no encontrado",
    "reservations.booking.notFoundDesc": "Verificá que el link sea correcto.",
    "reservations.booking.notReadyTitle": "Reservas no disponibles",
    "reservations.booking.notReadyDesc": "Este restaurante aún no activó las reservas online. Probá contactarlo directo por sus redes.",
    "reservations.booking.sentTitle": "Solicitud enviada",
    "reservations.booking.sentDesc": "Tu reserva todavía NO está confirmada. Mandá el mensaje por WhatsApp y el restaurante te la confirma por ahí.",
    "reservations.booking.sentHint": "Vas a recibir la confirmación por el mismo WhatsApp cuando el restaurante te responda.",
    "reservations.booking.openWhatsApp": "📲 Abrir WhatsApp",
    "reservations.booking.bookAnother": "Hacer otra reserva",

    // ─── Day view (owner) ───
    "reservations.dayView.pending": "pendientes",
    "reservations.dayView.confirmed": "confirmadas",
    "reservations.dayView.empty": "Sin reservas para este día.",
    "reservations.dayView.mapTitle": "Mapa del día",
    "reservations.dayView.pendingTitle": "Pendientes",
    "reservations.dayView.confirmedTitle": "Confirmadas",
    "reservations.dayView.rejectedTitle": "Rechazadas",
    "reservations.dayView.cancelledTitle": "Canceladas",
    "reservations.dayView.status_pending": "Pendiente",
    "reservations.dayView.status_confirmed": "Confirmada",
    "reservations.dayView.status_rejected": "Rechazada",
    "reservations.dayView.status_cancelled": "Cancelada",
    "reservations.dayView.status_expired": "Expirada",
    "reservations.dayView.confirm": "Confirmar",
    "reservations.dayView.changeTable": "Cambiar mesa",
    "reservations.dayView.reject": "Rechazar",
    "reservations.dayView.openWa": "WhatsApp",
    "reservations.dayView.resendConfirm": "Re-enviar confirmación",
    "reservations.dayView.requestedTable": "Pidió: {name}",
    "reservations.dayView.assignedTable": "Asignada: {name}",
    "reservations.dayView.rejectConfirm": "¿Rechazar esta reserva? Vas a poder mandarle un mensaje al cliente.",
    "reservations.dayView.cancelBooking": "Cancelar reserva",
    "reservations.dayView.cancelBookingConfirm": "¿Cancelar esta reserva? La mesa va a quedar libre para que otro cliente pueda reservarla.",
    "reservations.dayView.cancelledToast": "Reserva cancelada. La mesa quedó libre.",
    "reservations.dayView.confirmedToast": "Reserva confirmada. Se abre WhatsApp.",
    "reservations.dayView.rejectedToast": "Reserva rechazada. Se abre WhatsApp.",
    "reservations.dayView.confirmedNoWaToast": "Reserva confirmada. (No se abrió WhatsApp porque la plantilla está vacía.)",
    "reservations.dayView.rejectedNoWaToast": "Reserva rechazada. (No se abrió WhatsApp porque la plantilla está vacía.)",
    "reservations.dayView.invalidPhoneToast": "Acción guardada, pero el teléfono del cliente no es válido — no pude abrir WhatsApp.",
    "reservations.dayView.assignedTableMissing": "Mesa asignada eliminada del plano (era: {name})",

    "reservations.dayView.arrivedTitle": "Llegaron",
    "reservations.dayView.noShowTitle": "No vinieron",
    "reservations.dayView.status_arrived": "Llegó",
    "reservations.dayView.status_no_show": "No vino",
    "reservations.dayView.markArrived": "Llegó",
    "reservations.dayView.markNoShow": "No vino",
    "reservations.dayView.noShowConfirm": "¿Marcar esta reserva como que no vino? La mesa queda libre.",
    "reservations.dayView.arrivedToast": "Marcada como llegada.",
    "reservations.dayView.noShowToast": "Marcada como no vino. La mesa queda libre.",
    "reservations.dayView.edit": "Editar",
    "reservations.dayView.editedToast": "Reserva actualizada.",
    "reservations.dayView.newManualBooking": "Nueva reserva manual",
    "reservations.dayView.manualCreatedToast": "Reserva creada.",
    "reservations.dayView.blockTable": "Bloquear mesa",
    "reservations.dayView.blockedToast": "Mesa bloqueada para este horario.",
    "reservations.dayView.sendReminder": "Recordar",
    "reservations.dayView.defaultReminder": "¡Hola {name}! Te recuerdo tu reserva para el {date} a las {time}. ¡Te esperamos!",
    "reservations.dayView.pastNoShowWarn": "Este teléfono faltó {count} vez/veces antes",

    "reservations.dashboard.notifEnabledToast": "Notificaciones activadas",
    "reservations.dashboard.notifEnableThis": "Activar avisos de este restaurante en este celular",
    "reservations.dashboard.notifOnThis": "Avisos de este restaurante activados",
    "reservations.dashboard.notifOnHint": "Tocá para dejar de recibirlos en este celular",
    "reservations.dashboard.notifBlocked": "Avisos bloqueados — activalos en los ajustes del navegador",
    "reservations.dashboard.notifDisabledToast": "Avisos desactivados en este celular",
    "reservations.dashboard.notifLegacyOffToast": "Listo. Este celular ya no recibe avisos de todos tus restaurantes — activá los que quieras.",
    "reservations.dashboard.searchPh": "Buscar por nombre o teléfono...",
    "reservations.dashboard.upcomingTitle": "Próximas reservas",
    "reservations.dashboard.searchEmpty": "No encontramos reservas con eso.",

    "reservations.manualBooking.createTitle": "Nueva reserva manual",
    "reservations.manualBooking.editTitle": "Editar reserva",
    "reservations.manualBooking.name": "Nombre",
    "reservations.manualBooking.namePh": "Nombre del cliente",
    "reservations.manualBooking.phone": "Teléfono (opcional)",
    "reservations.manualBooking.phonePh": "+54 11 ...",
    "reservations.manualBooking.people": "Personas",
    "reservations.manualBooking.turn": "Turno",
    "reservations.manualBooking.time": "Hora",
    "reservations.manualBooking.table": "Mesa (opcional)",
    "reservations.manualBooking.noTable": "Sin mesa asignada",
    "reservations.manualBooking.notes": "Notas",
    "reservations.manualBooking.cancel": "Cancelar",
    "reservations.manualBooking.create": "Crear reserva",
    "reservations.manualBooking.saveEdit": "Guardar cambios",
    "reservations.manualBooking.errorName": "Falta el nombre.",
    "reservations.manualBooking.errorTime": "Falta el horario.",
    "reservations.manualBooking.outsideHoursWarn": "El horario está fuera del horario abierto. ¿Crear igual?",
    "reservations.manualBooking.tableOccupied": "ocupada",

    "reservations.blockTable.title": "Bloquear mesa",
    "reservations.blockTable.hint": "Usá esto cuando una mesa no puede ser reservada por algún motivo (evento privado, refacción, etc).",
    "reservations.blockTable.table": "Mesa",
    "reservations.blockTable.from": "Desde",
    "reservations.blockTable.to": "Hasta",
    "reservations.blockTable.reason": "Motivo (opcional)",
    "reservations.blockTable.reasonPh": "Ej: evento privado",
    "reservations.blockTable.confirm": "Bloquear",
    "reservations.blockTable.errorTable": "Elegí una mesa.",
    "reservations.blockTable.errorTime": "Faltan los horarios.",
    "reservations.blockTable.errorTimeOrder": "El horario de fin tiene que ser después del de inicio.",
    "reservations.blockTable.errorTableTaken": "Esa mesa tiene una reserva en ese horario. Elegí otra.",
    "reservations.blockTable.tapTableHint": "Tocá una mesa libre en el mapa para bloquearla",

    "reservations.stats.cta": "Estadísticas",
    "reservations.stats.ctaDesc": "Mirá cuántas reservas tuviste, no-shows y mesas más usadas.",
    "reservations.stats.title": "Estadísticas",
    "reservations.stats.subtitle": "Resumen del mes que estás mirando.",
    "reservations.stats.confirmed": "Confirmadas",
    "reservations.stats.arrived": "Llegaron",
    "reservations.stats.pending": "Pendientes",
    "reservations.stats.noShow": "No vinieron",
    "reservations.stats.cancelled": "Canceladas",
    "reservations.stats.rejected": "Rechazadas",
    "reservations.stats.noShowRateTitle": "Tasa de no-show",
    "reservations.stats.noShowRateHint": "De las que se cerraron (llegaron + no vinieron), cuántas no vinieron.",
    "reservations.stats.perDayTitle": "Reservas por día",
    "reservations.stats.topTablesTitle": "Mesas más reservadas",
    "reservations.stats.topZonesTitle": "Zonas más usadas",
    "reservations.stats.covers": "Cubiertos",
    "reservations.stats.empty": "Todavía no hay reservas este mes.",
    "reservations.dayView.actionError": "No se pudo actualizar. Probá de nuevo.",
    "reservations.dayView.assignTitle": "Elegí la mesa",
    "reservations.dayView.assignHint": "Tocá la mesa que querés asignarle al cliente.",
    "reservations.dayView.assignConfirm": "Asignar y confirmar",
    "reservations.dayView.cancel": "Cancelar",
    "reservations.dayView.legendSelected": "Seleccionada",
    "reservations.dayView.legendOccupied": "Ocupada",

    "menuDashboard.qrModal.title": "Código QR del menú",
    "menuDashboard.qrModal.hint": "Los clientes escanean este código y abren tu menú.",
    "menuDashboard.error": "No pudimos cargar este menú.",
    "menuDashboard.errorBack": "Volver a mis menús",

    // ─── Print PDF (wizard) ───
    "printPdf.back": "Volver",
    "printPdf.title": "PDF para imprimir",
    "printPdf.subtitle": "Diseñá tu menú de papel y descargalo.",
    "printPdf.loading": "Cargando datos del menú...",
    "printPdf.loadError": "No pudimos cargar el menú.",
    "printPdf.stepper.step": "Paso {current} de {total}",
    "printPdf.stepper.1": "Diseño",
    "printPdf.stepper.2": "Tema",
    "printPdf.stepper.3": "Contenido",
    "printPdf.stepper.4": "Formato",
    "printPdf.nav.previous": "Anterior",
    "printPdf.nav.next": "Siguiente",
    "printPdf.nav.finish": "Listo",
    "printPdf.nav.togglePreview": "Ver vista previa",
    "printPdf.nav.hidePreview": "Ocultar vista previa",
    "printPdf.cta.download": "Descargar PDF",
    "printPdf.cta.openPdf": "📄 Abrir / descargar PDF",
    "printPdf.cta.pdfReadyHint": "Si no empezó la descarga, tocá acá para abrir el PDF.",
    "printPdf.cta.loadingTitle": "Generando tu PDF…",
    "printPdf.cta.loadingHint": "Puede tardar unos segundos. La descarga arranca sola.",
    "printPdf.cta.generating": "Generando...",
    "printPdf.cta.save": "Guardar diseño",
    "printPdf.cta.saved": "Diseño guardado",
    "printPdf.cta.saving": "Guardando...",
    "printPdf.cta.reset": "Restablecer al diseño base",
    "printPdf.step1.title": "Elegí un diseño base",
    "printPdf.step1.subtitle": "El diseño define el estilo general. Después lo personalizás.",
    "printPdf.templates.classic.name": "Clásico",
    "printPdf.templates.classic.desc": "Elegante, serif, aire generoso",
    "printPdf.templates.modern.name": "Moderno",
    "printPdf.templates.modern.desc": "Minimalista, tipografía limpia",
    "printPdf.templates.familiar.name": "Familiar",
    "printPdf.templates.familiar.desc": "Cálido, legible, platos destacados",
    "printPdf.templates.chalkboard.name": "Pizarrón",
    "printPdf.templates.chalkboard.desc": "Fondo oscuro, look bar",
    "printPdf.templates.fine.name": "Fine dining",
    "printPdf.templates.fine.desc": "Serif delicado, mucho espacio",
    "printPdf.step2.title": "Tema",
    "printPdf.step2.subtitle": "Elegí fondo, colores y tamaño de texto.",
    "printPdf.step2.background": "Fondo",
    "printPdf.step2.backgroundPresets": "Fondos predefinidos",
    "printPdf.step2.backgroundUpload": "Subir mi propio fondo",
    "printPdf.step2.backgroundUploadHint": "JPG o PNG. Tu foto aparece como fondo del menú.",
    "printPdf.step2.backgroundNone": "Sin fondo",
    "printPdf.step2.backgroundOpacity": "Opacidad del fondo",
    "printPdf.step2.backgroundOverlay": "Recuadro claro detrás de cada plato",
    "printPdf.step2.backgroundOverlayHint": "Ayuda a leer el texto sobre fondos con imagen.",
    "printPdf.step2.colors": "Colores del texto",
    "printPdf.step2.colorTitles": "Títulos",
    "printPdf.step2.colorProducts": "Nombres de plato",
    "printPdf.step2.colorPrices": "Precios",
    "printPdf.step2.colorDescriptions": "Descripciones",
    "printPdf.step2.fontFamily": "Tipografía",
    "printPdf.step2.fontDefault": "Según el diseño elegido",
    "printPdf.step2.fontPreview": "Aa — Carta del restaurante",
    "printPdf.step2.textSize": "Tamaño del texto",
    "printPdf.step2.textSize.sm": "Chico",
    "printPdf.step2.textSize.md": "Normal",
    "printPdf.step2.textSize.lg": "Grande",
    "printPdf.step2.logo": "Logo del local",
    "printPdf.step2.logoUpload": "Subir logo",
    "printPdf.step2.logoRemove": "Quitar logo",
    "printPdf.step3.title": "Contenido",
    "printPdf.step3.subtitle": "Elegí qué mostrar en el PDF.",
    "printPdf.step3.showCover": "Portada con logo y nombre",
    "printPdf.step3.showDescriptions": "Descripciones de platos",
    "printPdf.step3.showPhotos": "Fotos de platos (si el menú las tiene)",
    "printPdf.step3.showAllergens": "Etiquetas (sin TACC, vegano...)",
    "printPdf.step3.showRestaurantInfo": "Datos del local al final",
    "printPdf.step3.showQr": "Código QR al final",
    "printPdf.step3.itemBox": "Recuadro detrás de cada plato",
    "printPdf.step3.itemBoxHint": "Encierra cada plato en una caja suave para separarlos mejor.",
    "printPdf.step4.title": "Formato",
    "printPdf.step4.subtitle": "Tamaño de papel y orientación.",
    "printPdf.step4.paperSize": "Tamaño de papel",
    "printPdf.step4.paper.a4": "A4",
    "printPdf.step4.paper.a5": "A5",
    "printPdf.step4.paper.letter": "Carta",
    "printPdf.step4.paper.halfLetter": "Media carta",
    "printPdf.step4.orientation": "Orientación",
    "printPdf.step4.orientation.portrait": "Vertical",
    "printPdf.step4.orientation.landscape": "Horizontal",
    "printPdf.step4.columns": "Columnas",
    "printPdf.step4.columns.one": "Una",
    "printPdf.step4.columns.two": "Dos",
    "printPdf.step4.columns.three": "Tres",
    "printPdf.stepper.5": "Textos",
    "printPdf.step5.title": "Editá los textos",
    "printPdf.step5.subtitle": "Cambiá nombres, descripciones o agregá notas — solo para este PDF, sin tocar tu menú digital.",
    "printPdf.step5.hintTitle": "Tip:",
    "printPdf.step5.hintBody": "Dejá el campo vacío para mantener el texto original. Podés usar saltos de línea (Enter) en descripciones y notas.",
    "printPdf.step5.categoryName": "Nombre de la categoría",
    "printPdf.step5.categoryDescription": "Descripción de la categoría",
    "printPdf.step5.categoryDescriptionPlaceholder": "Ej: Ideales para compartir antes del plato principal",
    "printPdf.step5.keepTogether": "Mantener unida (no partir entre páginas)",
    "printPdf.step5.pageBreakBefore": "Empezar en página nueva",
    "printPdf.step5.productName": "Nombre del producto",
    "printPdf.step5.productDescription": "Descripción",
    "printPdf.step5.productDescriptionPlaceholder": "Escribí una descripción",
    "printPdf.step5.products": "productos",
    "printPdf.step5.empty": "No hay categorías ni productos en el menú.",
    "printPdf.preview.title": "Vista previa",
    "printPdf.preview.generating": "Generando vista previa...",
    "printPdf.preview.refresh": "Actualizar vista previa",
    "printPdf.preview.mobileHint": "Tocá para ver la vista previa",
    "printPdf.toast.uploadError": "No pudimos subir la imagen.",
    "printPdf.toast.downloadError": "No pudimos generar el PDF. Intentá de nuevo.",
    "printPdf.toast.saveError": "No pudimos guardar el diseño.",
    "printPdf.toast.savedSuccess": "Diseño guardado.",
    "printPdfOutput.menu": "Menú",
    "printPdfOutput.allergens.sinTacc": "Sin TACC",
    "printPdfOutput.allergens.veg": "Vegetariano",
    "printPdfOutput.allergens.vegan": "Vegano",
    "printPdfOutput.scanQr": "Escaneá el QR para ver la versión digital",
    "printPdfOutput.findUs": "Encontranos",

    // ─── Menu Editor (V1) ───
    "menuEditor.recovery.title": "⚠️ Cambios sin guardar",
    "menuEditor.recovery.message": "Se encontraron cambios sin guardar en este menú. ¿Deseas recuperarlos y continuar editando?",
    "menuEditor.recovery.disclaimer": "Si eliges \"Descartar\", se perderán todos los cambios no guardados.",
    "menuEditor.recovery.discard": "Descartar cambios",
    "menuEditor.recovery.recover": "Recuperar y continuar",
    "menuEditor.viewMenu": "Ver Menú",
    "menuEditor.editPrices": "Editar Precios",
    "menuEditor.editAvailability": "Pausar Platos",
    "menuEditor.updateMenu": "Actualizar Menú",
    "menuEditor.addCategory": "Categoria",

    // ─── Global Price Editor ───
    "globalPrice.title": "Editor Global de Precios",
    "globalPrice.searchPlaceholder": "Buscar producto...",
    "globalPrice.allCategories": "Todas ({count})",
    "globalPrice.hideBulk": "Ocultar",
    "globalPrice.showBulk": "Operaciones en masa",
    "globalPrice.bulkPanel.title": "Aplicar cambio a todos los productos mostrados",
    "globalPrice.bulkPanel.noProducts": "No hay productos para aplicar cambios",
    "globalPrice.bulkPanel.productsCount": "Cambios se aplicarán a {count} producto(s) visible(s)",
    "globalPrice.bulk.percentage": "Porcentaje (%)",
    "globalPrice.bulk.fixedAmount": "Monto fijo ($)",
    "globalPrice.bulk.increase": "Aumentar",
    "globalPrice.bulk.decrease": "Disminuir",
    "globalPrice.bulk.valuePlaceholder": "Valor",
    "globalPrice.bulk.apply": "Aplicar",
    "globalPrice.noProductsFiltered": "No se encontraron productos con los filtros aplicados",
    "globalPrice.noProductsInMenu": "No hay productos con precios en el menú",
    "globalPrice.table.product": "Producto",
    "globalPrice.table.category": "Categoría",
    "globalPrice.table.priceType": "Tipo Precio",
    "globalPrice.table.currentPrice": "Precio Actual",
    "globalPrice.table.newPrice": "Precio Nuevo",
    "globalPrice.noName": "Sin nombre",
    "globalPrice.pricesCount": "precios",
    "globalPrice.unsavedChanges": "Tienes {count} cambio(s) sin guardar",
    "globalPrice.modifiedCount": "{count} precio(s) modificado(s)",
    "globalPrice.cancel": "Cancelar",
    "globalPrice.saveChanges": "Guardar cambios",
    "globalPrice.discardConfirm": "¿Descartar todos los cambios sin guardar?",
    "globalPrice.toast.noProducts": "No hay productos para aplicar cambios",
    "globalPrice.toast.invalidValue": "Ingresa un valor válido mayor a cero",
    "globalPrice.toast.bulkApplied": "✅ Se aplicaron {count} cambios de precio. Revisa y presiona \"Guardar cambios\".",

    // ─── Global Availability Editor ───
    "availability.title": "Pausar / Activar Platos",
    "availability.searchPlaceholder": "Buscar plato...",
    "availability.allCategories": "Todas las categorías ({count})",
    "availability.filterAll": "Todos",
    "availability.filterActive": "Activos",
    "availability.filterPaused": "Pausados",
    "availability.selectedCount": "{count} seleccionado(s)",
    "availability.activateSelected": "Activar seleccionados",
    "availability.pauseSelected": "Pausar seleccionados",
    "availability.noProductsFiltered": "No se encontraron platos con los filtros aplicados",
    "availability.noProductsInMenu": "No hay platos en el menú",
    "availability.colProduct": "Plato",
    "availability.colCategory": "Categoría",
    "availability.colStatus": "Estado",
    "availability.colToggle": "Acción",
    "availability.noName": "Sin nombre",
    "availability.statusActive": "Activo",
    "availability.statusPaused": "Pausado",
    "availability.toggleActive": "Activo",
    "availability.togglePaused": "Pausado",
    "availability.pendingChanges": "{count} cambio(s) pendiente(s) de guardar",
    "availability.modifiedCount": "{count} plato(s) modificado(s)",
    "availability.pauseAll": "Pausar todos",
    "availability.activateAll": "Activar todos",
    "availability.cancel": "Cancelar",
    "availability.saveChanges": "Guardar cambios",
    "availability.discardConfirm": "¿Descartar los cambios de disponibilidad sin guardar?",

    // ─── Category Editor ───
    "catEditor.unnamed": "Categoria sin nombre aún",
    "catEditor.paused": " (PAUSADA)",
    "catEditor.addProduct": "Producto",
    "catEditor.addSubCategory": "Sub-categoría",
    "catEditor.deleteCategory": "Eliminar Categoría",
    "catEditor.deleteSubcategory": "Eliminar Subcategoría",
    "catEditor.deleteConfirmTitle": "Confirmar Eliminación",
    "catEditor.deleteConfirmMessage": "¿Estás seguro de que deseas eliminar esta categoría y todos sus productos?",
    "catEditor.activate": "Activar",
    "catEditor.activateTitle": "Activar categoría",
    "catEditor.pause": "Pausar",
    "catEditor.pauseTitle": "Pausar categoría",

    // ─── Product Editor ───
    "productEditor.unnamed": "Plato sin nombre aún",
    "productEditor.tabInfo": "Información",
    "productEditor.tabImage": "Imagen",
    "productEditor.tabPrices": "Precios",
    "productEditor.spanish": "Español",
    "productEditor.english": "Inglés",
    "productEditor.name": "Nombre",
    "productEditor.namePlaceholderEs": "Nombre en español",
    "productEditor.namePlaceholderEn": "Nombre en inglés",
    "productEditor.description": "Descripción",
    "productEditor.descPlaceholderEs": "Descripción en español",
    "productEditor.descPlaceholderEn": "Descripción en inglés",
    "productEditor.translateFailed": "No se pudo traducir. Probá de nuevo en un minuto.",
    "productEditor.translateToEnglish": "Traducir al inglés",
    "productEditor.specialTags": "Etiquetas Especiales",
    "productEditor.tagVegan": "🌱 Vegano",
    "productEditor.tagGlutenFree": "🌾 Sin TACC",
    "productEditor.tagsHelp": "Estas etiquetas aparecerán junto al nombre del producto en el menú",
    "productEditor.pricesTitle": "Precios del producto",
    "productEditor.noPrices": "No hay precios definidos",
    "productEditor.noPricesHelp": "Añade al menos un precio para que tu producto aparezca en el menú.",
    "productEditor.activate": "Activar",
    "productEditor.pause": "Pausar",
    "productEditor.delete": "Eliminar",
    "productEditor.deleteConfirmTitle": "Confirmar Eliminación",
    "productEditor.deleteConfirmMessage": "¿Estás seguro de que deseas eliminar este producto?",

    // ─── Image Editor ───
    "imageEditor.previewAlt": "Vista previa de la imagen",
    "imageEditor.noImageAlt": "No hay imagen disponible",
    "imageEditor.upload": "Subir imagen",
    "imageEditor.view": "Ver imagen",
    "imageEditor.delete": "Eliminar",
    "imageEditor.uploading": "CARGANDO IMAGEN ...",
    "imageEditor.previewTitle": "Vista Previa de la Imagen",
    "imageEditor.close": "Cerrar",
    "imageEditor.deleteConfirmTitle": "Confirmar Eliminación",
    "imageEditor.deleteConfirmMessage": "¿Estás seguro de que deseas eliminar esta imagen?",
    "imageEditor.cancel": "Cancelar",

    // ─── Price Types ───
    "priceTypes.title": "Tipos de precios",
    "priceTypes.placeholder": "Ej. Simple, Doble, Triple",
    "priceTypes.deleteAriaLabel": "Eliminar tipo de precio",
    "priceTypes.tip": "Ingresa un nombre descriptivo para cada tipo de precio (Ej. Simple, Doble, Triple).",
    "priceTypes.add": "Agregar tipo de precio",

    // ─── Bulk Price Updater ───
    "bulkPrice.title": "Actualización masiva de precios",
    "bulkPrice.noProducts": "No hay productos con precios para actualizar.",
    "bulkPrice.typeLabel": "Tipo de actualización",
    "bulkPrice.percentage": "Porcentaje (%)",
    "bulkPrice.fixedAmount": "Monto fijo ($)",
    "bulkPrice.operationLabel": "Operación",
    "bulkPrice.increase": "Aumentar",
    "bulkPrice.decrease": "Disminuir",
    "bulkPrice.operationHelp": "Selecciona si quieres aumentar o disminuir los precios.",
    "bulkPrice.valueLabel.percentage": "Porcentaje a aplicar",
    "bulkPrice.valueLabel.fixedAmount": "Monto a aplicar",
    "bulkPrice.valueHelp.percentage": "Ingrese el porcentaje sin el símbolo %",
    "bulkPrice.valueHelp.fixedAmount": "Ingrese el monto sin el símbolo $",
    "bulkPrice.previewTitle": "Vista previa de cambios ({count} productos)",
    "bulkPrice.table.product": "Producto",
    "bulkPrice.table.priceType": "Tipo de precio",
    "bulkPrice.table.currentPrice": "Precio actual",
    "bulkPrice.table.newPrice": "Nuevo precio",
    "bulkPrice.noPreview": "No hay productos con precios para actualizar o el valor ingresado no es válido.",
    "bulkPrice.cancel": "Cancelar",
    "bulkPrice.applying": "Aplicando...",
    "bulkPrice.apply": "Aplicar cambios",
    "bulkPrice.error.invalidValue": "Por favor ingrese un valor válido mayor a cero",
    "bulkPrice.error.noChanges": "No hay cambios para aplicar",
    "bulkPrice.noProductName": "Producto sin nombre",
    "bulkPrice.variantFallback": "Variante",

    // ─── Info Editor ───
    "infoEditor.nameLabel": "Nombre",
    "infoEditor.namePlaceholder": "Agrega un nombre",
    "infoEditor.descriptionLabel": "Descripción",
    "infoEditor.descriptionPlaceholder": "Agrega una descripción",
    "infoEditor.translateToEnglish": "Traducir al inglés",

    // ─── QR Code ───
    "qr.title": "Código QR - {name}",
    "qr.quantityLabel": "Cantidad de códigos QR por hoja:",
    "qr.count1": "1 código QR",
    "qr.count4": "4 códigos QR",
    "qr.count6": "6 códigos QR",
    "qr.count9": "9 códigos QR",
    "qr.count12": "12 códigos QR",
    "qr.print": "Imprimir QR",
    "qr.download": "Descargar QR",
    "qr.close": "Cerrar",

    // ─── Custom Modal ───
    "modal.cancel": "Cancelar",
    "modal.confirm": "Confirmar",

    // ─── Create Menu ───
    "createMenu.comingSoon": "Proximamente!",

    // ─── Testimonials ───
    "testimonials.slideLabel": "Ir a testimonial {index}",

    // ─── Context Provider (V1) ───
    "context.defaultPriceType": "Precio",
    "context.newPriceType": "Nuevo precio",
    "context.toast.maxPriceTypes": "Máximo 5 tipos de precios permitidos",
    "context.toast.minPriceTypes": "Debe mantener al menos un tipo de precio configurado",
    "context.toast.saveSuccess": "Tu menú se ha guardado exitosamente en el servidor",
    "context.toast.saveError": "No se pudo guardar el menú. Verifica tu conexión e intenta nuevamente.",
    "context.toast.menuNotFound": "El archivo del menú no existe en el servidor. Crea uno nuevo desde la lista.",
    "context.alert.menuFileNotFound": "No se encontró el archivo del menú. Vuelve a la lista e intenta crearlo nuevamente o espera unos segundos y recarga.",
    "context.error.invalidImage": "El archivo seleccionado no es una imagen admitida.",

    // ─── Constants ───
    "constants.spanish": "Español",
    "constants.english": "Inglés",
    "constants.price": "Precio",
    "constants.simple": "Simple",
    "constants.double": "Doble",
    "constants.small": "Chica",
    "constants.medium": "Mediana",
    "constants.large": "Grande",

    // ─── Home (landing page) ───
    "home.badge": "200+ menús creados",
    "home.hero.title1": "La carta digital",
    "home.hero.title2": "que tus clientes",
    "home.hero.title3": "van a amar",
    "home.hero.sub": "Creamos menús digitales premium para restaurantes en toda Argentina. QR, multi-idioma, fotos HD, actualización instantánea.",
    "home.hero.ctaPrimary": "Quiero mi carta",
    "home.hero.ctaGhost": "Ver ejemplos",
    "home.hero.scroll": "Scroll",

    "home.stats.menus": "Menús creados",
    "home.stats.provinces": "Provincias",
    "home.stats.years": "Años",
    "home.stats.google": "Google",

    "home.showcase.tag": "Portfolio",
    "home.showcase.title1": "Cartas reales,",
    "home.showcase.title2": "en vivo",
    "home.showcase.sub": "Cada teléfono muestra una carta real funcionando ahora mismo. Tocá cualquiera para explorarla.",
    "home.showcase.prev": "Anterior",
    "home.showcase.next": "Siguiente",

    "home.map.tag": "Cobertura",
    "home.map.title1": "De Jujuy a",
    "home.map.title2": "Tierra del Fuego",
    "home.map.sub": "{count} restaurantes en {provinces} provincias. Cada punto es un cliente real.",
    "home.map.restaurants": "{count} restaurantes",
    "home.map.viewMenu": "Ver carta",
    "home.map.filterAll": "Todos",

    "home.rubros.restoran": "Restoran",
    "home.rubros.parrilla": "Parrilla",
    "home.rubros.pizzeria": "Pizzería",
    "home.rubros.hamburgueseria": "Hamburguesería",
    "home.rubros.bar": "Bar",
    "home.rubros.sushi": "Sushi",
    "home.rubros.cafeteria": "Cafetería",
    "home.rubros.cerveceria": "Cervecería",
    "home.rubros.fastfood": "Fast Food",
    "home.rubros.wineBar": "Wine Bar",
    "home.rubros.italiana": "Italiana",
    "home.rubros.foodtruck": "Foodtruck",

    "home.proof.tag": "Reseñas",
    "home.proof.title1": "Lo que dicen",
    "home.proof.title2": "nuestros clientes",
    "home.proof.googleLink": "Ver reseñas en Google",
    "home.proof.testimonial1.text": "Excelente servicio, muy rápidos y atentos. La carta digital quedó increíble, mis clientes la aman.",
    "home.proof.testimonial1.author": "Pablo M.",
    "home.proof.testimonial1.place": "Encrucijada, Santa Fe",
    "home.proof.testimonial2.text": "Súper profesionales. Me armaron todo en el día y queda perfecto en el celular. Lo recomiendo 100%.",
    "home.proof.testimonial2.author": "Ornella F.",
    "home.proof.testimonial2.place": "La Pescería, Buenos Aires",
    "home.proof.testimonial3.text": "La mejor inversión para mi restaurante. Los clientes escanean el QR y tienen todo al instante.",
    "home.proof.testimonial3.author": "Carolina R.",
    "home.proof.testimonial3.place": "Hotel La María, Mendoza",

    "home.features.tag": "Producto",
    "home.features.title1": "Todo lo que",
    "home.features.title2": "necesitás",
    "home.features.photos.title": "Fotos HD",
    "home.features.photos.desc": "Cada plato con su mejor imagen",
    "home.features.update.title": "Actualización instantánea",
    "home.features.update.desc": "Cambiá precios y platos al momento",
    "home.features.multilang.title": "Multi-idioma",
    "home.features.multilang.desc": "Español, inglés y portugués",
    "home.features.qr.title": "QR personalizado",
    "home.features.qr.desc": "Con tu logo y colores",
    "home.features.fast.title": "Carga ultrarrápida",
    "home.features.fast.desc": "Menos de 1 segundo",
    "home.features.support.title": "Soporte dedicado",
    "home.features.support.desc": "Te ayudamos con todo",

    "home.contact.tag": "Contacto",
    "home.contact.title1": "Empezá",
    "home.contact.title2": "hoy",
    "home.contact.desc": "Completá el formulario y te contactamos en menos de 24hs con tu carta lista para revisar.",
    "home.contact.benefit1": "Diseño personalizado",
    "home.contact.benefit2": "Lista en 24-48 horas",
    "home.contact.benefit3": "QR listo para imprimir",
    "home.contact.benefit4": "Soporte permanente",
    "home.contact.success.title": "Mensaje enviado",
    "home.contact.success.desc": "Te contactamos pronto con tu carta lista.",
    "home.contact.step1": "Datos",
    "home.contact.step2": "Contacto",
    "home.contact.step3": "Mensaje",
    "home.contact.nameLabel": "Tu nombre",
    "home.contact.namePlaceholder": "Juan Pérez",
    "home.contact.businessLabel": "Nombre del negocio",
    "home.contact.businessPlaceholder": "Mi Restaurante",
    "home.contact.phoneLabel": "Teléfono",
    "home.contact.phonePlaceholder": "11 2345-6789",
    "home.contact.emailLabel": "Email",
    "home.contact.emailPlaceholder": "juan@email.com",
    "home.contact.messageLabel": "Mensaje (opcional)",
    "home.contact.messagePlaceholder": "Contanos sobre tu negocio...",
    "home.contact.back": "Atrás",
    "home.contact.next": "Siguiente",
    "home.contact.submit": "Enviar",
    "home.contact.submitting": "Enviando...",

    "home.footer.brandDesc": "Cartas digitales premium para restaurantes de toda Argentina.",
    "home.footer.product": "Producto",
    "home.footer.examples": "Ver ejemplos",
    "home.footer.contact": "Contacto",
    "home.footer.legal": "Legal",
    "home.footer.privacy": "Privacidad",
    "home.footer.terms": "Términos",
    "home.footer.dataDeletion": "Eliminación de datos",
    "home.footer.social": "Redes",

    "home.whatsapp.aria": "Contactar por WhatsApp",
    "home.whatsapp.text": "Hola! Me interesa una carta digital para mi restaurante",

    // ─── Costos y Margen ───
    "costs.title": "Costos y Ganancia",
    "costs.subtitle": "Cargá ingredientes y recetas para saber cuánto te cuesta hacer cada plato y cuánto te queda de ganancia.",
    "costs.back": "Volver al menú",
    "costs.tabs.dashboard": "Resumen",
    "costs.tabs.products": "Mis platos",
    "costs.tabs.ingredients": "Ingredientes",
    "costs.tabs.subRecipes": "Preparados",
    "costs.tabs.settings": "Ajustes",

    "costs.empty.title": "Empezá cargando ingredientes",
    "costs.empty.desc": "Agregá los ingredientes que usás en la cocina y después armá la receta de cada plato.",
    "costs.empty.cta": "Agregar primer ingrediente",

    // Onboarding (cuando no hay nada cargado)
    "costs.onboarding.title": "👋 Empezá en 3 pasos",
    "costs.onboarding.subtitle": "Te ayudamos a saber cuánto te cuesta hacer cada plato y cuánto te queda de ganancia. Es más fácil de lo que parece.",
    "costs.onboarding.step1Title": "Cargá tus ingredientes",
    "costs.onboarding.step1Desc": "Por ejemplo: harina, aceite, carne picada... y lo que cada uno te sale por kilo o por litro. Tenemos una lista de ingredientes típicos para que arranques rápido.",
    "costs.onboarding.step1Cta": "Cargar ingredientes",
    "costs.onboarding.step2Title": "Decí qué lleva cada plato",
    "costs.onboarding.step2Desc": "Para cada plato del menú, indicá qué ingredientes usa y cuánto. Por ejemplo: una hamburguesa lleva 180g de carne, 1 pan, 30g de queso.",
    "costs.onboarding.step2Cta": "Ir a mis platos",
    "costs.onboarding.step2Locked": "Primero cargá ingredientes",
    "costs.onboarding.step3Title": "Mirá cuánto te queda",
    "costs.onboarding.step3Desc": "Te mostramos cuánto te cuesta hacer cada plato, cuánto te queda de ganancia, y te avisamos si alguno te está dando pérdida.",
    "costs.onboarding.step3Locked": "Primero cargá los costos de tus platos",
    "costs.onboarding.simpleNote": "💡 ¿Querés ir más rápido? Podés saltarte los ingredientes y, en cada plato, cargar directamente lo que te sale aproximado.",

    "costs.dashboard.avgFc": "Costo promedio del plato",
    "costs.dashboard.avgMargin": "Ganancia promedio",
    "costs.dashboard.coverage": "{covered} de {total} platos con costo cargado",
    "costs.dashboard.coverageHint": "completar el resto",
    "costs.dashboard.topRentables": "Te dejan más ganancia",
    "costs.dashboard.bottomRentables": "Te dejan menos ganancia",
    "costs.dashboard.inDanger": "Casi sin ganancia o con pérdida",
    "costs.dashboard.noData": "Cargá algunas recetas para ver tu resumen",
    "costs.dashboard.noDanger": "Todos tus platos están dejando buena ganancia 👌",
    "costs.dashboard.alertsTitle": "Mirá estos platos",
    "costs.dashboard.alertEmpty": "Nada urgente por ahora",
    "costs.dashboard.recalcCta": "🔄 Actualizar precios de ingredientes",

    "costs.status.healthy": "Buena ganancia",
    "costs.status.warning": "Ganancia justa",
    "costs.status.danger": "Casi sin ganancia",
    "costs.status.unknown": "Sin datos",

    "costs.product.noCost": "Sin costo cargado",
    "costs.product.cargar": "Cargar costo",
    "costs.product.editCost": "Editar costo",
    "costs.product.deleteCost": "Quitar costo",
    "costs.product.foodCost": "Lo que te cuesta",
    "costs.product.foodCostShort": "Costo",
    "costs.product.margin": "Ganancia",
    "costs.product.suggested": "Precio sugerido",
    "costs.product.suggestedHint": "Para que el costo sea el {target}% del precio",
    "costs.product.byPrice": "Tu precio en la carta y lo que te queda",
    "costs.product.priceLabelSell": "Vendés a",
    "costs.product.priceLabelLeftover": "te queda",
    "costs.product.priceLabelMarginShort": "ganancia",
    "costs.product.youKeep": "ganás",
    "costs.product.searchPlaceholder": "Buscar plato...",
    "costs.product.filter.all": "Todos",
    "costs.product.filter.uncosted": "Sin costo",
    "costs.product.filter.danger": "En riesgo",
    "costs.product.sort.name": "Nombre",
    "costs.product.sort.foodCost": "% Costo",
    "costs.product.empty": "Este menú todavía no tiene platos. Agregalos desde el editor.",

    "costs.drawer.title": "Cargar costo: {productName}",
    "costs.drawer.intro": "Vamos a calcular cuánto te cuesta hacer este plato.",
    "costs.drawer.modeQuick": "Solo el costo total",
    "costs.drawer.modeQuickDesc": "Tirás un número aproximado y listo. Rápido pero no se actualiza solo cuando cambian los precios.",
    "costs.drawer.modeRecipe": "Detallar ingredientes",
    "costs.drawer.modeRecipeDesc": "Decís cuánto lleva cada ingrediente. Cuando suba un precio, todos los platos que lo usan se recalculan solos. Lo más útil con la inflación.",
    "costs.drawer.modeRecipeLocked": "🔒 Cargá ingredientes primero para usar este modo",
    "costs.drawer.modeChange": "Cambiar modo",
    "costs.drawer.quickHelp": "Tirá un número aproximado de cuánto te sale hacer una porción de este plato (ingredientes + gas + lo que sea).",
    "costs.drawer.quickLabel": "Cuánto te cuesta una porción",
    "costs.drawer.recipeHelp": "Para cada ingrediente decí cuánto lleva una porción. Por ejemplo: una hamburguesa lleva 180g de carne picada, 1 pan, 30g de queso.",
    "costs.drawer.recipeEmpty": "Empezá agregando un ingrediente abajo 👇",
    "costs.drawer.addIngredient": "+ Agregar ingrediente",
    "costs.drawer.addSubRecipe": "+ Agregar preparado",
    "costs.drawer.notes": "Notas (opcional)",
    "costs.drawer.notesPlaceholder": "Cualquier cosa que quieras anotar.",
    "costs.drawer.indirectOverride": "Otros gastos para este plato (luz, gas, sueldo)",
    "costs.drawer.indirectGlobal": "Por defecto se aplica {percent}% (ajustable en Ajustes)",
    "costs.drawer.indirectClear": "Volver al valor por defecto",
    "costs.drawer.save": "Guardar",
    "costs.drawer.cancel": "Cancelar",
    "costs.drawer.close": "Cerrar",
    "costs.drawer.summary": "Resumen",
    "costs.drawer.summaryDirect": "Ingredientes",
    "costs.drawer.summaryIndirect": "Otros gastos",
    "costs.drawer.summaryTotal": "Total: cuánto te cuesta hacerlo",

    "costs.recipeLine.helpHeader": "Ingrediente · Cuánto lleva · Desperdicio % (si pelás/cortás y se pierde algo)",
    "costs.recipeLine.amount": "Cantidad",
    "costs.recipeLine.unit": "Unidad",
    "costs.recipeLine.waste": "Desperdicio %",
    "costs.recipeLine.wasteHint": "Si al pelar/cortar se pierde algo. Ej: papas 10%, carne 5%. Si no, dejá 0.",
    "costs.recipeLine.remove": "Quitar",
    "costs.recipeLine.unitMismatch": "⚠️ La unidad no coincide con {ingredient}",
    "costs.recipeLine.pickIngredient": "Elegí un ingrediente",
    "costs.recipeLine.pickSubRecipe": "Elegí un preparado",
    "costs.recipeLine.cost": "Costo de la línea",

    "costs.library.title": "Biblioteca de ingredientes",
    "costs.library.subtitle": "Cargá una vez los ingredientes con su precio. Cuando suba un precio, lo cambiás acá y todos los platos que lo usan se actualizan solos.",
    "costs.library.add": "+ Agregar ingrediente",
    "costs.library.search": "Buscar ingrediente...",
    "costs.library.empty": "Todavía no cargaste ingredientes",
    "costs.library.emptyDesc": "La forma más rápida es elegir de la lista de ingredientes típicos de cocina argentina y solo cargar el precio.",
    "costs.library.fromPreset": "🇦🇷 Lista de ingredientes típicos",
    "costs.library.fromScratch": "Crear uno nuevo",
    "costs.library.importFromMenu": "Importar de otro menú",
    "costs.library.history": "Historial",
    "costs.library.lastUpdated": "Actualizado: {date}",
    "costs.library.usedIn": "Usado en {count}",
    "costs.library.notUsed": "Sin uso",

    "costs.ingredient.modal.titleNew": "Nuevo ingrediente",
    "costs.ingredient.modal.titleEdit": "Editar ingrediente",
    "costs.ingredient.modal.name": "Nombre",
    "costs.ingredient.modal.namePlaceholder": "Ej: Carne picada",
    "costs.ingredient.modal.cost": "Cuánto te sale",
    "costs.ingredient.modal.costHint": "Lo que pagás cuando lo comprás. Ej: $4500 el kilo.",
    "costs.ingredient.modal.unit": "Por qué unidad lo comprás",
    "costs.ingredient.modal.unitHint": "kg = kilo, g = gramos, lt = litro, ml = mililitros, u = unidad.",
    "costs.ingredient.modal.supplier": "Proveedor (opcional)",
    "costs.ingredient.modal.supplierPlaceholder": "Ej: Frigorífico X",
    "costs.ingredient.modal.save": "Guardar",
    "costs.ingredient.modal.cancel": "Cancelar",
    "costs.ingredient.modal.history": "Historial de precios",
    "costs.ingredient.modal.noHistory": "Sin cambios registrados todavía",

    "costs.ingredient.delete.title": "Borrar ingrediente",
    "costs.ingredient.delete.simple": "¿Borrar este ingrediente?",
    "costs.ingredient.delete.inUse": "Este ingrediente se usa en {count} lugares. Si lo borrás, se eliminará de todas las recetas que lo usan.",
    "costs.ingredient.delete.confirm": "Sí, borrar",
    "costs.ingredient.delete.forceConfirm": "Borrar igual",

    "costs.preset.title": "Presets de cocina argentina",
    "costs.preset.subtitle": "Tickeá los ingredientes que usás y solo cargá el precio.",
    "costs.preset.cat.meats": "Carnes y aves",
    "costs.preset.cat.fish": "Pescados",
    "costs.preset.cat.dairy": "Lácteos y huevos",
    "costs.preset.cat.veggies": "Verduras y frutas",
    "costs.preset.cat.pantry": "Almacén",
    "costs.preset.cat.oils": "Aceites y vinagres",
    "costs.preset.cat.canned": "Conservas",
    "costs.preset.cat.drinks": "Bebidas",
    "costs.preset.cat.bakery": "Panificados",
    "costs.preset.use": "Usar",
    "costs.preset.alreadyAdded": "Ya está en tu biblioteca",

    "costs.subRecipe.title": "Preparados base",
    "costs.subRecipe.subtitle": "Preparaciones que usás en varios platos (salsas, masas, marinados). Cargás los ingredientes una sola vez y después las usás en cada plato como si fueran un ingrediente más.",
    "costs.subRecipe.add": "+ Nuevo preparado",
    "costs.subRecipe.empty": "Todavía no tenés preparados",
    "costs.subRecipe.usedIn": "Se usa en {count} platos",
    "costs.subRecipe.modal.titleNew": "Nuevo preparado",
    "costs.subRecipe.modal.titleEdit": "Editar preparado",
    "costs.subRecipe.modal.name": "Nombre",
    "costs.subRecipe.modal.namePlaceholder": "Ej: Salsa bolognesa, Masa de pizza",
    "costs.subRecipe.modal.yield": "Cuánto rinde la receta",
    "costs.subRecipe.modal.yieldHint": "Cuánto sale en total. Ej: 2000 g de salsa, 1.5 lt de jugo, 12 unidades de masa.",
    "costs.subRecipe.modal.computed": "Te cuesta {cost} en total ({perUnit} por {unit})",
    "costs.subRecipe.modal.notComputed": "Cargá ingredientes para calcular el costo",

    "costs.massRecalc.title": "Actualizar precios de ingredientes",
    "costs.massRecalc.subtitle": "Si te subieron los precios, cambiá los nuevos costos acá. Todos los platos que usan esos ingredientes se recalculan automáticamente.",
    "costs.massRecalc.cta": "🔄 Actualizar precios",
    "costs.massRecalc.newCost": "Nuevo precio",
    "costs.massRecalc.unchanged": "Sin cambios",
    "costs.massRecalc.preview": "Vista previa",
    "costs.massRecalc.changesCount": "{count} ingredientes con nuevo precio",
    "costs.massRecalc.affectedProducts": "{count} platos se van a actualizar",
    "costs.massRecalc.crossDanger": "{count} platos pasan a tener problema",
    "costs.massRecalc.apply": "Aplicar cambios",
    "costs.massRecalc.cancel": "Cancelar",
    "costs.massRecalc.empty": "Todavía no cargaste ingredientes",

    "costs.settings.title": "Ajustes",
    "costs.settings.indirect": "Otros gastos por plato %",
    "costs.settings.indirectHint": "Porcentaje que sumamos por default al costo de cada plato para tener en cuenta gas, luz, sueldo. Lo típico: 15-20%.",
    "costs.settings.target": "Costo objetivo del plato %",
    "costs.settings.targetHint": "Cuánto querés que represente el costo dentro del precio de venta. Ideal: 28-35%. Te usamos esto para sugerirte precios.",
    "costs.settings.subRecipes": "Usar preparados base",
    "costs.settings.subRecipesHint": "Activalo si tenés salsas, masas o caldos que usás en varios platos. Si no, no hace falta.",
    "costs.settings.save": "Guardar ajustes",

    "costs.import.title": "Importar de otro menú",
    "costs.import.desc": "Trae los ingredientes (y opcionalmente sub-recetas) de otro de tus menús. Si ya tenés ingredientes con el mismo nombre, no los pisa.",
    "costs.import.menuLabel": "Menú origen",
    "costs.import.includeSub": "Incluir sub-recetas",
    "costs.import.btn": "Importar",
    "costs.import.cancel": "Cancelar",
    "costs.import.noOtherMenus": "No tenés otros menús con costos cargados.",

    "costs.currency.warningTitle": "Las monedas no coinciden",
    "costs.currency.warningDesc": "Tus costos están cargados en {costsCurrency} pero el menú está en {menuCurrency}. Revisá los valores manualmente.",

    "costs.toast.saved": "Guardado",
    "costs.toast.saveError": "Error al guardar",
    "costs.toast.imported": "Datos importados",
    "costs.toast.deleted": "Borrado",

    "costs.menuDashboard.title": "Costos y Ganancia",
    "costs.menuDashboard.desc": "Calculá cuánto te cuesta hacer cada plato, cuánto te queda de ganancia y qué precio te conviene cobrar.",
    "costs.menuDashboard.cta": "Abrir calculadora",
  },

  // ═══════════════════════════════════════════
  //  ENGLISH
  // ═══════════════════════════════════════════
  en: {
    "editor.loading": "Loading menu...",
    "editor.notFound": "Menu not found",
    "editor.backToProfile": "Back to Profile",
    "editor.brand": "RestaurAdmin",
    "editor.brandSub": "Editor V2",
    "editor.viewMenu": "View Menu",
    "editor.save": "🚀 Publish Menu",
    "editor.saveMobile": "🚀 Publish",
    "editor.saving": "⏳ Publishing...",
    "editor.unsaved": "● Unpublished changes",
    "editor.unsavedMobile": "● Unpublished",
    "editor.published": "✓ Published",

    "nav.general": "General",
    "nav.generalShort": "General",
    "nav.restaurant": "Restaurant Info",
    "nav.restaurantShort": "Info",
    "nav.catalog": "Catalog",
    "nav.catalogShort": "Catalog",
    "nav.modules": "Modules",
    "nav.modulesShort": "Modules",
    "nav.preview": "Preview",
    "nav.previewShort": "Preview",

    "general.languages": "🌐 Menu Languages",
    "general.languagesDesc": "Configure available languages. The default language is shown first to your customers.",
    "general.defaultLang": "Default Language",
    "general.additionalLangs": "Additional Languages",
    "general.addLang": "+ Add Language",
    "general.removeLangTitle": "Remove language?",
    "general.removeLangMsg": "The language {lang} and all its translations will be removed.",
    "general.removeLangConfirm": "Remove",
    "general.aboutLangs": "About languages",
    "general.aboutLangsDesc": "When adding a new language, you can automatically translate all existing content or fill in translations manually in each section.",
    "general.autoTranslateTitle": "Auto-translate?",
    "general.autoTranslateMsg": "You added \"{lang}\". Do you want to automatically translate all content?",
    "general.autoTranslateManual": "I'll translate manually",
    "general.autoTranslateAuto": "✨ Translate all",
    "general.autoTranslating": "⏳ Translating...",
    "general.currency": "Currency",
    "general.timezone": "🕐 Timezone",
    "general.timezoneDesc": "Set your restaurant's timezone. Used to show or hide categories based on schedule (time slots).",
    "general.timezoneLabel": "Restaurant Timezone",
    "general.fonts": "🔤 Fonts",
    "general.fontsDesc": "Use the arrows to browse and preview each font live.",
    "general.fontHeading": "HEADING FONT",
    "general.fontHeadingPreview": "Appetizers · Main Courses",
    "general.fontBody": "BODY FONT",
    "general.fontBodyPreview": "Classic burger with cheddar cheese, lettuce and tomato.",

    "general.colors": "🎨 Menu Colors",
    "general.colorsDesc": "Customize the background, typography, and cover colors of your menu.",
    "general.colorReset": "Reset",

    "general.themeAccent": "ACCENT",
    "general.themeAccentReset": "↩ Reset",
    "general.themeAdvanced": "ADVANCED SETTINGS",
    "general.themeAdvancedClearAll": "Clear all",
    "general.themeAdvancedHint": "Override individual colors on top of the base theme. The ↩ button restores the theme default.",
    "general.themeGroupBody": "Menu body",
    "general.themeGroupHero": "Cover / Hero",
    "general.tokenBg": "Background",
    "general.tokenSurface": "Cards / Surfaces",
    "general.tokenText": "Main text",
    "general.tokenTextSec": "Secondary text",
    "general.tokenTextMuted": "Muted text",
    "general.tokenBorder": "Borders",
    "general.tokenDivider": "Product divider",
    "general.tokenHeaderBg": "Cover background",
    "general.tokenHeaderText": "Cover text",
    "general.previewHeroSub": "Cover",
    "general.previewCat1": "Starters",
    "general.previewCat2": "Mains",
    "general.previewProduct": "Classic burger",
    "general.previewProductDesc": "With cheddar cheese, lettuce and tomato.",
    "general.previewAllergens": "(V) (G)",
    "general.previewHoursLabel": "🕐 Hours",
    "general.previewHoursDay": "● Monday",
    "general.previewHoursTime": "12:00 – 11:00 PM",
    "general.previewFooter": "Digital menu by",

    "currency.ARS": "Argentine Peso",
    "currency.USD": "US Dollar",
    "currency.EUR": "Euro",
    "currency.BRL": "Brazilian Real",
    "currency.MXN": "Mexican Peso",

    "tz.ar": "🇦🇷 Argentina (Buenos Aires)",
    "tz.mx": "🇲🇽 Mexico (Mexico City)",
    "tz.cl": "🇨🇱 Chile (Santiago)",
    "tz.co": "🇨🇴 Colombia (Bogotá)",
    "tz.pe": "🇵🇪 Peru (Lima)",
    "tz.uy": "🇺🇾 Uruguay (Montevideo)",
    "tz.br": "🇧🇷 Brazil (São Paulo)",
    "tz.ve": "🇻🇪 Venezuela (Caracas)",
    "tz.ec": "🇪🇨 Ecuador (Guayaquil)",
    "tz.py": "🇵🇾 Paraguay (Asunción)",
    "tz.bo": "🇧🇴 Bolivia (La Paz)",
    "tz.pa": "🇵🇦 Panama",
    "tz.cr": "🇨🇷 Costa Rica",
    "tz.usEast": "🇺🇸 United States (Eastern)",
    "tz.usPacific": "🇺🇸 United States (Pacific)",
    "tz.usCentral": "🇺🇸 United States (Central)",
    "tz.es": "🇪🇸 Spain (Madrid)",
    "tz.gb": "🇬🇧 United Kingdom (London)",
    "tz.fr": "🇫🇷 France (Paris)",
    "tz.it": "🇮🇹 Italy (Rome)",
    "tz.de": "🇩🇪 Germany (Berlin)",

    "info.images": "📷 Restaurant Images",
    "info.logo": "Logo",
    "info.cover": "Cover",
    "info.coverBgColor": "Cover Background Color",
    "info.uploading": "Uploading...",
    "info.clickUpload": "Click to upload {type}",
    "info.dropHint": "or drop an image here",
    "info.dropActive": "Drop to upload",
    "info.imgFormats": "PNG, JPG",
    "info.uploadError": "Error uploading image.",
    "info.basic": "ℹ️ Basic Information",
    "info.default": "Default",
    "info.name": "Restaurant Name",
    "info.namePlaceholder": "Name...",
    "info.description": "Description",
    "info.descPlaceholder": "Short description...",
    "info.social": "🔗 Social Media",
    "info.instagram": "📸 Instagram",
    "info.instagramPlaceholder": "@username",
    "info.facebook": "👤 Facebook",
    "info.facebookPlaceholder": "URL or username",
    "info.whatsapp": "💬 WhatsApp",
    "info.whatsappPlaceholder": "+1 555 123-4567",
    "info.website": "🌐 Website",
    "info.websitePlaceholder": "https://...",
    "info.googleMaps": "⭐ Google Maps / Reviews",
    "info.googleMapsPlaceholder": "https://maps.google.com/...",
    "info.wifi": "📶 Local WiFi",
    "info.wifiName": "Network Name",
    "info.wifiNamePlaceholder": "WiFi-Restaurant",
    "info.wifiPassword": "Password",
    "info.wifiPasswordPlaceholder": "password123",
    "info.hours": "🕐 Business Hours",
    "info.timeTo": "to",
    "info.addRange": "+ Add time slot",
    "info.closed": "Closed",

    "day.monday": "Monday",
    "day.tuesday": "Tuesday",
    "day.wednesday": "Wednesday",
    "day.thursday": "Thursday",
    "day.friday": "Friday",
    "day.saturday": "Saturday",
    "day.sunday": "Sunday",

    "catalog.search": "Search...",
    "catalog.newCategory": "New Category",
    "catalog.newCategoryShort": "Category",
    "catalog.empty": "No categories yet",
    "catalog.createFirst": "Create First Category",
    "catalog.hidden": "HIDDEN",
    "catalog.paused": "PAUSED",
    "catalog.items": "items",
    "catalog.visible": "👁️ Visible",
    "catalog.hiddenBtn": "🚫 Hidden",
    "catalog.prices": "💲 Prices",
    "catalog.edit": "✏️ Edit",
    "catalog.delete": "🗑️",
    "catalog.addSubcategory": "📂 + Sub-category",
    "catalog.addProduct": "+ Product",
    "catalog.noProducts": "No products",
    "catalog.addProductLink": "+ Add product",
    "catalog.noName": "No name",
    "catalog.bulkAdjust": "Adjust:",
    "catalog.bulkApply": "Apply",
    "catalog.bulkTitle": "Bulk adjustment",
    "catalog.bulkIncrease": "Increase prices of \"{name}\" by {pct}%?",
    "catalog.bulkDecrease": "Decrease prices of \"{name}\" by {pct}%?",
    "catalog.bulkFixedIncrease": "Add ${amount} to all prices of \"{name}\"?",
    "catalog.bulkFixedDecrease": "Subtract ${amount} from all prices of \"{name}\"?",
    "catalog.editPrice": "Edit price",
    "catalog.hide": "Hide",
    "catalog.show": "Show",
    "catalog.editAction": "Edit",
    "catalog.deleteAction": "Delete",
    "catalog.deleteTitle": "Delete category?",
    "catalog.deleteMsg": "\"{name}\" and all its products will be deleted.",
    "catalog.deleteConfirm": "Delete",
    "catalog.deleteProductTitle": "Delete product?",
    "catalog.deleteProductMsg": "This product will be removed from the catalog.",
    "catalog.deleteProductConfirm": "Delete",

    "product.edit": "✏️ Edit Product",
    "product.new": "✨ New Product",
    "product.tabBasic": "Basic",
    "product.tabLangs": "Languages",
    "product.tabTags": "Tags",
    "product.tabExtras": "Extras",
    "product.image": "Product Image",
    "product.uploadImage": "Upload image",
    "product.dropHint": "or drop it here",
    "product.dropActive": "Drop to upload",
    "product.uploading": "Uploading...",
    "product.imgFormats": "PNG, JPG (max 800px)",
    "product.name": "Name ({lang}) *",
    "product.namePlaceholder": "E.g.: Classic Burger",
    "product.desc": "Description ({lang})",
    "product.descPlaceholder": "Product description...",
    "product.prices": "Prices ({symbol})",
    "product.enabled": "Product Enabled",
    "product.enabledDesc": "Visible on the public menu",
    "product.noLangs": "No additional languages configured",
    "product.noLangsDesc": "Add languages in the General section",
    "product.translate": "🌐 Translate",
    "product.translating": "⏳ Translating...",
    "product.translateAll": "🌐 Translate to all languages",
    "product.translatingAll": "⏳ Translating to all languages...",
    "product.tags": "Tags",
    "product.customTag": "+ Custom tag",
    "product.allergens": "Allergens",
    "product.customAllergen": "+ Add Allergen",
    "product.modifiers": "Modifiers / Extras",
    "product.modifiersDesc": "Additional options for this product (e.g.: extra cheese, no salt)",
    "product.addModifier": "+ Add Modifier",
    "product.modName": "Name ({lang})",
    "product.modPrice": "Price",
    "product.save": "Save Changes",
    "product.create": "Create Product",
    "product.cancel": "Cancel",

    "tag.vegan": "🌱 Vegan",
    "tag.vegetarian": "🥬 Vegetarian",
    "tag.glutenFree": "🌾 Gluten Free",
    "tag.popular": "🔥 Popular",
    "tag.new": "✨ New",
    "tag.spicy": "🌶️ Spicy",
    "tag.recommended": "⭐ Recommended",
    "tag.noMeat": "🐟 No Meat",
    "tag.nutFree": "🥜 Nut Free",
    "tag.organic": "🍃 Organic",

    "category.edit": "✏️ Edit Category",
    "category.new": "📂 New Category",
    "category.newSub": "📂 New Sub-category",
    "category.name": "Category Name *",
    "category.descLabel": "Description (Optional)",
    "category.descPlaceholder": "Brief description of this category...",
    "category.priceTypes": "💲 Price Types",
    "category.priceTypesAdd": "+ Add",
    "category.priceTypesDesc": "E.g.: \"Small\", \"Medium\", \"Large\" for drinks.",
    "category.priceTypePlaceholder": "Price type name",
    "category.status": "Category Status",
    "category.statusDesc": "Paused categories are not shown on the menu",
    "category.schedule": "🕐 Time Slot",
    "category.scheduleDesc": "If active, this category is only shown during the configured hours.",
    "category.scheduleFrom": "From",
    "category.scheduleTo": "To",
    "category.addRange": "+ Add time slot",
    "category.save": "Save Changes",
    "category.create": "Create Category",
    "category.cancel": "Cancel",
    "category.translate": "🌐 Translate",
    "category.translating": "⏳ Translating...",
    "category.nameRequired": "Name in {lang} is required",
    "category.minPriceType": "There must be at least one price type",
    "category.maxPriceType": "Maximum 4 price types allowed",
    "category.namePlaceholder": "E.g.: Starters, Main Courses...",
    "category.priceDefault": "Price",
    "category.priceNew": "New Type",
    "category.deletePriceType": "Delete price type",
    "modules.dailyTitleDefault": "Daily Special",
    "modules.announcementCta": "Got it!",
    "bulkPrice.simple": "Simple",
    "bulkPrice.doble": "Double",
    "bulkPrice.variante": "Variant",
    "bulkPrice.noName": "Unnamed product",
    "bulkPrice.errorApply": "An error occurred while applying changes: {error}",
    "bulkPrice.errorPreview": "Error generating preview: {error}",
    "bulkPrice.exPercent": "E.g.: 10",
    "bulkPrice.exFixed": "E.g.: 500",

    "modules.title": "Modules",
    "modules.desc": "Enable extra features for your digital menu",
    "modules.daily": "🍽️ Daily Specials",
    "modules.dailyDesc": "Highlight special dishes at the top of your menu",
    "modules.dailyTitle": "Section title",
    "modules.dailyTitlePlaceholder": "🍽️ Daily Specials",
    "modules.dailyDescLabel": "Description (optional)",
    "modules.dailyDescPlaceholder": "E.g.: Available today only",
    "modules.displayStyle": "Display style",
    "modules.styleBanner": "Banner",
    "modules.styleCard": "Card",
    "modules.styleHighlight": "Highlight",
    "modules.selectedItems": "Selected dishes ({count})",
    "modules.noItemsYet": "No dishes selected yet",
    "modules.noItemsDesc": "Select products from the catalog or create a custom one",
    "modules.itemNoName": "No name",
    "modules.itemNamePlaceholder": "Dish name",
    "modules.originalPrice": "Original price: ",
    "modules.customItem": "Custom dish",
    "modules.price": "Price",
    "modules.specialPrice": "Special price",
    "modules.activateItem": "Activate dish",
    "modules.pauseItem": "Pause dish (won't be shown)",
    "modules.itemHidden": "🚫 Hidden",
    "modules.itemDescPlaceholder": "Description (optional)",
    "modules.itemUploading": "⏳ Uploading...",
    "modules.itemPhoto": "📸 Photo",
    "modules.deletedProduct": "Deleted product",
    "modules.uploadError": "Error uploading image. Please try again.",
    "modules.createCustom": "🍽️ Create custom dish",
    "modules.newCustomItem": "New custom dish",
    "modules.customNamePlaceholder": "Dish name",
    "modules.customPricePlaceholder": "Price",
    "modules.customDescPlaceholder": "Description (optional)",
    "modules.customAdd": "Add",
    "modules.customCancel": "Cancel",
    "modules.selectProduct": "Select product from catalog",
    "modules.addFromCatalog": "⭐ Add dish from catalog",
    "modules.searchCatalogPlaceholder": "🔍 Search your catalog...",
    "modules.searchProducts": "Search products...",
    "modules.noResults": "No matches found",
    "modules.noResultsFor": "No results for \"{term}\"",
    "modules.noCatalogProducts": "No products in catalog",
    "modules.noCatalogProductsDesc": "Create a new one or add products in Catalog",
    "modules.createNew": "+ Create new product",
    "modules.selectorCancel": "Cancel",
    "modules.addProductsFirst": "⚠️ First add products in the Catalog section",
    "modules.annTimeTo": "to",
    "modules.announcements": "📢 Announcements",
    "modules.announcementsDesc": "Popup that appears when opening the menu with news or promos",
    "modules.annTitle": "Announcement title",
    "modules.annTitlePlaceholder": "E.g.: What's new! 🎉",
    "modules.annMessage": "Message",
    "modules.annMsgPlaceholder": "Write the message your customers will see...",
    "modules.annImage": "Announcement image",
    "modules.annDeleteImage": "✕ Remove",
    "modules.annUploading": "Uploading image...",
    "modules.annClickUpload": "Click to upload image",
    "modules.annImgFormats": "PNG, JPG (max 1000px)",
    "modules.annCtaText": "Button text",
    "modules.annCtaPlaceholder": "Got it!",
    "modules.annCtaUrl": "Button URL (optional)",
    "modules.annBgColor": "Background color",
    "modules.annAccentColor": "Accent color (button)",
    "modules.annShowOnce": "Show only once per session",
    "modules.annShowOnceDesc": "If active, the popup only appears the first time they open the menu",
    "modules.annSchedule": "🕐 Time Slot",
    "modules.annScheduleDesc": "Show the announcement only during certain hours",
    "modules.annAddRange": "+ Add time slot",
    "modules.annPreview": "👁️ Announcement preview",
    "modules.annPreviewLabel": "This is how your customers will see the announcement",
    "modules.annNoTitle": "No title",
    "modules.annClose": "Close",

    "preview.title": "Preview",
    "preview.mobile": "Mobile",
    "preview.desktop": "Desktop",
    "preview.viewMenu": "👁️ View Menu",
    "preview.notAvailable": "Preview not available",
    "preview.saveFirst": "Save the menu to generate the preview",
    "preview.updateHint": "ℹ️ Preview updates when you save changes",

    "confirm.default": "Confirm",
    "confirm.cancel": "Cancel",
    "confirm.noPricesTitle": "No prices defined",
    "confirm.noPricesMsg": "You haven't defined prices for this product. Do you want to continue anyway?",
    "confirm.continue": "Continue",

    "catalog.dragReorder": "Drag to reorder",
    "catalog.drag": "Drag",

    "product.transName": "Name",
    "product.transDesc": "Description",
    "product.transNamePh": "Product name...",
    "product.transDescPh": "Description...",
    "product.quickTags": "Quick tags",
    "product.customTagPh": "Custom tag...",
    "product.allergenPh": "Allergen name...",
    "product.modifierPh": "Extra name...",
    "product.modExtraPh": "E.g.: Extra cheese ({lang})",

    "toast.saveSuccess": "Menu saved successfully",
    "toast.saveError": "Error saving the menu",
    "toast.translating": "Translating to {lang}...",
    "toast.translateSuccess": "Translation to {lang} completed!",
    "toast.translateError": "Error translating. Some fields may not have been translated.",
    "toast.cannotRemoveDefault": "You cannot remove the default language",
    "toast.minOnePriceType": "There must be at least one price type",

    // ═══════════════════════════════════════════
    //  NON-V2 APP STRINGS
    // ═══════════════════════════════════════════

    "navbar.brand": "RestaurAdmin",
    "navbar.home": "Home",
    "navbar.myAccount": "My Menus",
    "navbar.signOut": "Sign Out",
    "navbar.signIn": "Sign In",
    "navbar.auth.emptyFields": "Please fill in all fields",
    "navbar.auth.genericError": "Error signing in. Please try again.",
    "navbar.auth.userNotFound": "No account found with this email.",
    "navbar.auth.wrongPassword": "Incorrect password. Please verify and try again.",
    "navbar.auth.invalidEmail": "The email address is not valid.",
    "navbar.auth.tooManyRequests": "Too many failed attempts. Please try again later.",
    "navbar.auth.invalidCredential": "Invalid credentials. Please verify and try again.",
    "navbar.auth.emailLabel": "Email",
    "navbar.auth.emailPlaceholder": "Enter your email",
    "navbar.auth.passwordLabel": "Password",
    "navbar.auth.passwordPlaceholder": "Enter your password",
    "navbar.auth.showPassword": "Show password",
    "navbar.auth.hidePassword": "Hide password",
    "navbar.auth.cancel": "Cancel",
    "navbar.auth.signingIn": "Signing in...",

    "home.trustBadge": "Used by +200 restaurants",
    "home.weekBadge": "{count} restaurants created their menu this week",
    "home.hero.title": "Your Digital Menu ",
    "home.hero.titleHighlight": "Ready in 24h",
    "home.hero.subtitle1": "No printing. No errors. No limits.",
    "home.hero.subtitle2": "Update prices, dishes and photos from your phone",
    "home.hero.benefit1": "Custom QR code for your business",
    "home.hero.benefit2": "Multi-language menu included",
    "home.hero.benefit3": "Technical support when you need it",
    "home.hero.statValue": "+30%",
    "home.hero.statLabel": "Average sales",
    "home.hero.ctaButton": "Create My Menu Now",
    "home.hero.ctaInfo": "⚡ No credit card • Setup in minutes",
    "home.testimonials.badge": "+200 Satisfied Clients",
    "home.testimonials.viewTestimonial": "View testimonial by {author}",
    "home.testimonials.title": "Real Success Stories",
    "home.testimonials.subtitle": "Restaurants that trusted us and increased their sales",
    "home.features.title": "Everything you need in one place",
    "home.features.photos": "Unlimited photos",
    "home.features.instantUpdate": "Instant update",
    "home.features.multiLanguage": "Multi-language",
    "home.features.customQr": "Custom QR",
    "home.features.support": "24/7 Support",
    "home.features.editor": "Intuitive editor",
    "home.finalCta.title": "Ready to modernize your restaurant?",
    "home.finalCta.subtitle": "Join 200+ restaurants that already digitized their menu and increased sales",
    "home.finalCta.benefit1": "Setup in 24h",
    "home.finalCta.benefit2": "No hidden costs",
    "home.finalCta.benefit3": "Cancel anytime",
    "home.finalCta.button": "Create My Digital Menu Now",
    "home.finalCta.guarantee": "100% risk-free guarantee - If you don't like it in the first 7 days, we'll refund your money",
    "home.footer.title": "Have questions? Let's talk",
    "home.footer.subtitle": "We answer all your questions in less than 2 hours",
    "home.footer.contactButton": "Talk to the Team",
    "home.whatsapp.tooltip": "Need help? Write to us",
    "home.whatsapp.message": "Hi! I want to create my digital menu",

    "clientCarousel.badge": "DIGITAL MENUS IN ACTION",
    "clientCarousel.title": "Hundreds of restaurants trust us!",
    "clientCarousel.subtitle": "Discover how we transformed their businesses",
    "clientCarousel.viewMenu": "View Menu",
    "clientCarousel.goToPage": "Go to page {page}",
    "clientCarousel.previous": "Previous",
    "clientCarousel.next": "Next",
    "clientCarousel.ctaText": "Would you like a menu like these?",
    "clientCarousel.ctaButton": "Create My Digital Menu",

    "contact.success.title": "Message Sent! 🎉",
    "contact.success.message": "Thank you for your interest. We'll contact you very soon to help you create your custom digital menu.",
    "contact.success.button": "Perfect",
    "contact.close": "Close",
    "contact.form.title": "Let's Create Your Digital Menu Together! 🚀",
    "contact.form.subtitle": "Leave your details and we'll contact you to help transform your business with a professional digital menu",
    "contact.form.nameLabel": "Your Name",
    "contact.form.namePlaceholder": "E.g.: John Smith",
    "contact.form.phoneLabel": "WhatsApp / Phone",
    "contact.form.phonePlaceholder": "E.g.: +1 555 123-4567",
    "contact.form.emailLabel": "Email",
    "contact.form.emailPlaceholder": "your@email.com",
    "contact.form.businessLabel": "Business Name",
    "contact.form.businessPlaceholder": "E.g.: The Corner Restaurant",
    "contact.form.messageLabel": "Tell us what you need",
    "contact.form.messagePlaceholder": "E.g.: I want a digital menu for my restaurant with 50 products...",
    "contact.benefits.title": "✨ What you'll get:",
    "contact.benefits.item1": "✅ Professional and customized digital menu",
    "contact.benefits.item2": "✅ Downloadable QR for printing",
    "contact.benefits.item3": "✅ Unlimited updates from your dashboard",
    "contact.benefits.item4": "✅ Technical support included",
    "contact.form.sending": "Sending...",
    "contact.form.submitButton": "Send Inquiry",

    "profile.sectionHeader": "Your Menus",
    "profile.categories": "Categories",
    "profile.products": "Products",
    "profile.lastUpdate": "Last update: ",
    "profile.viewMenu": "View Menu",
    "profile.editMenu": "Edit Menu",
    "profile.qrCode": "QR Code",
    "profile.deleteMenu": "Delete Menu",
    "profile.print": "Print",
    "profile.createNewMenu": "Create New Menu",
    "profile.emptyState": "You don't have any menus available.",
    "profile.menuType.complete": "Complete",
    "profile.menuType.standard": "Standard",
    "profile.menuType.basic": "Basic",
    "profile.dateNotAvailable": "Not available",
    "profile.deleteModal.title": "Confirm Deletion",
    "profile.deleteModal.message": "Are you sure you want to delete this menu? You will lose all information.",
    "profile.deleteModal.passwordLabel": "Enter your password to confirm:",
    "profile.deleteModal.passwordPlaceholder": "Password",
    "profile.deleteModal.verifying": "Verifying...",
    "profile.toast.menuExists": "A menu with that name already exists. Please choose another name.",
    "profile.toast.menuCreatedSuccess": "Menu created successfully. Reloading...",
    "profile.toast.htmlError": "Error creating the HTML file.",
    "profile.toast.jsonError": "Error creating the JSON file.",
    "profile.toast.menuV2CreatedSuccess": "✨ V2 Menu created successfully. Redirecting to editor...",
    "profile.toast.enterPassword": "Enter your password to confirm",
    "profile.toast.menuDeleted": "Menu deleted successfully. Reloading...",
    "profile.toast.wrongPassword": "Incorrect password",
    "profile.toast.deleteError": "Error deleting the menu",
    "profile.prompt.menuName": "Enter your menu name:",
    "profile.subtitle.one": "Your menu. Tap to open.",
    "profile.subtitle.many": "{count} menus. Pick one to manage it.",

    "menuDashboard.eyebrow": "Menu",
    "menuDashboard.back": "My menus",
    "menuDashboard.qrButton": "QR Code",
    "menuDashboard.viewPublic": "View public menu",
    "menuDashboard.sectionTitle": "What do you want to do?",
    "menuDashboard.feature.edit.title": "Edit digital menu",
    "menuDashboard.feature.edit.desc": "Add or modify categories, dishes, prices and photos.",
    "menuDashboard.feature.pdf.title": "Printable PDF",
    "menuDashboard.feature.pdf.desc": "Download your menu as a ready-to-print PDF.",
    "menuDashboard.feature.pdf.badge": "New",
    "menuDashboard.feature.costs.title": "Costs & profit",
    "menuDashboard.feature.costs.desc": "See how much each dish costs to make and how much profit you keep.",
    "menuDashboard.feature.costsStock.desc": "How much each dish leaves you and how much you have left of each supply.",
    "menuDashboard.feature.reservations.title": "Reservations",
    "menuDashboard.feature.reservations.desc": "Take reservations from your menu and manage them here.",
    "menuDashboard.feature.reservations.badge": "New",
    "menuDashboard.comingSoon": "Coming soon",
    "menuDashboard.feature.online.title": "Online orders",
    "menuDashboard.feature.online.desc": "Your ordering link, delivery and payments: turn on your store.",

    // ─── Reservations feature ───
    "reservations.title": "Reservations",
    "reservations.subtitle": "Manage your restaurant's reservations",
    "reservations.back": "Back",
    "reservations.loading": "Loading...",
    "reservations.empty.title": "Turn reservations on in 1 minute",
    "reservations.empty.desc": "Your customers will be able to book a table from your digital menu. You get the request via WhatsApp and confirm with one tap.",
    "reservations.empty.step1": "Add your WhatsApp number",
    "reservations.empty.step1Desc": "Reservations will arrive here",
    "reservations.empty.step2": "Draw your tables (optional)",
    "reservations.empty.step2Desc": "So customers see where they'll sit",
    "reservations.empty.step3": "Define shifts (optional)",
    "reservations.empty.step3Desc": "Available time slots per day",
    "reservations.empty.cta": "Get started",
    "reservations.setup.title": "Initial setup",
    "reservations.setup.waLabel": "Restaurant WhatsApp number",
    "reservations.setup.waPlaceholder": "+1 555 123 4567",
    "reservations.setup.waHelp": "Customer reservations will arrive here.",
    "reservations.setup.save": "Save and continue",
    "reservations.setup.saving": "Saving...",
    "reservations.setup.invalidPhone": "Enter a valid number with country code (e.g.: +1 555 123 4567).",
    "reservations.setup.savedTitle": "All set!",
    "reservations.setup.savedDesc": "You can start taking reservations now. We recommend drawing your tables for a better experience.",
    "reservations.month.today": "Today",
    "reservations.month.weekdays": "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
    "reservations.month.months": "January,February,March,April,May,June,July,August,September,October,November,December",
    "reservations.month.empty": "No reservations this month yet.",
    "reservations.month.shareLink": "Share this link with your customers:",
    "reservations.month.shareLinkNotReady": "Your booking link will be generated once your menu has a public slug assigned in /admin. Let us know to set it up.",

    // ─── Claim slug self-service ───
    "reservations.claim.title": "Pick your booking link",
    "reservations.claim.desc": "Your restaurant doesn't have a public link yet. Pick a short, memorable name.",
    "reservations.claim.placeholder": "my-restaurant",
    "reservations.claim.claim": "Create link",
    "reservations.claim.creating": "Creating...",
    "reservations.claim.checking": "Checking availability...",
    "reservations.claim.available": "Available, you can use it.",
    "reservations.claim.taken": "That link is taken. Try another.",
    "reservations.claim.invalidFormat": "Lowercase letters, numbers and dashes only. 3–30 chars.",
    "reservations.claim.checkError": "Couldn't verify. Try again.",
    "reservations.claim.createError": "Couldn't create the link. Try later.",
    "reservations.claim.claimedToast": "Link created.",
    "reservations.claim.rules": "Link rules",
    "reservations.claim.rule1": "Lowercase letters, numbers and dashes only.",
    "reservations.claim.rule2": "Between 3 and 30 characters.",
    "reservations.claim.rule3": "Once created it can't be changed (ask us for help if you mistyped).",
    "reservations.month.copyLink": "Copy link",
    "reservations.month.linkCopied": "Link copied!",
    "reservations.legend.pending": "Pending",
    "reservations.legend.confirmed": "Confirmed",
    "reservations.legend.full": "Full",
    "reservations.placeholder.calendarTitle": "Your reservations calendar",
    "reservations.placeholder.calendarDesc": "You'll see every day's reservations here. Tap any day to see the details.",
    "reservations.placeholder.mapTitle": "Coming soon: draw your floor",
    "reservations.placeholder.mapDesc": "You'll be able to draw your tables drag-and-drop and upload photos per area. Your customers see them before booking.",
    "reservations.placeholder.turnsTitle": "Coming soon: shifts per day",
    "reservations.placeholder.turnsDesc": "Configure which days you accept reservations and at what times. Days off auto-disable.",

    // ─── Floor plan editor ───
    "reservations.editor.cta": "Draw my tables",
    "reservations.editor.ctaDesc": "Draw your floor. Your customers will be able to pick a table when booking.",
    "reservations.editor.title": "Table editor",
    "reservations.editor.subtitle": "Drag tables to arrange them",
    "reservations.editor.toolRect": "Table",
    "reservations.editor.toolCircle": "Round",
    "reservations.editor.toolLarge": "Long",
    "reservations.editor.toolArea": "Area",
    "reservations.editor.toolWall": "Wall",
    "reservations.editor.toolLabel": "Text",
    "reservations.editor.toolPhoto": "Photo",
    "reservations.editor.tapToSelect": "Tap a table to edit it",
    "reservations.editor.itemTable": "Table",
    "reservations.editor.itemLabel": "Text",
    "reservations.editor.itemPhoto": "Photo",
    "reservations.editor.itemWall": "Wall",
    "reservations.editor.itemArea": "Area",
    "reservations.editor.areaName": "Area name",
    "reservations.editor.areaNamePlaceholder": "Dining room, Patio, Bar...",
    "reservations.editor.zoomIn": "Zoom in",
    "reservations.editor.zoomOut": "Zoom out",
    "reservations.editor.zoomFit": "Fit plan",
    "reservations.editor.drawWallsHint": "Wall mode: tap the corners, drag to pan.",
    "reservations.editor.drawWallsStart": "Tap the first corner of the wall.",
    "reservations.editor.drawWallsNext": "Tap the next corner · {n} segments",
    "reservations.editor.number": "Table number",
    "reservations.editor.numberPlaceholder": "1, 2, B3...",
    "reservations.editor.label": "Name or zone",
    "reservations.editor.labelPlaceholder": "Window, Patio, Bar...",
    "reservations.editor.seats": "Seats",
    "reservations.editor.minSeats": "Minimum party",
    "reservations.editor.minSeatsHint": "Guests can't book this table for fewer people than this. 0 = no minimum (e.g. a table for 4 with min 3 won't be booked for 1).",
    "reservations.editor.rotation": "Rotation",
    "reservations.editor.rotate90": "Rotate 90°",
    "reservations.editor.width": "Width",
    "reservations.editor.height": "Height",
    "reservations.editor.diameter": "Diameter",
    "reservations.editor.wallLength": "Length",
    "reservations.editor.wallThickness": "Thickness",
    "reservations.editor.text": "Text",
    "reservations.editor.textPlaceholder": "WINDOW",
    "reservations.editor.size": "Size",
    "reservations.editor.photo": "Photo (optional)",
    "reservations.editor.uploadPhoto": "Upload photo",
    "reservations.editor.uploading": "Uploading...",
    "reservations.editor.uploadError": "Couldn't upload the photo.",
    "reservations.editor.caption": "Caption",
    "reservations.editor.captionPlaceholder": "View from the front...",
    "reservations.editor.delete": "Delete",
    "reservations.editor.deleteItem": "Delete {item}",
    "reservations.editor.hintEmpty": "Tap a tool to add tables.",
    "reservations.editor.hintSelected": "Drag to move. Edit properties on the side panel.",
    "reservations.editor.save": "Save map",
    "reservations.editor.saving": "Saving...",
    "reservations.editor.undo": "Undo",
    "reservations.editor.redo": "Redo",
    "reservations.editor.duplicate": "Duplicate",
    "reservations.editor.unsaved": "Unsaved changes",
    "reservations.editor.allSaved": "All saved",
    "reservations.editor.savedToast": "Map saved",
    "reservations.editor.saveError": "Couldn't save the map.",
    "reservations.editor.overrideSubtitle": "Custom map for {date}",
    "reservations.editor.overrideActive": "This day uses a custom map.",
    "reservations.editor.overrideStartHint": "Edit the tables. Changes only apply to this day.",
    "reservations.editor.emptyState": "Tap a tool to add your first table.",
    "reservations.dayView.emptyTitle": "No reservations yet",
    "reservations.dayView.emptyDesc": "Share your booking link on your social media to start receiving.",
    "reservations.editor.revertToBase": "Back to base map",
    "reservations.editor.revertConfirm": "Delete the custom map and go back to the base?",
    "reservations.editor.revertedToast": "Reverted to base map.",
    "reservations.dayView.editMapForDay": "Edit map for this day",

    // ─── Config screen ───
    "reservations.config.cta": "Shifts & hours",
    "reservations.config.ctaDesc": "Set which days you take reservations, blocked dates and message templates.",
    "reservations.config.title": "Configuration",
    "reservations.config.subtitle": "Shifts, blocked dates and messages.",
    "reservations.config.nameTitle": "Restaurant name",
    "reservations.config.nameHint": "Shown as the title on the page where your guests book.",
    "reservations.config.namePlaceholder": "e.g. Don Juan's Grill",
    "reservations.config.waTitle": "📱 Restaurant WhatsApp",
    "reservations.config.waHint": "Reservations from your customers arrive here.",
    "reservations.config.modeTitle": "Reservation mode",
    "reservations.config.modeHint": "Choose how you take reservations.",
    "reservations.config.modeFree": "Free time",
    "reservations.config.modeFreeDesc": "Customer picks any time within your opening hours.",
    "reservations.config.modeTurns": "By shifts",
    "reservations.config.modeTurnsDesc": "Define specific shifts (e.g.: 8-10pm and 10:30pm-0:30am). Customer picks one.",
    "reservations.config.presetsTitle": "Quick presets",
    "reservations.config.presetsHint": "Start with a preset and tweak as needed.",
    "reservations.config.presetNone": "No shifts",
    "reservations.config.presetWeekendDinner": "Fri/Sat/Sun dinner",
    "reservations.config.presetDinnerEveryday": "Dinner every day",
    "reservations.config.presetLunchDinner": "Lunch & dinner",
    "reservations.config.daysTitle": "Days & shifts",
    "reservations.config.daysHint": "Turn on the days you take reservations. Tap each to define shifts.",
    "reservations.config.openHoursTitle": "Days & open hours",
    "reservations.config.openHoursHint": "Turn on the days you're open. Customers will only pick times within these ranges.",
    "reservations.config.addTurn": "Add shift",
    "reservations.config.addRange": "Add range",
    "reservations.config.removeTurn": "Remove shift",
    "reservations.config.blockedTitle": "📅 Blocked dates",
    "reservations.config.blockedHint": "Holidays, days off, private events. No reservations are taken on these days.",
    "reservations.config.blockDate": "Block",
    "reservations.config.blockedEmpty": "No blocked dates.",
    "reservations.config.unblock": "Unblock",
    "reservations.config.specialOpenTitle": "🗓️ Special open days",
    "reservations.config.specialOpenHint": "Holidays or one-off dates when you open even if it's not a regular day. They become bookable with the hours you set.",
    "reservations.config.specialOpenAdd": "Add day",
    "reservations.config.specialOpenEmpty": "No special days. Add a holiday to open bookings that day.",
    "reservations.config.specialOpenRemove": "Remove",
    "reservations.config.specialOpenBeyondWindow": "It's beyond your booking window ({days} days): it'll be bookable as the date gets closer.",
    "reservations.config.messagesTitle": "💬 Message templates",
    "reservations.config.messagesHint": "When you confirm or reject a reservation WhatsApp opens with these pre-filled messages (always editable before sending).",
    "reservations.config.variables": "Available variables:",
    "reservations.config.tplConfirm": "Confirm reservation",
    "reservations.config.tplConfirmHint": "Sent when you accept a reservation.",
    "reservations.config.tplReject": "Reject reservation",
    "reservations.config.tplRejectHint": "When you can't take it.",
    "reservations.config.tplChange": "Table change",
    "reservations.config.tplChangeHint": "When confirming but assigning a different table.",
    "reservations.config.tplReminder": "Reminder",
    "reservations.config.tplReminderHint": "The message for the 🔔 Remind button (on the day of the booking).",
    "reservations.config.save": "Save settings",
    "reservations.config.savedToast": "Settings saved",
    "reservations.config.saveError": "Couldn't save.",

    // ─── Public booking page ───
    "reservations.booking.title": "Book a table",
    "reservations.booking.step1": "Pick the date",
    "reservations.booking.step2": "Pick the time",
    "reservations.booking.step4": "Pick your table (optional)",
    "reservations.booking.step4Hint": "Tap a table to request it. Otherwise the restaurant assigns one.",
    "reservations.booking.step5": "Your details",
    "reservations.booking.people": "How many?",
    "reservations.booking.personSingular": "person",
    "reservations.booking.personPlural": "people",
    "reservations.booking.yourName": "Your name",
    "reservations.booking.yourNamePh": "John Smith",
    "reservations.booking.yourPhone": "Your WhatsApp",
    "reservations.booking.yourPhonePh": "+1 555 123 4567",
    "reservations.booking.notes": "Notes (optional)",
    "reservations.booking.notesPh": "Birthday, allergies, indoor/outdoor preference...",
    "reservations.booking.submitCta": "Book via WhatsApp",
    "reservations.booking.submitHint": "WhatsApp opens with your request pre-filled. Send it to the restaurant and wait for confirmation.",
    "reservations.booking.sending": "Sending...",
    "reservations.booking.submitError": "Couldn't save your booking. Try again.",
    "reservations.booking.tableTakenError": "Someone just took that table. Pick another and try again.",
    "reservations.booking.duplicateError": "You already have a booking for that day with this phone. To change it, message us on WhatsApp.",
    "reservations.booking.missingTime": "Missing: pick a time",
    "reservations.booking.missingZone": "Missing: pick an area",
    "reservations.booking.missingName": "Missing: your name",
    "reservations.booking.missingPhone": "Missing: your phone (WhatsApp)",
    "reservations.booking.phoneTooShort": "That phone looks incomplete",
    "reservations.booking.outOfHoursError": "The time you picked is outside opening hours. Check the day's hours.",
    "reservations.booking.tooSoonError": "That time is too soon. Please pick one further ahead.",
    "reservations.booking.dateChangedError": "The day changed. Please pick the date and time again.",
    "reservations.booking.noTurns": "No shifts available for this day.",
    "reservations.booking.freeTimeLabel": "Pick a time",
    "reservations.booking.endsAt": "You stay until {time}",
    "reservations.booking.openHours": "Open hours",
    "reservations.booking.legendAvailable": "Available",
    "reservations.booking.legendReserved": "Booked",
    "reservations.booking.legendPending": "Pending",
    "reservations.booking.legendTooSmall": "Too small",
    "reservations.booking.notFoundTitle": "Restaurant not found",
    "reservations.booking.notFoundDesc": "Check that the link is correct.",
    "reservations.booking.notReadyTitle": "Reservations not available",
    "reservations.booking.notReadyDesc": "This restaurant hasn't activated online reservations yet. Try contacting them on social media.",
    "reservations.booking.sentTitle": "Request sent",
    "reservations.booking.sentDesc": "Your booking is NOT confirmed yet. Send the WhatsApp message and the restaurant will confirm it there.",
    "reservations.booking.sentHint": "You'll get the confirmation on that same WhatsApp when the restaurant replies.",
    "reservations.booking.openWhatsApp": "📲 Open WhatsApp",
    "reservations.booking.bookAnother": "Book another time",

    // ─── Day view (owner) ───
    "reservations.dayView.pending": "pending",
    "reservations.dayView.confirmed": "confirmed",
    "reservations.dayView.empty": "No reservations for this day.",
    "reservations.dayView.mapTitle": "Map for the day",
    "reservations.dayView.pendingTitle": "Pending",
    "reservations.dayView.confirmedTitle": "Confirmed",
    "reservations.dayView.rejectedTitle": "Rejected",
    "reservations.dayView.cancelledTitle": "Cancelled",
    "reservations.dayView.status_pending": "Pending",
    "reservations.dayView.status_confirmed": "Confirmed",
    "reservations.dayView.status_rejected": "Rejected",
    "reservations.dayView.status_cancelled": "Cancelled",
    "reservations.dayView.status_expired": "Expired",
    "reservations.dayView.confirm": "Confirm",
    "reservations.dayView.changeTable": "Change table",
    "reservations.dayView.reject": "Reject",
    "reservations.dayView.openWa": "WhatsApp",
    "reservations.dayView.resendConfirm": "Re-send confirmation",
    "reservations.dayView.requestedTable": "Asked for: {name}",
    "reservations.dayView.assignedTable": "Assigned: {name}",
    "reservations.dayView.rejectConfirm": "Reject this booking? You'll be able to message the customer.",
    "reservations.dayView.cancelBooking": "Cancel reservation",
    "reservations.dayView.cancelBookingConfirm": "Cancel this reservation? The table will become available for other customers.",
    "reservations.dayView.cancelledToast": "Reservation cancelled. The table is free again.",
    "reservations.dayView.confirmedToast": "Reservation confirmed. WhatsApp opens.",
    "reservations.dayView.rejectedToast": "Reservation rejected. WhatsApp opens.",
    "reservations.dayView.confirmedNoWaToast": "Reservation confirmed. (WhatsApp didn't open because the template is empty.)",
    "reservations.dayView.rejectedNoWaToast": "Reservation rejected. (WhatsApp didn't open because the template is empty.)",
    "reservations.dayView.invalidPhoneToast": "Saved, but the customer's phone number is invalid — couldn't open WhatsApp.",
    "reservations.dayView.assignedTableMissing": "Assigned table was deleted from the plan (was: {name})",

    "reservations.dayView.arrivedTitle": "Arrived",
    "reservations.dayView.noShowTitle": "No-show",
    "reservations.dayView.status_arrived": "Arrived",
    "reservations.dayView.status_no_show": "No-show",
    "reservations.dayView.markArrived": "Arrived",
    "reservations.dayView.markNoShow": "No-show",
    "reservations.dayView.noShowConfirm": "Mark as no-show? The table becomes free.",
    "reservations.dayView.arrivedToast": "Marked as arrived.",
    "reservations.dayView.noShowToast": "Marked as no-show. Table is free.",
    "reservations.dayView.edit": "Edit",
    "reservations.dayView.editedToast": "Reservation updated.",
    "reservations.dayView.newManualBooking": "New manual booking",
    "reservations.dayView.manualCreatedToast": "Booking created.",
    "reservations.dayView.blockTable": "Block table",
    "reservations.dayView.blockedToast": "Table blocked for this slot.",
    "reservations.dayView.sendReminder": "Remind",
    "reservations.dayView.defaultReminder": "Hi {name}! Just a reminder about your reservation on {date} at {time}. See you!",
    "reservations.dayView.pastNoShowWarn": "This phone has {count} previous no-show(s)",

    "reservations.dashboard.notifEnabledToast": "Notifications enabled",
    "reservations.dashboard.notifEnableThis": "Turn on alerts for this restaurant on this phone",
    "reservations.dashboard.notifOnThis": "Alerts on for this restaurant",
    "reservations.dashboard.notifOnHint": "Tap to stop receiving them on this phone",
    "reservations.dashboard.notifBlocked": "Alerts blocked — enable them in your browser settings",
    "reservations.dashboard.notifDisabledToast": "Alerts turned off on this phone",
    "reservations.dashboard.notifLegacyOffToast": "Done. This phone no longer gets alerts from all your restaurants — turn on the ones you want.",
    "reservations.dashboard.searchPh": "Search by name or phone...",
    "reservations.dashboard.upcomingTitle": "Upcoming bookings",
    "reservations.dashboard.searchEmpty": "No reservations match that.",

    "reservations.manualBooking.createTitle": "New manual booking",
    "reservations.manualBooking.editTitle": "Edit booking",
    "reservations.manualBooking.name": "Name",
    "reservations.manualBooking.namePh": "Customer name",
    "reservations.manualBooking.phone": "Phone (optional)",
    "reservations.manualBooking.phonePh": "+1 555 ...",
    "reservations.manualBooking.people": "Party",
    "reservations.manualBooking.turn": "Turn",
    "reservations.manualBooking.time": "Time",
    "reservations.manualBooking.table": "Table (optional)",
    "reservations.manualBooking.noTable": "No table assigned",
    "reservations.manualBooking.notes": "Notes",
    "reservations.manualBooking.cancel": "Cancel",
    "reservations.manualBooking.create": "Create booking",
    "reservations.manualBooking.saveEdit": "Save changes",
    "reservations.manualBooking.errorName": "Name is required.",
    "reservations.manualBooking.errorTime": "Time is required.",
    "reservations.manualBooking.outsideHoursWarn": "Time is outside open hours. Create anyway?",
    "reservations.manualBooking.tableOccupied": "occupied",

    "reservations.blockTable.title": "Block table",
    "reservations.blockTable.hint": "Use this when a table can't be booked (private event, repair, etc).",
    "reservations.blockTable.table": "Table",
    "reservations.blockTable.from": "From",
    "reservations.blockTable.to": "To",
    "reservations.blockTable.reason": "Reason (optional)",
    "reservations.blockTable.reasonPh": "e.g. private event",
    "reservations.blockTable.confirm": "Block",
    "reservations.blockTable.errorTable": "Pick a table.",
    "reservations.blockTable.errorTime": "Missing times.",
    "reservations.blockTable.errorTimeOrder": "The end time must be after the start time.",
    "reservations.blockTable.errorTableTaken": "That table is booked for that time slot. Pick another.",
    "reservations.blockTable.tapTableHint": "Tap a free table on the map to block it",

    "reservations.stats.cta": "Stats",
    "reservations.stats.ctaDesc": "See booking counts, no-shows and top tables.",
    "reservations.stats.title": "Stats",
    "reservations.stats.subtitle": "Summary of the month you're viewing.",
    "reservations.stats.confirmed": "Confirmed",
    "reservations.stats.arrived": "Arrived",
    "reservations.stats.pending": "Pending",
    "reservations.stats.noShow": "No-show",
    "reservations.stats.cancelled": "Cancelled",
    "reservations.stats.rejected": "Rejected",
    "reservations.stats.noShowRateTitle": "No-show rate",
    "reservations.stats.noShowRateHint": "Of the bookings that closed (arrived + no-show), how many didn't show.",
    "reservations.stats.perDayTitle": "Bookings per day",
    "reservations.stats.topTablesTitle": "Top tables",
    "reservations.stats.topZonesTitle": "Most used areas",
    "reservations.stats.covers": "Covers",
    "reservations.stats.empty": "No bookings this month yet.",
    "reservations.dayView.actionError": "Couldn't update. Try again.",
    "reservations.dayView.assignTitle": "Pick a table",
    "reservations.dayView.assignHint": "Tap the table you want to assign.",
    "reservations.dayView.assignConfirm": "Assign and confirm",
    "reservations.dayView.cancel": "Cancel",
    "reservations.dayView.legendSelected": "Selected",
    "reservations.dayView.legendOccupied": "Occupied",

    "menuDashboard.qrModal.title": "Menu QR code",
    "menuDashboard.qrModal.hint": "Customers scan this code and open your menu.",
    "menuDashboard.error": "We couldn't load this menu.",
    "menuDashboard.errorBack": "Back to my menus",

    "printPdf.back": "Back",
    "printPdf.title": "Printable PDF",
    "printPdf.subtitle": "Design your paper menu and download it.",
    "printPdf.loading": "Loading menu data...",
    "printPdf.loadError": "We couldn't load the menu.",
    "printPdf.stepper.step": "Step {current} of {total}",
    "printPdf.stepper.1": "Design",
    "printPdf.stepper.2": "Theme",
    "printPdf.stepper.3": "Content",
    "printPdf.stepper.4": "Format",
    "printPdf.nav.previous": "Previous",
    "printPdf.nav.next": "Next",
    "printPdf.nav.finish": "Done",
    "printPdf.nav.togglePreview": "View preview",
    "printPdf.nav.hidePreview": "Hide preview",
    "printPdf.cta.download": "Download PDF",
    "printPdf.cta.openPdf": "📄 Open / download PDF",
    "printPdf.cta.pdfReadyHint": "If the download didn't start, tap here to open the PDF.",
    "printPdf.cta.loadingTitle": "Generating your PDF…",
    "printPdf.cta.loadingHint": "It may take a few seconds. The download starts automatically.",
    "printPdf.cta.generating": "Generating...",
    "printPdf.cta.save": "Save design",
    "printPdf.cta.saved": "Design saved",
    "printPdf.cta.saving": "Saving...",
    "printPdf.cta.reset": "Reset to base design",
    "printPdf.step1.title": "Pick a base design",
    "printPdf.step1.subtitle": "The design sets the overall style. You'll tweak it later.",
    "printPdf.templates.classic.name": "Classic",
    "printPdf.templates.classic.desc": "Elegant, serif, generous spacing",
    "printPdf.templates.modern.name": "Modern",
    "printPdf.templates.modern.desc": "Minimal, clean typography",
    "printPdf.templates.familiar.name": "Warm",
    "printPdf.templates.familiar.desc": "Cozy, readable, dishes stand out",
    "printPdf.templates.chalkboard.name": "Chalkboard",
    "printPdf.templates.chalkboard.desc": "Dark background, bar vibe",
    "printPdf.templates.fine.name": "Fine dining",
    "printPdf.templates.fine.desc": "Delicate serif, lots of space",
    "printPdf.step2.title": "Theme",
    "printPdf.step2.subtitle": "Pick background, colors and text size.",
    "printPdf.step2.background": "Background",
    "printPdf.step2.backgroundPresets": "Preset backgrounds",
    "printPdf.step2.backgroundUpload": "Upload my own background",
    "printPdf.step2.backgroundUploadHint": "JPG or PNG. Your photo becomes the menu background.",
    "printPdf.step2.backgroundNone": "No background",
    "printPdf.step2.backgroundOpacity": "Background opacity",
    "printPdf.step2.backgroundOverlay": "Light box behind each dish",
    "printPdf.step2.backgroundOverlayHint": "Helps readability on image backgrounds.",
    "printPdf.step2.colors": "Text colors",
    "printPdf.step2.colorTitles": "Titles",
    "printPdf.step2.colorProducts": "Dish names",
    "printPdf.step2.colorPrices": "Prices",
    "printPdf.step2.colorDescriptions": "Descriptions",
    "printPdf.step2.fontFamily": "Font",
    "printPdf.step2.fontDefault": "Match the chosen design",
    "printPdf.step2.fontPreview": "Aa — Restaurant menu",
    "printPdf.step2.textSize": "Text size",
    "printPdf.step2.textSize.sm": "Small",
    "printPdf.step2.textSize.md": "Normal",
    "printPdf.step2.textSize.lg": "Large",
    "printPdf.step2.logo": "Restaurant logo",
    "printPdf.step2.logoUpload": "Upload logo",
    "printPdf.step2.logoRemove": "Remove logo",
    "printPdf.step3.title": "Content",
    "printPdf.step3.subtitle": "Choose what to show in the PDF.",
    "printPdf.step3.showCover": "Cover page with logo and name",
    "printPdf.step3.showDescriptions": "Dish descriptions",
    "printPdf.step3.showPhotos": "Dish photos (if the menu has them)",
    "printPdf.step3.showAllergens": "Tags (gluten-free, vegan...)",
    "printPdf.step3.showRestaurantInfo": "Restaurant info at the end",
    "printPdf.step3.showQr": "QR code at the end",
    "printPdf.step3.itemBox": "Box behind each dish",
    "printPdf.step3.itemBoxHint": "Wraps each dish in a soft box to separate them better.",
    "printPdf.step4.title": "Format",
    "printPdf.step4.subtitle": "Paper size and orientation.",
    "printPdf.step4.paperSize": "Paper size",
    "printPdf.step4.paper.a4": "A4",
    "printPdf.step4.paper.a5": "A5",
    "printPdf.step4.paper.letter": "Letter",
    "printPdf.step4.paper.halfLetter": "Half-letter",
    "printPdf.step4.orientation": "Orientation",
    "printPdf.step4.orientation.portrait": "Portrait",
    "printPdf.step4.orientation.landscape": "Landscape",
    "printPdf.step4.columns": "Columns",
    "printPdf.step4.columns.one": "One",
    "printPdf.step4.columns.two": "Two",
    "printPdf.step4.columns.three": "Three",
    "printPdf.stepper.5": "Texts",
    "printPdf.step5.title": "Edit the texts",
    "printPdf.step5.subtitle": "Change names, descriptions or add notes — for this PDF only, your digital menu stays intact.",
    "printPdf.step5.hintTitle": "Tip:",
    "printPdf.step5.hintBody": "Leave the field empty to keep the original text. You can use line breaks (Enter) in descriptions and notes.",
    "printPdf.step5.categoryName": "Category name",
    "printPdf.step5.categoryDescription": "Category description",
    "printPdf.step5.categoryDescriptionPlaceholder": "e.g. Perfect for sharing before the main course",
    "printPdf.step5.keepTogether": "Keep together (don't split across pages)",
    "printPdf.step5.pageBreakBefore": "Start on a new page",
    "printPdf.step5.productName": "Product name",
    "printPdf.step5.productDescription": "Description",
    "printPdf.step5.productDescriptionPlaceholder": "Write a description",
    "printPdf.step5.products": "products",
    "printPdf.step5.empty": "No categories or products in the menu.",
    "printPdf.preview.title": "Preview",
    "printPdf.preview.generating": "Generating preview...",
    "printPdf.preview.refresh": "Refresh preview",
    "printPdf.preview.mobileHint": "Tap to see the preview",
    "printPdf.toast.uploadError": "We couldn't upload the image.",
    "printPdf.toast.downloadError": "We couldn't generate the PDF. Try again.",
    "printPdf.toast.saveError": "We couldn't save the design.",
    "printPdf.toast.savedSuccess": "Design saved.",
    "printPdfOutput.menu": "Menu",
    "printPdfOutput.allergens.sinTacc": "Gluten-free",
    "printPdfOutput.allergens.veg": "Vegetarian",
    "printPdfOutput.allergens.vegan": "Vegan",
    "printPdfOutput.scanQr": "Scan the QR to see the digital version",
    "printPdfOutput.findUs": "Find us",

    "menuEditor.recovery.title": "⚠️ Unsaved changes",
    "menuEditor.recovery.message": "Unsaved changes were found in this menu. Do you want to recover them and continue editing?",
    "menuEditor.recovery.disclaimer": "If you choose \"Discard\", all unsaved changes will be lost.",
    "menuEditor.recovery.discard": "Discard changes",
    "menuEditor.recovery.recover": "Recover and continue",
    "menuEditor.viewMenu": "View Menu",
    "menuEditor.editPrices": "Edit Prices",
    "menuEditor.editAvailability": "Pause Dishes",
    "menuEditor.updateMenu": "Update Menu",
    "menuEditor.addCategory": "Category",

    "globalPrice.title": "Global Price Editor",
    "globalPrice.searchPlaceholder": "Search product...",
    "globalPrice.allCategories": "All ({count})",
    "globalPrice.hideBulk": "Hide",
    "globalPrice.showBulk": "Bulk operations",
    "globalPrice.bulkPanel.title": "Apply change to all displayed products",
    "globalPrice.bulkPanel.noProducts": "No products to apply changes",
    "globalPrice.bulkPanel.productsCount": "Changes will apply to {count} visible product(s)",
    "globalPrice.bulk.percentage": "Percentage (%)",
    "globalPrice.bulk.fixedAmount": "Fixed amount ($)",
    "globalPrice.bulk.increase": "Increase",
    "globalPrice.bulk.decrease": "Decrease",
    "globalPrice.bulk.valuePlaceholder": "Value",
    "globalPrice.bulk.apply": "Apply",
    "globalPrice.noProductsFiltered": "No products found with the applied filters",
    "globalPrice.noProductsInMenu": "No products with prices in the menu",
    "globalPrice.table.product": "Product",
    "globalPrice.table.category": "Category",
    "globalPrice.table.priceType": "Price Type",
    "globalPrice.table.currentPrice": "Current Price",
    "globalPrice.table.newPrice": "New Price",
    "globalPrice.noName": "No name",
    "globalPrice.pricesCount": "prices",
    "globalPrice.unsavedChanges": "You have {count} unsaved change(s)",
    "globalPrice.modifiedCount": "{count} price(s) modified",
    "globalPrice.cancel": "Cancel",
    "globalPrice.saveChanges": "Save changes",
    "globalPrice.discardConfirm": "Discard all unsaved changes?",
    "globalPrice.toast.noProducts": "No products to apply changes",
    "globalPrice.toast.invalidValue": "Enter a valid value greater than zero",
    "globalPrice.toast.bulkApplied": "✅ {count} price changes applied. Review and press \"Save changes\".",

    // ─── Global Availability Editor ───
    "availability.title": "Pause / Activate Dishes",
    "availability.searchPlaceholder": "Search dish...",
    "availability.allCategories": "All categories ({count})",
    "availability.filterAll": "All",
    "availability.filterActive": "Active",
    "availability.filterPaused": "Paused",
    "availability.selectedCount": "{count} selected",
    "availability.activateSelected": "Activate selected",
    "availability.pauseSelected": "Pause selected",
    "availability.noProductsFiltered": "No dishes found with the applied filters",
    "availability.noProductsInMenu": "No dishes in the menu",
    "availability.colProduct": "Dish",
    "availability.colCategory": "Category",
    "availability.colStatus": "Status",
    "availability.colToggle": "Action",
    "availability.noName": "No name",
    "availability.statusActive": "Active",
    "availability.statusPaused": "Paused",
    "availability.toggleActive": "Active",
    "availability.togglePaused": "Paused",
    "availability.pendingChanges": "{count} unsaved change(s)",
    "availability.modifiedCount": "{count} dish(es) modified",
    "availability.pauseAll": "Pause all",
    "availability.activateAll": "Activate all",
    "availability.cancel": "Cancel",
    "availability.saveChanges": "Save changes",
    "availability.discardConfirm": "Discard all unsaved availability changes?",

    "catEditor.unnamed": "Unnamed category",
    "catEditor.paused": " (PAUSED)",
    "catEditor.addProduct": "Product",
    "catEditor.addSubCategory": "Sub-category",
    "catEditor.deleteCategory": "Delete Category",
    "catEditor.deleteSubcategory": "Delete Subcategory",
    "catEditor.deleteConfirmTitle": "Confirm Deletion",
    "catEditor.deleteConfirmMessage": "Are you sure you want to delete this category and all its products?",
    "catEditor.activate": "Activate",
    "catEditor.activateTitle": "Activate category",
    "catEditor.pause": "Pause",
    "catEditor.pauseTitle": "Pause category",

    "productEditor.unnamed": "Unnamed dish",
    "productEditor.tabInfo": "Information",
    "productEditor.tabImage": "Image",
    "productEditor.tabPrices": "Prices",
    "productEditor.spanish": "Spanish",
    "productEditor.english": "English",
    "productEditor.name": "Name",
    "productEditor.namePlaceholderEs": "Name in Spanish",
    "productEditor.namePlaceholderEn": "Name in English",
    "productEditor.description": "Description",
    "productEditor.descPlaceholderEs": "Description in Spanish",
    "productEditor.descPlaceholderEn": "Description in English",
    "productEditor.translateFailed": "Could not translate. Try again in a minute.",
    "productEditor.translateToEnglish": "Translate to English",
    "productEditor.specialTags": "Special Tags",
    "productEditor.tagVegan": "🌱 Vegan",
    "productEditor.tagGlutenFree": "🌾 Gluten Free",
    "productEditor.tagsHelp": "These tags will appear next to the product name in the menu",
    "productEditor.pricesTitle": "Product prices",
    "productEditor.noPrices": "No prices defined",
    "productEditor.noPricesHelp": "Add at least one price so your product appears in the menu.",
    "productEditor.activate": "Activate",
    "productEditor.pause": "Pause",
    "productEditor.delete": "Delete",
    "productEditor.deleteConfirmTitle": "Confirm Deletion",
    "productEditor.deleteConfirmMessage": "Are you sure you want to delete this product?",

    "imageEditor.previewAlt": "Image preview",
    "imageEditor.noImageAlt": "No image available",
    "imageEditor.upload": "Upload image",
    "imageEditor.view": "View image",
    "imageEditor.delete": "Delete",
    "imageEditor.uploading": "UPLOADING IMAGE...",
    "imageEditor.previewTitle": "Image Preview",
    "imageEditor.close": "Close",
    "imageEditor.deleteConfirmTitle": "Confirm Deletion",
    "imageEditor.deleteConfirmMessage": "Are you sure you want to delete this image?",
    "imageEditor.cancel": "Cancel",

    "priceTypes.title": "Price types",
    "priceTypes.placeholder": "E.g. Single, Double, Triple",
    "priceTypes.deleteAriaLabel": "Delete price type",
    "priceTypes.tip": "Enter a descriptive name for each price type (E.g. Single, Double, Triple).",
    "priceTypes.add": "Add price type",

    "bulkPrice.title": "Bulk price update",
    "bulkPrice.noProducts": "No products with prices to update.",
    "bulkPrice.typeLabel": "Update type",
    "bulkPrice.percentage": "Percentage (%)",
    "bulkPrice.fixedAmount": "Fixed amount ($)",
    "bulkPrice.operationLabel": "Operation",
    "bulkPrice.increase": "Increase",
    "bulkPrice.decrease": "Decrease",
    "bulkPrice.operationHelp": "Select whether you want to increase or decrease prices.",
    "bulkPrice.valueLabel.percentage": "Percentage to apply",
    "bulkPrice.valueLabel.fixedAmount": "Amount to apply",
    "bulkPrice.valueHelp.percentage": "Enter the percentage without the % symbol",
    "bulkPrice.valueHelp.fixedAmount": "Enter the amount without the $ symbol",
    "bulkPrice.previewTitle": "Preview of changes ({count} products)",
    "bulkPrice.table.product": "Product",
    "bulkPrice.table.priceType": "Price type",
    "bulkPrice.table.currentPrice": "Current price",
    "bulkPrice.table.newPrice": "New price",
    "bulkPrice.noPreview": "No products with prices to update or the entered value is not valid.",
    "bulkPrice.cancel": "Cancel",
    "bulkPrice.applying": "Applying...",
    "bulkPrice.apply": "Apply changes",
    "bulkPrice.error.invalidValue": "Please enter a valid value greater than zero",
    "bulkPrice.error.noChanges": "No changes to apply",
    "bulkPrice.noProductName": "Unnamed product",
    "bulkPrice.variantFallback": "Variant",

    "infoEditor.nameLabel": "Name",
    "infoEditor.namePlaceholder": "Add a name",
    "infoEditor.descriptionLabel": "Description",
    "infoEditor.descriptionPlaceholder": "Add a description",
    "infoEditor.translateToEnglish": "Translate to English",

    "qr.title": "QR Code - {name}",
    "qr.quantityLabel": "Number of QR codes per sheet:",
    "qr.count1": "1 QR code",
    "qr.count4": "4 QR codes",
    "qr.count6": "6 QR codes",
    "qr.count9": "9 QR codes",
    "qr.count12": "12 QR codes",
    "qr.print": "Print QR",
    "qr.download": "Download QR",
    "qr.close": "Close",

    "modal.cancel": "Cancel",
    "modal.confirm": "Confirm",

    "createMenu.comingSoon": "Coming soon!",

    "testimonials.slideLabel": "Go to testimonial {index}",

    "context.defaultPriceType": "Price",
    "context.newPriceType": "New price",
    "context.toast.maxPriceTypes": "Maximum 5 price types allowed",
    "context.toast.minPriceTypes": "Must keep at least one price type configured",
    "context.toast.saveSuccess": "Your menu has been saved successfully to the server",
    "context.toast.saveError": "Could not save the menu. Check your connection and try again.",
    "context.toast.menuNotFound": "The menu file does not exist on the server. Create a new one from the list.",
    "context.alert.menuFileNotFound": "The menu file was not found. Go back to the list and try creating it again or wait a few seconds and reload.",
    "context.error.invalidImage": "The selected file is not a supported image.",

    "constants.spanish": "Spanish",
    "constants.english": "English",
    "constants.price": "Price",
    "constants.simple": "Single",
    "constants.double": "Double",
    "constants.small": "Small",
    "constants.medium": "Medium",
    "constants.large": "Large",

    // ─── Home (landing page) ───
    "home.badge": "200+ menus created",
    "home.hero.title1": "The digital menu",
    "home.hero.title2": "your customers",
    "home.hero.title3": "will love",
    "home.hero.sub": "We build premium digital menus for restaurants across Argentina. QR, multi-language, HD photos, instant updates.",
    "home.hero.ctaPrimary": "I want my menu",
    "home.hero.ctaGhost": "See examples",
    "home.hero.scroll": "Scroll",

    "home.stats.menus": "Menus created",
    "home.stats.provinces": "Provinces",
    "home.stats.years": "Years",
    "home.stats.google": "Google",

    "home.showcase.tag": "Portfolio",
    "home.showcase.title1": "Real menus,",
    "home.showcase.title2": "live",
    "home.showcase.sub": "Each phone shows a real menu running right now. Tap any to explore.",
    "home.showcase.prev": "Previous",
    "home.showcase.next": "Next",

    "home.map.tag": "Coverage",
    "home.map.title1": "From Jujuy to",
    "home.map.title2": "Tierra del Fuego",
    "home.map.sub": "{count} restaurants across {provinces} provinces. Every dot is a real client.",
    "home.map.restaurants": "{count} restaurants",
    "home.map.viewMenu": "View menu",
    "home.map.filterAll": "All",

    "home.rubros.restoran": "Restaurant",
    "home.rubros.parrilla": "Steakhouse",
    "home.rubros.pizzeria": "Pizzeria",
    "home.rubros.hamburgueseria": "Burger Joint",
    "home.rubros.bar": "Bar",
    "home.rubros.sushi": "Sushi",
    "home.rubros.cafeteria": "Café",
    "home.rubros.cerveceria": "Brewery",
    "home.rubros.fastfood": "Fast Food",
    "home.rubros.wineBar": "Wine Bar",
    "home.rubros.italiana": "Italian",
    "home.rubros.foodtruck": "Foodtruck",

    "home.proof.tag": "Reviews",
    "home.proof.title1": "What",
    "home.proof.title2": "our clients say",
    "home.proof.googleLink": "See reviews on Google",
    "home.proof.testimonial1.text": "Excellent service, very fast and attentive. The digital menu came out amazing, my customers love it.",
    "home.proof.testimonial1.author": "Pablo M.",
    "home.proof.testimonial1.place": "Encrucijada, Santa Fe",
    "home.proof.testimonial2.text": "Super professional. They built everything in a day and it looks perfect on mobile. 100% recommended.",
    "home.proof.testimonial2.author": "Ornella F.",
    "home.proof.testimonial2.place": "La Pescería, Buenos Aires",
    "home.proof.testimonial3.text": "The best investment for my restaurant. Customers scan the QR and get everything instantly.",
    "home.proof.testimonial3.author": "Carolina R.",
    "home.proof.testimonial3.place": "Hotel La María, Mendoza",

    "home.features.tag": "Product",
    "home.features.title1": "Everything you",
    "home.features.title2": "need",
    "home.features.photos.title": "HD photos",
    "home.features.photos.desc": "Every dish at its best",
    "home.features.update.title": "Instant updates",
    "home.features.update.desc": "Change prices and dishes on the fly",
    "home.features.multilang.title": "Multi-language",
    "home.features.multilang.desc": "Spanish, English and Portuguese",
    "home.features.qr.title": "Custom QR",
    "home.features.qr.desc": "With your logo and colors",
    "home.features.fast.title": "Ultra-fast loading",
    "home.features.fast.desc": "Under 1 second",
    "home.features.support.title": "Dedicated support",
    "home.features.support.desc": "We help with everything",

    "home.contact.tag": "Contact",
    "home.contact.title1": "Start",
    "home.contact.title2": "today",
    "home.contact.desc": "Fill out the form and we'll get back to you within 24h with your menu ready to review.",
    "home.contact.benefit1": "Custom design",
    "home.contact.benefit2": "Ready in 24-48 hours",
    "home.contact.benefit3": "QR ready to print",
    "home.contact.benefit4": "Ongoing support",
    "home.contact.success.title": "Message sent",
    "home.contact.success.desc": "We'll contact you soon with your menu ready.",
    "home.contact.step1": "Info",
    "home.contact.step2": "Contact",
    "home.contact.step3": "Message",
    "home.contact.nameLabel": "Your name",
    "home.contact.namePlaceholder": "John Smith",
    "home.contact.businessLabel": "Business name",
    "home.contact.businessPlaceholder": "My Restaurant",
    "home.contact.phoneLabel": "Phone",
    "home.contact.phonePlaceholder": "11 2345-6789",
    "home.contact.emailLabel": "Email",
    "home.contact.emailPlaceholder": "john@email.com",
    "home.contact.messageLabel": "Message (optional)",
    "home.contact.messagePlaceholder": "Tell us about your business...",
    "home.contact.back": "Back",
    "home.contact.next": "Next",
    "home.contact.submit": "Send",
    "home.contact.submitting": "Sending...",

    "home.footer.brandDesc": "Premium digital menus for restaurants across Argentina.",
    "home.footer.product": "Product",
    "home.footer.examples": "See examples",
    "home.footer.contact": "Contact",
    "home.footer.legal": "Legal",
    "home.footer.privacy": "Privacy",
    "home.footer.terms": "Terms",
    "home.footer.dataDeletion": "Data deletion",
    "home.footer.social": "Social",

    "home.whatsapp.aria": "Contact via WhatsApp",
    "home.whatsapp.text": "Hi! I'm interested in a digital menu for my restaurant",

    // ─── Costs & Profit ───
    "costs.title": "Costs & Profit",
    "costs.subtitle": "Load ingredients and recipes to see how much each dish costs you to make and how much profit you keep.",
    "costs.back": "Back to menu",
    "costs.tabs.dashboard": "Overview",
    "costs.tabs.products": "My dishes",
    "costs.tabs.ingredients": "Ingredients",
    "costs.tabs.subRecipes": "Base preps",
    "costs.tabs.settings": "Settings",

    "costs.empty.title": "Start by adding ingredients",
    "costs.empty.desc": "Add the ingredients you use, then build the recipe of each dish.",
    "costs.empty.cta": "Add first ingredient",

    "costs.onboarding.title": "👋 Get started in 3 steps",
    "costs.onboarding.subtitle": "We'll help you see how much each dish costs and how much profit you keep. Easier than it looks.",
    "costs.onboarding.step1Title": "Load your ingredients",
    "costs.onboarding.step1Desc": "Things like flour, oil, ground beef... and what each one costs you per kilo or liter. We have a list of typical ingredients to get you started fast.",
    "costs.onboarding.step1Cta": "Load ingredients",
    "costs.onboarding.step2Title": "Tell us what each dish has",
    "costs.onboarding.step2Desc": "For each dish, say which ingredients it uses and how much. For example: a burger has 180g beef, 1 bun, 30g cheese.",
    "costs.onboarding.step2Cta": "Go to my dishes",
    "costs.onboarding.step2Locked": "Load ingredients first",
    "costs.onboarding.step3Title": "See your profit",
    "costs.onboarding.step3Desc": "We'll show you how much each dish costs to make, how much profit you keep, and warn you if any is losing money.",
    "costs.onboarding.step3Locked": "Load costs for your dishes first",
    "costs.onboarding.simpleNote": "💡 Want to go faster? You can skip ingredients and load an approximate total cost on each dish.",

    "costs.dashboard.avgFc": "Average dish cost",
    "costs.dashboard.avgMargin": "Average profit",
    "costs.dashboard.coverage": "{covered} of {total} dishes costed",
    "costs.dashboard.coverageHint": "complete the rest",
    "costs.dashboard.topRentables": "Most profitable",
    "costs.dashboard.bottomRentables": "Least profitable",
    "costs.dashboard.inDanger": "Almost no profit / losing money",
    "costs.dashboard.noData": "Add some recipes to see your overview",
    "costs.dashboard.noDanger": "All your dishes have good profit 👌",
    "costs.dashboard.alertsTitle": "Watch these dishes",
    "costs.dashboard.alertEmpty": "Nothing urgent right now",
    "costs.dashboard.recalcCta": "🔄 Update ingredient prices",

    "costs.status.healthy": "Good profit",
    "costs.status.warning": "Tight profit",
    "costs.status.danger": "Almost no profit",
    "costs.status.unknown": "No data",

    "costs.product.noCost": "No cost loaded",
    "costs.product.cargar": "Add cost",
    "costs.product.editCost": "Edit cost",
    "costs.product.deleteCost": "Remove cost",
    "costs.product.foodCost": "What it costs you",
    "costs.product.foodCostShort": "Cost",
    "costs.product.margin": "Profit",
    "costs.product.suggested": "Suggested price",
    "costs.product.suggestedHint": "So cost is {target}% of price",
    "costs.product.byPrice": "Your menu price and what you keep",
    "costs.product.priceLabelSell": "You sell at",
    "costs.product.priceLabelLeftover": "you keep",
    "costs.product.priceLabelMarginShort": "profit",
    "costs.product.youKeep": "you keep",
    "costs.product.searchPlaceholder": "Search dish...",
    "costs.product.filter.all": "All",
    "costs.product.filter.uncosted": "No cost",
    "costs.product.filter.danger": "At risk",
    "costs.product.sort.name": "Name",
    "costs.product.sort.foodCost": "% Cost",
    "costs.product.empty": "This menu has no dishes yet. Add them from the editor.",

    "costs.drawer.title": "Add cost: {productName}",
    "costs.drawer.intro": "Let's calculate what this dish costs you to make.",
    "costs.drawer.modeQuick": "Total cost only",
    "costs.drawer.modeQuickDesc": "Throw in an approximate number. Quick but doesn't auto-update when prices change.",
    "costs.drawer.modeRecipe": "Detail ingredients",
    "costs.drawer.modeRecipeDesc": "Say how much of each ingredient it uses. When a price goes up, all dishes using it recalculate automatically. Most useful with inflation.",
    "costs.drawer.modeRecipeLocked": "🔒 Load ingredients first to use this mode",
    "costs.drawer.modeChange": "Change mode",
    "costs.drawer.quickHelp": "Throw in an approximate number of what one serving costs you (ingredients + gas + whatever).",
    "costs.drawer.quickLabel": "Cost per serving",
    "costs.drawer.recipeHelp": "For each ingredient, say how much one serving uses. Example: a burger has 180g of ground beef, 1 bun, 30g of cheese.",
    "costs.drawer.recipeEmpty": "Start by adding an ingredient below 👇",
    "costs.drawer.addIngredient": "+ Add ingredient",
    "costs.drawer.addSubRecipe": "+ Add base prep",
    "costs.drawer.notes": "Notes (optional)",
    "costs.drawer.notesPlaceholder": "Anything you want to remember.",
    "costs.drawer.indirectOverride": "Other costs for this dish (electricity, gas, payroll)",
    "costs.drawer.indirectGlobal": "Default: {percent}% (adjust in Settings)",
    "costs.drawer.indirectClear": "Use default again",
    "costs.drawer.save": "Save",
    "costs.drawer.cancel": "Cancel",
    "costs.drawer.close": "Close",
    "costs.drawer.summary": "Summary",
    "costs.drawer.summaryDirect": "Ingredients",
    "costs.drawer.summaryIndirect": "Other costs",
    "costs.drawer.summaryTotal": "Total: what it costs to make",

    "costs.recipeLine.helpHeader": "Ingredient · Amount · Waste % (if some is lost when peeling/cutting)",
    "costs.recipeLine.amount": "Amount",
    "costs.recipeLine.unit": "Unit",
    "costs.recipeLine.waste": "Waste %",
    "costs.recipeLine.wasteHint": "Set if peeling/cutting loses some. Ex: potatoes 10%, beef 5%. Otherwise leave 0.",
    "costs.recipeLine.remove": "Remove",
    "costs.recipeLine.unitMismatch": "⚠️ Unit doesn't match {ingredient}",
    "costs.recipeLine.pickIngredient": "Pick an ingredient",
    "costs.recipeLine.pickSubRecipe": "Pick a base prep",
    "costs.recipeLine.cost": "Line cost",

    "costs.library.title": "Ingredient library",
    "costs.library.subtitle": "Load ingredients with their price once. When a price changes, update it here and every dish using it auto-updates.",
    "costs.library.add": "+ Add ingredient",
    "costs.library.search": "Search ingredient...",
    "costs.library.empty": "No ingredients yet",
    "costs.library.emptyDesc": "Fastest way: pick from the typical Argentine kitchen list and just enter the price.",
    "costs.library.fromPreset": "🇦🇷 Typical ingredients list",
    "costs.library.fromScratch": "Create new",
    "costs.library.importFromMenu": "Import from another menu",
    "costs.library.history": "History",
    "costs.library.lastUpdated": "Updated: {date}",
    "costs.library.usedIn": "Used in {count}",
    "costs.library.notUsed": "Not used",

    "costs.ingredient.modal.titleNew": "New ingredient",
    "costs.ingredient.modal.titleEdit": "Edit ingredient",
    "costs.ingredient.modal.name": "Name",
    "costs.ingredient.modal.namePlaceholder": "Ex: Ground beef",
    "costs.ingredient.modal.cost": "How much it costs you",
    "costs.ingredient.modal.costHint": "What you pay when buying. Ex: $4500 per kilo.",
    "costs.ingredient.modal.unit": "Purchase unit",
    "costs.ingredient.modal.unitHint": "kg = kilo, g = gram, lt = liter, ml = milliliter, u = unit.",
    "costs.ingredient.modal.supplier": "Supplier (optional)",
    "costs.ingredient.modal.supplierPlaceholder": "Ex: Frigorífico X",
    "costs.ingredient.modal.save": "Save",
    "costs.ingredient.modal.cancel": "Cancel",
    "costs.ingredient.modal.history": "Price history",
    "costs.ingredient.modal.noHistory": "No changes recorded yet",

    "costs.ingredient.delete.title": "Delete ingredient",
    "costs.ingredient.delete.simple": "Delete this ingredient?",
    "costs.ingredient.delete.inUse": "This ingredient is used in {count} places. Deleting will remove it from all recipes that use it.",
    "costs.ingredient.delete.confirm": "Yes, delete",
    "costs.ingredient.delete.forceConfirm": "Delete anyway",

    "costs.preset.title": "Argentine kitchen presets",
    "costs.preset.subtitle": "Tick the ingredients you use and just enter the price.",
    "costs.preset.cat.meats": "Meats & poultry",
    "costs.preset.cat.fish": "Fish",
    "costs.preset.cat.dairy": "Dairy & eggs",
    "costs.preset.cat.veggies": "Veggies & fruits",
    "costs.preset.cat.pantry": "Pantry",
    "costs.preset.cat.oils": "Oils & vinegar",
    "costs.preset.cat.canned": "Canned",
    "costs.preset.cat.drinks": "Drinks",
    "costs.preset.cat.bakery": "Bakery",
    "costs.preset.use": "Use",
    "costs.preset.alreadyAdded": "Already in your library",

    "costs.subRecipe.title": "Base preparations",
    "costs.subRecipe.subtitle": "Preparations you use in several dishes (sauces, doughs, marinades). Load ingredients once and reuse them like an ingredient in any dish.",
    "costs.subRecipe.add": "+ New base prep",
    "costs.subRecipe.empty": "No base preparations yet",
    "costs.subRecipe.usedIn": "Used in {count} dishes",
    "costs.subRecipe.modal.titleNew": "New base prep",
    "costs.subRecipe.modal.titleEdit": "Edit base prep",
    "costs.subRecipe.modal.name": "Name",
    "costs.subRecipe.modal.namePlaceholder": "Ex: Bolognese sauce, Pizza dough",
    "costs.subRecipe.modal.yield": "How much it yields",
    "costs.subRecipe.modal.yieldHint": "How much comes out total. Ex: 2000 g of sauce, 1.5 lt of juice, 12 dough units.",
    "costs.subRecipe.modal.computed": "Costs you {cost} total ({perUnit} per {unit})",
    "costs.subRecipe.modal.notComputed": "Add ingredients to calculate cost",

    "costs.massRecalc.title": "Update ingredient prices",
    "costs.massRecalc.subtitle": "If prices went up, enter the new costs here. Every dish using those ingredients recalculates automatically.",
    "costs.massRecalc.cta": "🔄 Update prices",
    "costs.massRecalc.newCost": "New price",
    "costs.massRecalc.unchanged": "Unchanged",
    "costs.massRecalc.preview": "Preview",
    "costs.massRecalc.changesCount": "{count} ingredients with new price",
    "costs.massRecalc.affectedProducts": "{count} dishes will update",
    "costs.massRecalc.crossDanger": "{count} dishes will lose profit",
    "costs.massRecalc.apply": "Apply changes",
    "costs.massRecalc.cancel": "Cancel",
    "costs.massRecalc.empty": "No ingredients loaded yet",

    "costs.settings.title": "Settings",
    "costs.settings.indirect": "Other costs per dish %",
    "costs.settings.indirectHint": "Percentage added by default to each dish to account for gas, electricity, payroll. Typical: 15-20%.",
    "costs.settings.target": "Target dish cost %",
    "costs.settings.targetHint": "How much you want the cost to represent within sale price. Ideal: 28-35%. We use this to suggest prices.",
    "costs.settings.subRecipes": "Use base preparations",
    "costs.settings.subRecipesHint": "Turn on if you have sauces, doughs, or stocks used in several dishes. Otherwise, no need.",
    "costs.settings.save": "Save settings",

    "costs.import.title": "Import from another menu",
    "costs.import.desc": "Pull ingredients (and optionally sub-recipes) from another of your menus. If you already have ingredients with the same name, they aren't overwritten.",
    "costs.import.menuLabel": "Source menu",
    "costs.import.includeSub": "Include sub-recipes",
    "costs.import.btn": "Import",
    "costs.import.cancel": "Cancel",
    "costs.import.noOtherMenus": "No other menus with costs loaded.",

    "costs.currency.warningTitle": "Currencies don't match",
    "costs.currency.warningDesc": "Your costs are loaded in {costsCurrency} but the menu is in {menuCurrency}. Review the values manually.",

    "costs.toast.saved": "Saved",
    "costs.toast.saveError": "Save error",
    "costs.toast.imported": "Data imported",
    "costs.toast.deleted": "Deleted",

    "costs.menuDashboard.title": "Costs & Profit",
    "costs.menuDashboard.desc": "See how much each dish costs to make, how much profit you keep, and what price to charge.",
    "costs.menuDashboard.cta": "Open calculator",
  },

  // ═══════════════════════════════════════════
  //  PORTUGUÊS
  // ═══════════════════════════════════════════
  pt: {
    "editor.loading": "Carregando cardápio...",
    "editor.notFound": "Cardápio não encontrado",
    "editor.backToProfile": "Voltar ao Perfil",
    "editor.brand": "RestaurAdmin",
    "editor.brandSub": "Editor V2",
    "editor.viewMenu": "Ver Cardápio",
    "editor.save": "🚀 Publicar Cardápio",
    "editor.saveMobile": "🚀 Publicar",
    "editor.saving": "⏳ Publicando...",
    "editor.unsaved": "● Alterações não publicadas",
    "editor.unsavedMobile": "● Não publicado",
    "editor.published": "✓ Publicado",

    "nav.general": "Geral",
    "nav.generalShort": "Geral",
    "nav.restaurant": "Info do Restaurante",
    "nav.restaurantShort": "Info",
    "nav.catalog": "Catálogo",
    "nav.catalogShort": "Catálogo",
    "nav.modules": "Módulos",
    "nav.modulesShort": "Módulos",
    "nav.preview": "Pré-visualização",
    "nav.previewShort": "Preview",

    "general.languages": "🌐 Idiomas do Cardápio",
    "general.languagesDesc": "Configure os idiomas disponíveis. O idioma padrão é exibido primeiro para seus clientes.",
    "general.defaultLang": "Idioma Padrão",
    "general.additionalLangs": "Idiomas Adicionais",
    "general.addLang": "+ Adicionar Idioma",
    "general.removeLangTitle": "Remover idioma?",
    "general.removeLangMsg": "O idioma {lang} e todas as suas traduções serão removidos.",
    "general.removeLangConfirm": "Remover",
    "general.aboutLangs": "Sobre os idiomas",
    "general.aboutLangsDesc": "Ao adicionar um novo idioma, você pode traduzir automaticamente todo o conteúdo existente ou preencher as traduções manualmente em cada seção.",
    "general.autoTranslateTitle": "Traduzir automaticamente?",
    "general.autoTranslateMsg": "Você adicionou \"{lang}\". Deseja traduzir automaticamente todo o conteúdo?",
    "general.autoTranslateManual": "Vou traduzir manualmente",
    "general.autoTranslateAuto": "✨ Traduzir tudo",
    "general.autoTranslating": "⏳ Traduzindo...",
    "general.currency": "Moeda",
    "general.timezone": "🕐 Fuso Horário",
    "general.timezoneDesc": "Configure o fuso horário do seu restaurante. Usado para mostrar ou ocultar categorias conforme o horário (faixas horárias).",
    "general.timezoneLabel": "Fuso Horário do Restaurante",
    "general.fonts": "🔤 Tipografias",
    "general.fontsDesc": "Use as setas para navegar e ver como cada fonte fica ao vivo.",
    "general.fontHeading": "FONTE DE TÍTULOS",
    "general.fontHeadingPreview": "Entradas · Pratos Principais",
    "general.fontBody": "FONTE DO CORPO",
    "general.fontBodyPreview": "Hambúrguer clássico com queijo cheddar, alface e tomate.",

    "general.colors": "🎨 Cores do Menu",
    "general.colorsDesc": "Personalize as cores de fundo, tipografia e capa do menu.",
    "general.colorReset": "Redefinir",

    "general.themeAccent": "DESTAQUE",
    "general.themeAccentReset": "↩ Redefinir",
    "general.themeAdvanced": "AJUSTES AVANÇADOS",
    "general.themeAdvancedClearAll": "Limpar tudo",
    "general.themeAdvancedHint": "Ajuste cores individuais sobre o tema base. O botão ↩ restaura o valor original do tema.",
    "general.themeGroupBody": "Corpo do menu",
    "general.themeGroupHero": "Capa / Hero",
    "general.tokenBg": "Fundo geral",
    "general.tokenSurface": "Cards / Superfícies",
    "general.tokenText": "Texto principal",
    "general.tokenTextSec": "Texto secundário",
    "general.tokenTextMuted": "Texto atenuado",
    "general.tokenBorder": "Bordas",
    "general.tokenDivider": "Divisor produtos",
    "general.tokenHeaderBg": "Fundo da capa",
    "general.tokenHeaderText": "Texto da capa",
    "general.previewHeroSub": "Capa",
    "general.previewCat1": "Entradas",
    "general.previewCat2": "Pratos principais",
    "general.previewProduct": "Hambúrguer clássico",
    "general.previewProductDesc": "Com queijo cheddar, alface e tomate.",
    "general.previewAllergens": "(V) (G)",
    "general.previewHoursLabel": "🕐 Horários",
    "general.previewHoursDay": "● Segunda",
    "general.previewHoursTime": "12:00 – 23:00",
    "general.previewFooter": "Cardápio digital por",

    "currency.ARS": "Peso Argentino",
    "currency.USD": "Dólar Americano",
    "currency.EUR": "Euro",
    "currency.BRL": "Real Brasileiro",
    "currency.MXN": "Peso Mexicano",

    "tz.ar": "🇦🇷 Argentina (Buenos Aires)",
    "tz.mx": "🇲🇽 México (Cidade do México)",
    "tz.cl": "🇨🇱 Chile (Santiago)",
    "tz.co": "🇨🇴 Colômbia (Bogotá)",
    "tz.pe": "🇵🇪 Peru (Lima)",
    "tz.uy": "🇺🇾 Uruguai (Montevidéu)",
    "tz.br": "🇧🇷 Brasil (São Paulo)",
    "tz.ve": "🇻🇪 Venezuela (Caracas)",
    "tz.ec": "🇪🇨 Equador (Guayaquil)",
    "tz.py": "🇵🇾 Paraguai (Assunção)",
    "tz.bo": "🇧🇴 Bolívia (La Paz)",
    "tz.pa": "🇵🇦 Panamá",
    "tz.cr": "🇨🇷 Costa Rica",
    "tz.usEast": "🇺🇸 Estados Unidos (Leste)",
    "tz.usPacific": "🇺🇸 Estados Unidos (Pacífico)",
    "tz.usCentral": "🇺🇸 Estados Unidos (Central)",
    "tz.es": "🇪🇸 Espanha (Madri)",
    "tz.gb": "🇬🇧 Reino Unido (Londres)",
    "tz.fr": "🇫🇷 França (Paris)",
    "tz.it": "🇮🇹 Itália (Roma)",
    "tz.de": "🇩🇪 Alemanha (Berlim)",

    "info.images": "📷 Imagens do Restaurante",
    "info.logo": "Logo",
    "info.cover": "Capa",
    "info.coverBgColor": "Cor de Fundo da Capa",
    "info.uploading": "Enviando...",
    "info.clickUpload": "Clique para enviar {type}",
    "info.dropHint": "ou arraste uma imagem aqui",
    "info.dropActive": "Solte para enviar",
    "info.imgFormats": "PNG, JPG",
    "info.uploadError": "Erro ao enviar a imagem.",
    "info.basic": "ℹ️ Informações Básicas",
    "info.default": "Padrão",
    "info.name": "Nome do Restaurante",
    "info.namePlaceholder": "Nome...",
    "info.description": "Descrição",
    "info.descPlaceholder": "Descrição breve...",
    "info.social": "🔗 Redes Sociais",
    "info.instagram": "📸 Instagram",
    "info.instagramPlaceholder": "@usuário",
    "info.facebook": "👤 Facebook",
    "info.facebookPlaceholder": "URL ou usuário",
    "info.whatsapp": "💬 WhatsApp",
    "info.whatsappPlaceholder": "+55 11 91234-5678",
    "info.website": "🌐 Site",
    "info.websitePlaceholder": "https://...",
    "info.googleMaps": "⭐ Google Maps / Avaliações",
    "info.googleMapsPlaceholder": "https://maps.google.com/...",
    "info.wifi": "📶 WiFi do Local",
    "info.wifiName": "Nome da Rede",
    "info.wifiNamePlaceholder": "WiFi-Restaurante",
    "info.wifiPassword": "Senha",
    "info.wifiPasswordPlaceholder": "senha123",
    "info.hours": "🕐 Horário de Funcionamento",
    "info.timeTo": "a",
    "info.addRange": "+ Adicionar faixa",
    "info.closed": "Fechado",

    "day.monday": "Segunda",
    "day.tuesday": "Terça",
    "day.wednesday": "Quarta",
    "day.thursday": "Quinta",
    "day.friday": "Sexta",
    "day.saturday": "Sábado",
    "day.sunday": "Domingo",

    "catalog.search": "Buscar...",
    "catalog.newCategory": "Nova Categoria",
    "catalog.newCategoryShort": "Categoria",
    "catalog.empty": "Nenhuma categoria ainda",
    "catalog.createFirst": "Criar Primeira Categoria",
    "catalog.hidden": "OCULTA",
    "catalog.paused": "PAUSADA",
    "catalog.items": "itens",
    "catalog.visible": "👁️ Visível",
    "catalog.hiddenBtn": "🚫 Oculta",
    "catalog.prices": "💲 Preços",
    "catalog.edit": "✏️ Editar",
    "catalog.delete": "🗑️",
    "catalog.addSubcategory": "📂 + Sub-categoria",
    "catalog.addProduct": "+ Produto",
    "catalog.noProducts": "Sem produtos",
    "catalog.addProductLink": "+ Adicionar produto",
    "catalog.noName": "Sem nome",
    "catalog.bulkAdjust": "Ajustar:",
    "catalog.bulkApply": "Aplicar",
    "catalog.bulkTitle": "Ajuste em massa",
    "catalog.bulkIncrease": "Aumentar preços de \"{name}\" em {pct}%?",
    "catalog.bulkDecrease": "Diminuir preços de \"{name}\" em {pct}%?",
    "catalog.bulkFixedIncrease": "Adicionar ${amount} a todos os preços de \"{name}\"?",
    "catalog.bulkFixedDecrease": "Subtrair ${amount} de todos os preços de \"{name}\"?",
    "catalog.editPrice": "Editar preço",
    "catalog.hide": "Ocultar",
    "catalog.show": "Mostrar",
    "catalog.editAction": "Editar",
    "catalog.deleteAction": "Excluir",
    "catalog.deleteTitle": "Excluir categoria?",
    "catalog.deleteMsg": "\"{name}\" e todos os seus produtos serão excluídos.",
    "catalog.deleteConfirm": "Excluir",
    "catalog.deleteProductTitle": "Excluir produto?",
    "catalog.deleteProductMsg": "Este produto será removido do catálogo.",
    "catalog.deleteProductConfirm": "Excluir",

    "product.edit": "✏️ Editar Produto",
    "product.new": "✨ Novo Produto",
    "product.tabBasic": "Básico",
    "product.tabLangs": "Idiomas",
    "product.tabTags": "Tags",
    "product.tabExtras": "Extras",
    "product.image": "Imagem do Produto",
    "product.uploadImage": "Enviar imagem",
    "product.dropHint": "ou arraste aqui",
    "product.dropActive": "Solte para enviar",
    "product.uploading": "Enviando...",
    "product.imgFormats": "PNG, JPG (máx 800px)",
    "product.name": "Nome ({lang}) *",
    "product.namePlaceholder": "Ex: Hambúrguer Clássico",
    "product.desc": "Descrição ({lang})",
    "product.descPlaceholder": "Descrição do produto...",
    "product.prices": "Preços ({symbol})",
    "product.enabled": "Produto Habilitado",
    "product.enabledDesc": "Visível no cardápio público",
    "product.noLangs": "Nenhum idioma adicional configurado",
    "product.noLangsDesc": "Adicione idiomas na seção Geral",
    "product.translate": "🌐 Traduzir",
    "product.translating": "⏳ Traduzindo...",
    "product.translateAll": "🌐 Traduzir para todos os idiomas",
    "product.translatingAll": "⏳ Traduzindo para todos os idiomas...",
    "product.tags": "Tags",
    "product.customTag": "+ Tag personalizada",
    "product.allergens": "Alérgenos",
    "product.customAllergen": "+ Adicionar Alérgeno",
    "product.modifiers": "Modificadores / Extras",
    "product.modifiersDesc": "Opções adicionais para este produto (ex: queijo extra, sem sal)",
    "product.addModifier": "+ Adicionar Modificador",
    "product.modName": "Nome ({lang})",
    "product.modPrice": "Preço",
    "product.save": "Salvar Alterações",
    "product.create": "Criar Produto",
    "product.cancel": "Cancelar",

    "tag.vegan": "🌱 Vegano",
    "tag.vegetarian": "🥬 Vegetariano",
    "tag.glutenFree": "🌾 Sem Glúten",
    "tag.popular": "🔥 Popular",
    "tag.new": "✨ Novo",
    "tag.spicy": "🌶️ Picante",
    "tag.recommended": "⭐ Recomendado",
    "tag.noMeat": "🐟 Sem Carne",
    "tag.nutFree": "🥜 Sem Nozes",
    "tag.organic": "🍃 Orgânico",

    "category.edit": "✏️ Editar Categoria",
    "category.new": "📂 Nova Categoria",
    "category.newSub": "📂 Nova Sub-categoria",
    "category.name": "Nome da Categoria *",
    "category.descLabel": "Descrição (Opcional)",
    "category.descPlaceholder": "Descrição breve desta categoria...",
    "category.priceTypes": "💲 Tipos de Preço",
    "category.priceTypesAdd": "+ Adicionar",
    "category.priceTypesDesc": "Ex: \"Pequena\", \"Média\", \"Grande\" para bebidas.",
    "category.priceTypePlaceholder": "Nome do tipo de preço",
    "category.status": "Status da Categoria",
    "category.statusDesc": "Categorias pausadas não aparecem no cardápio",
    "category.schedule": "🕐 Faixa Horária",
    "category.scheduleDesc": "Se ativo, esta categoria só aparece durante o horário configurado.",
    "category.scheduleFrom": "De",
    "category.scheduleTo": "Até",
    "category.addRange": "+ Adicionar faixa",
    "category.save": "Salvar Alterações",
    "category.create": "Criar Categoria",
    "category.cancel": "Cancelar",
    "category.translate": "🌐 Traduzir",
    "category.translating": "⏳ Traduzindo...",
    "category.nameRequired": "O nome em {lang} é obrigatório",
    "category.minPriceType": "Deve haver pelo menos um tipo de preço",
    "category.maxPriceType": "Máximo de 4 tipos de preço permitidos",
    "category.namePlaceholder": "Ex: Entradas, Pratos Principais...",
    "category.priceDefault": "Preço",
    "category.priceNew": "Novo Tipo",
    "category.deletePriceType": "Excluir tipo de preço",
    "modules.dailyTitleDefault": "Prato do Dia",
    "modules.announcementCta": "Entendido!",
    "bulkPrice.simple": "Simples",
    "bulkPrice.doble": "Duplo",
    "bulkPrice.variante": "Variante",
    "bulkPrice.noName": "Produto sem nome",
    "bulkPrice.errorApply": "Ocorreu um erro ao aplicar as alterações: {error}",
    "bulkPrice.errorPreview": "Erro ao gerar pré-visualização: {error}",
    "bulkPrice.exPercent": "Ex: 10",
    "bulkPrice.exFixed": "Ex: 500",

    "modules.title": "Módulos",
    "modules.desc": "Ative funcionalidades extras para seu cardápio digital",
    "modules.daily": "🍽️ Pratos do Dia",
    "modules.dailyDesc": "Destaque pratos especiais no topo do seu cardápio",
    "modules.dailyTitle": "Título da seção",
    "modules.dailyTitlePlaceholder": "🍽️ Pratos do Dia",
    "modules.dailyDescLabel": "Descrição (opcional)",
    "modules.dailyDescPlaceholder": "Ex: Disponível apenas hoje",
    "modules.displayStyle": "Estilo de exibição",
    "modules.styleBanner": "Banner",
    "modules.styleCard": "Cartão",
    "modules.styleHighlight": "Destaque",
    "modules.selectedItems": "Pratos selecionados ({count})",
    "modules.noItemsYet": "Nenhum prato selecionado ainda",
    "modules.noItemsDesc": "Selecione produtos do catálogo ou crie um personalizado",
    "modules.itemNoName": "Sem nome",
    "modules.itemNamePlaceholder": "Nome do prato",
    "modules.originalPrice": "Preço original: ",
    "modules.customItem": "Prato personalizado",
    "modules.price": "Preço",
    "modules.specialPrice": "Preço especial",
    "modules.activateItem": "Ativar prato",
    "modules.pauseItem": "Pausar prato (não será exibido)",
    "modules.itemHidden": "🚫 Oculto",
    "modules.itemDescPlaceholder": "Descrição (opcional)",
    "modules.itemUploading": "⏳ Enviando...",
    "modules.itemPhoto": "📸 Foto",
    "modules.deletedProduct": "Produto excluído",
    "modules.uploadError": "Erro ao enviar a imagem. Tente novamente.",
    "modules.createCustom": "🍽️ Criar prato personalizado",
    "modules.newCustomItem": "Novo prato personalizado",
    "modules.customNamePlaceholder": "Nome do prato",
    "modules.customPricePlaceholder": "Preço",
    "modules.customDescPlaceholder": "Descrição (opcional)",
    "modules.customAdd": "Adicionar",
    "modules.customCancel": "Cancelar",
    "modules.selectProduct": "Selecionar produto do catálogo",
    "modules.addFromCatalog": "⭐ Adicionar prato do catálogo",
    "modules.searchCatalogPlaceholder": "🔍 Buscar no seu catálogo...",
    "modules.searchProducts": "Buscar produtos...",
    "modules.noResults": "Nenhuma correspondência encontrada",
    "modules.noResultsFor": "Sem resultados para \"{term}\"",
    "modules.noCatalogProducts": "Sem produtos no catálogo",
    "modules.noCatalogProductsDesc": "Crie um novo ou adicione produtos no Catálogo",
    "modules.createNew": "+ Criar novo produto",
    "modules.selectorCancel": "Cancelar",
    "modules.addProductsFirst": "⚠️ Primeiro adicione produtos na seção Catálogo",
    "modules.annTimeTo": "a",
    "modules.announcements": "📢 Anúncios",
    "modules.announcementsDesc": "Popup que aparece ao abrir o cardápio com novidades ou promoções",
    "modules.annTitle": "Título do anúncio",
    "modules.annTitlePlaceholder": "Ex: Novidade! 🎉",
    "modules.annMessage": "Mensagem",
    "modules.annMsgPlaceholder": "Escreva a mensagem que seus clientes verão...",
    "modules.annImage": "Imagem do anúncio",
    "modules.annDeleteImage": "✕ Remover",
    "modules.annUploading": "Enviando imagem...",
    "modules.annClickUpload": "Clique para enviar imagem",
    "modules.annImgFormats": "PNG, JPG (máx 1000px)",
    "modules.annCtaText": "Texto do botão",
    "modules.annCtaPlaceholder": "Entendi!",
    "modules.annCtaUrl": "URL do botão (opcional)",
    "modules.annBgColor": "Cor de fundo",
    "modules.annAccentColor": "Cor de destaque (botão)",
    "modules.annShowOnce": "Mostrar apenas uma vez por sessão",
    "modules.annShowOnceDesc": "Se ativo, o popup só aparece na primeira vez que abrem o cardápio",
    "modules.annSchedule": "🕐 Faixa Horária",
    "modules.annScheduleDesc": "Mostrar o anúncio apenas em determinados horários",
    "modules.annAddRange": "+ Adicionar faixa",
    "modules.annPreview": "👁️ Pré-visualização do anúncio",
    "modules.annPreviewLabel": "É assim que seus clientes verão o anúncio",
    "modules.annNoTitle": "Sem título",
    "modules.annClose": "Fechar",

    "preview.title": "Pré-visualização",
    "preview.mobile": "Móvel",
    "preview.desktop": "Desktop",
    "preview.viewMenu": "👁️ Ver Cardápio",
    "preview.notAvailable": "Pré-visualização não disponível",
    "preview.saveFirst": "Salve o cardápio para gerar a pré-visualização",
    "preview.updateHint": "ℹ️ A pré-visualização é atualizada ao salvar alterações",

    "confirm.default": "Confirmar",
    "confirm.cancel": "Cancelar",
    "confirm.noPricesTitle": "Sem preços definidos",
    "confirm.noPricesMsg": "Você não definiu preços para este produto. Deseja continuar mesmo assim?",
    "confirm.continue": "Continuar",

    "catalog.dragReorder": "Arrastar para reordenar",
    "catalog.drag": "Arrastar",

    "product.transName": "Nome",
    "product.transDesc": "Descrição",
    "product.transNamePh": "Nome do produto...",
    "product.transDescPh": "Descrição...",
    "product.quickTags": "Tags rápidos",
    "product.customTagPh": "Tag personalizada...",
    "product.allergenPh": "Nome do alérgeno...",
    "product.modifierPh": "Nome do extra...",
    "product.modExtraPh": "Ex: Queijo extra ({lang})",

    "toast.saveSuccess": "Cardápio salvo com sucesso",
    "toast.saveError": "Erro ao salvar o cardápio",
    "toast.translating": "Traduzindo para {lang}...",
    "toast.translateSuccess": "Tradução para {lang} concluída!",
    "toast.translateError": "Erro ao traduzir. Alguns campos podem não ter sido traduzidos.",
    "toast.cannotRemoveDefault": "Não é possível remover o idioma padrão",
    "toast.minOnePriceType": "Deve haver pelo menos um tipo de preço",

    // ═══════════════════════════════════════════
    //  NON-V2 APP STRINGS
    // ═══════════════════════════════════════════

    "navbar.brand": "RestaurAdmin",
    "navbar.home": "Início",
    "navbar.myAccount": "Meus Menus",
    "navbar.signOut": "Sair",
    "navbar.signIn": "Entrar",
    "navbar.auth.emptyFields": "Por favor, preencha todos os campos",
    "navbar.auth.genericError": "Erro ao entrar. Tente novamente.",
    "navbar.auth.userNotFound": "Não existe uma conta com este e-mail.",
    "navbar.auth.wrongPassword": "Senha incorreta. Verifique e tente novamente.",
    "navbar.auth.invalidEmail": "O endereço de e-mail não é válido.",
    "navbar.auth.tooManyRequests": "Muitas tentativas falhadas. Tente mais tarde.",
    "navbar.auth.invalidCredential": "Credenciais inválidas. Verifique e tente novamente.",
    "navbar.auth.emailLabel": "E-mail",
    "navbar.auth.emailPlaceholder": "Digite seu e-mail",
    "navbar.auth.passwordLabel": "Senha",
    "navbar.auth.passwordPlaceholder": "Digite sua senha",
    "navbar.auth.showPassword": "Mostrar senha",
    "navbar.auth.hidePassword": "Ocultar senha",
    "navbar.auth.cancel": "Cancelar",
    "navbar.auth.signingIn": "Entrando...",

    "home.trustBadge": "Usado por +200 restaurantes",
    "home.weekBadge": "{count} restaurantes criaram seu cardápio esta semana",
    "home.hero.title": "Seu Cardápio Digital ",
    "home.hero.titleHighlight": "Pronto em 24h",
    "home.hero.subtitle1": "Sem gráficas. Sem erros. Sem limites.",
    "home.hero.subtitle2": "Atualize preços, pratos e fotos pelo celular",
    "home.hero.benefit1": "QR personalizado para seu negócio",
    "home.hero.benefit2": "Cardápio em vários idiomas incluído",
    "home.hero.benefit3": "Suporte técnico quando precisar",
    "home.hero.statValue": "+30%",
    "home.hero.statLabel": "Vendas médias",
    "home.hero.ctaButton": "Criar Meu Cardápio Agora",
    "home.hero.ctaInfo": "⚡ Sem cartão de crédito • Configuração em minutos",
    "home.testimonials.badge": "+200 Clientes Satisfeitos",
    "home.testimonials.viewTestimonial": "Ver depoimento de {author}",
    "home.testimonials.title": "Histórias Reais de Sucesso",
    "home.testimonials.subtitle": "Restaurantes que confiaram em nós e aumentaram suas vendas",
    "home.features.title": "Tudo que você precisa em um só lugar",
    "home.features.photos": "Fotos ilimitadas",
    "home.features.instantUpdate": "Atualização instantânea",
    "home.features.multiLanguage": "Multi-idioma",
    "home.features.customQr": "QR personalizado",
    "home.features.support": "Suporte 24/7",
    "home.features.editor": "Editor intuitivo",
    "home.finalCta.title": "Pronto para modernizar seu restaurante?",
    "home.finalCta.subtitle": "Junte-se aos +200 restaurantes que já digitalizaram seu cardápio e aumentaram as vendas",
    "home.finalCta.benefit1": "Setup em 24h",
    "home.finalCta.benefit2": "Sem custos ocultos",
    "home.finalCta.benefit3": "Cancele quando quiser",
    "home.finalCta.button": "Criar Meu Cardápio Digital Agora",
    "home.finalCta.guarantee": "Garantia 100% sem risco - Se não gostar nos primeiros 7 dias, devolvemos seu dinheiro",
    "home.footer.title": "Tem dúvidas? Vamos conversar",
    "home.footer.subtitle": "Respondemos todas as suas perguntas em menos de 2 horas",
    "home.footer.contactButton": "Falar com a Equipe",
    "home.whatsapp.tooltip": "Precisa de ajuda? Escreva-nos",
    "home.whatsapp.message": "Olá! Quero criar meu cardápio digital",

    "clientCarousel.badge": "CARDÁPIOS DIGITAIS EM AÇÃO",
    "clientCarousel.title": "Centenas de restaurantes confiam em nós!",
    "clientCarousel.subtitle": "Descubra como transformamos seus negócios",
    "clientCarousel.viewMenu": "Ver Cardápio",
    "clientCarousel.goToPage": "Ir para página {page}",
    "clientCarousel.previous": "Anterior",
    "clientCarousel.next": "Próximo",
    "clientCarousel.ctaText": "Gostaria de ter um cardápio como estes?",
    "clientCarousel.ctaButton": "Criar Meu Cardápio Digital",

    "contact.success.title": "Mensagem Enviada! 🎉",
    "contact.success.message": "Obrigado pelo seu interesse. Entraremos em contato em breve para ajudá-lo a criar seu cardápio digital personalizado.",
    "contact.success.button": "Perfeito",
    "contact.close": "Fechar",
    "contact.form.title": "Vamos Criar Seu Cardápio Digital Juntos! 🚀",
    "contact.form.subtitle": "Deixe seus dados e entraremos em contato para ajudá-lo a transformar seu negócio com um cardápio digital profissional",
    "contact.form.nameLabel": "Seu Nome",
    "contact.form.namePlaceholder": "Ex: João Silva",
    "contact.form.phoneLabel": "WhatsApp / Telefone",
    "contact.form.phonePlaceholder": "Ex: +55 11 91234-5678",
    "contact.form.emailLabel": "Email",
    "contact.form.emailPlaceholder": "seu@email.com",
    "contact.form.businessLabel": "Nome do seu Negócio",
    "contact.form.businessPlaceholder": "Ex: Restaurante A Esquina",
    "contact.form.messageLabel": "Conte-nos o que precisa",
    "contact.form.messagePlaceholder": "Ex: Quero um cardápio digital para meu restaurante com 50 produtos...",
    "contact.benefits.title": "✨ O que você vai receber:",
    "contact.benefits.item1": "✅ Cardápio digital profissional e personalizado",
    "contact.benefits.item2": "✅ QR para download e impressão",
    "contact.benefits.item3": "✅ Atualização ilimitada pelo painel",
    "contact.benefits.item4": "✅ Suporte técnico incluído",
    "contact.form.sending": "Enviando...",
    "contact.form.submitButton": "Enviar Consulta",

    "profile.sectionHeader": "Seus Cardápios",
    "profile.categories": "Categorias",
    "profile.products": "Produtos",
    "profile.lastUpdate": "Última atualização: ",
    "profile.viewMenu": "Ver Cardápio",
    "profile.editMenu": "Editar Cardápio",
    "profile.qrCode": "Código QR",
    "profile.deleteMenu": "Excluir Cardápio",
    "profile.print": "Imprimir",
    "profile.createNewMenu": "Criar Novo Cardápio",
    "profile.emptyState": "Você não tem cardápios disponíveis.",
    "profile.menuType.complete": "Completo",
    "profile.menuType.standard": "Padrão",
    "profile.menuType.basic": "Básico",
    "profile.dateNotAvailable": "Não disponível",
    "profile.deleteModal.title": "Confirmar Exclusão",
    "profile.deleteModal.message": "Tem certeza de que deseja excluir este cardápio? Você perderá todas as informações.",
    "profile.deleteModal.passwordLabel": "Digite sua senha para confirmar:",
    "profile.deleteModal.passwordPlaceholder": "Senha",
    "profile.deleteModal.verifying": "Verificando...",
    "profile.toast.menuExists": "Já existe um cardápio com esse nome. Escolha outro nome.",
    "profile.toast.menuCreatedSuccess": "Cardápio criado com sucesso. Recarregando...",
    "profile.toast.htmlError": "Erro ao criar o arquivo HTML.",
    "profile.toast.jsonError": "Erro ao criar o arquivo JSON.",
    "profile.toast.menuV2CreatedSuccess": "✨ Cardápio V2 criado com sucesso. Redirecionando para o editor...",
    "profile.toast.enterPassword": "Digite sua senha para confirmar",
    "profile.toast.menuDeleted": "Cardápio excluído com sucesso. Recarregando...",
    "profile.toast.wrongPassword": "Senha incorreta",
    "profile.toast.deleteError": "Erro ao excluir o cardápio",
    "profile.prompt.menuName": "Digite o nome do seu cardápio:",
    "profile.subtitle.one": "Seu cardápio. Toque para abrir.",
    "profile.subtitle.many": "{count} cardápios. Escolha um para gerenciar.",

    "menuDashboard.eyebrow": "Cardápio",
    "menuDashboard.back": "Meus cardápios",
    "menuDashboard.qrButton": "Código QR",
    "menuDashboard.viewPublic": "Ver cardápio público",
    "menuDashboard.sectionTitle": "O que você quer fazer?",
    "menuDashboard.feature.edit.title": "Editar cardápio digital",
    "menuDashboard.feature.edit.desc": "Adicionar ou modificar categorias, pratos, preços e fotos.",
    "menuDashboard.feature.pdf.title": "PDF para imprimir",
    "menuDashboard.feature.pdf.desc": "Baixe seu cardápio como PDF pronto para imprimir.",
    "menuDashboard.feature.pdf.badge": "Novo",
    "menuDashboard.feature.costs.title": "Custos e lucro",
    "menuDashboard.feature.costs.desc": "Veja quanto cada prato custa e quanto de lucro fica.",
    "menuDashboard.feature.costsStock.desc": "Quanto cada prato te deixa e quanto resta de cada insumo.",
    "menuDashboard.feature.reservations.title": "Reservas",
    "menuDashboard.feature.reservations.desc": "Receba reservas pelo cardápio e gerencie-as aqui.",
    "menuDashboard.feature.reservations.badge": "Novo",
    "menuDashboard.comingSoon": "Em breve",
    "menuDashboard.feature.online.title": "Pedidos online",
    "menuDashboard.feature.online.desc": "Seu link para pedir, a entrega e os pagamentos: ligue sua loja.",

    // ─── Reservations feature ───
    "reservations.title": "Reservas",
    "reservations.subtitle": "Gerencie as reservas do seu restaurante",
    "reservations.back": "Voltar",
    "reservations.loading": "Carregando...",
    "reservations.empty.title": "Ative as reservas em 1 minuto",
    "reservations.empty.desc": "Seus clientes vão poder reservar mesa pelo cardápio digital. Você recebe o pedido pelo WhatsApp e confirma com um toque.",
    "reservations.empty.step1": "Coloque seu número de WhatsApp",
    "reservations.empty.step1Desc": "As reservas chegam aqui",
    "reservations.empty.step2": "Desenhe suas mesas (opcional)",
    "reservations.empty.step2Desc": "Para o cliente ver onde vai sentar",
    "reservations.empty.step3": "Defina turnos (opcional)",
    "reservations.empty.step3Desc": "Horários disponíveis por dia",
    "reservations.empty.cta": "Começar",
    "reservations.setup.title": "Configuração inicial",
    "reservations.setup.waLabel": "Número de WhatsApp do restaurante",
    "reservations.setup.waPlaceholder": "+55 11 91234-5678",
    "reservations.setup.waHelp": "As reservas dos clientes chegam aqui.",
    "reservations.setup.save": "Salvar e continuar",
    "reservations.setup.saving": "Salvando...",
    "reservations.setup.invalidPhone": "Digite um número válido com código de país (ex: +55 11 91234-5678).",
    "reservations.setup.savedTitle": "Pronto!",
    "reservations.setup.savedDesc": "Você já pode receber reservas. Recomendamos desenhar suas mesas para uma melhor experiência.",
    "reservations.month.today": "Hoje",
    "reservations.month.weekdays": "Seg,Ter,Qua,Qui,Sex,Sáb,Dom",
    "reservations.month.months": "Janeiro,Fevereiro,Março,Abril,Maio,Junho,Julho,Agosto,Setembro,Outubro,Novembro,Dezembro",
    "reservations.month.empty": "Ainda não há reservas este mês.",
    "reservations.month.shareLink": "Compartilhe este link com seus clientes:",
    "reservations.month.shareLinkNotReady": "Seu link de reservas será gerado quando seu cardápio tiver um slug público em /admin. Avise-nos para configurar.",

    // ─── Claim slug self-service ───
    "reservations.claim.title": "Escolha seu link de reservas",
    "reservations.claim.desc": "Seu restaurante ainda não tem um link público. Escolha um nome curto e memorável.",
    "reservations.claim.placeholder": "meu-restaurante",
    "reservations.claim.claim": "Criar link",
    "reservations.claim.creating": "Criando...",
    "reservations.claim.checking": "Verificando disponibilidade...",
    "reservations.claim.available": "Disponível, pode usar.",
    "reservations.claim.taken": "Esse link já existe. Tente outro.",
    "reservations.claim.invalidFormat": "Apenas letras minúsculas, números e traços. Entre 3 e 30 caracteres.",
    "reservations.claim.checkError": "Não foi possível verificar. Tente de novo.",
    "reservations.claim.createError": "Não foi possível criar o link. Tente mais tarde.",
    "reservations.claim.claimedToast": "Link criado.",
    "reservations.claim.rules": "Regras do link",
    "reservations.claim.rule1": "Apenas letras minúsculas, números e traços.",
    "reservations.claim.rule2": "Entre 3 e 30 caracteres.",
    "reservations.claim.rule3": "Após criado não pode ser alterado (peça ajuda se errou).",
    "reservations.month.copyLink": "Copiar link",
    "reservations.month.linkCopied": "Link copiado!",
    "reservations.legend.pending": "Pendentes",
    "reservations.legend.confirmed": "Confirmadas",
    "reservations.legend.full": "Lotado",
    "reservations.placeholder.calendarTitle": "Seu calendário de reservas",
    "reservations.placeholder.calendarDesc": "Aqui você vê todas as reservas de cada dia. Toque em qualquer dia para ver o detalhe.",
    "reservations.placeholder.mapTitle": "Em breve: desenhe seu salão",
    "reservations.placeholder.mapDesc": "Você vai poder desenhar suas mesas arrastando e enviar fotos por zona. Seu cliente as vê antes de reservar.",
    "reservations.placeholder.turnsTitle": "Em breve: turnos por dia",
    "reservations.placeholder.turnsDesc": "Configure quais dias aceita reservas e em quais horários. Dias sem atendimento se desativam sozinhos.",

    // ─── Editor de mapa ───
    "reservations.editor.cta": "Desenhar minhas mesas",
    "reservations.editor.ctaDesc": "Desenhe seu salão. Seus clientes vão poder escolher mesa ao reservar.",
    "reservations.editor.title": "Editor de mesas",
    "reservations.editor.subtitle": "Arraste as mesas para acomodá-las",
    "reservations.editor.toolRect": "Mesa",
    "reservations.editor.toolCircle": "Redonda",
    "reservations.editor.toolLarge": "Longa",
    "reservations.editor.toolArea": "Setor",
    "reservations.editor.toolWall": "Parede",
    "reservations.editor.toolLabel": "Texto",
    "reservations.editor.toolPhoto": "Foto",
    "reservations.editor.tapToSelect": "Toque uma mesa para editá-la",
    "reservations.editor.itemTable": "Mesa",
    "reservations.editor.itemArea": "Setor",
    "reservations.editor.areaName": "Nome do setor",
    "reservations.editor.areaNamePlaceholder": "Salão, Varanda, Bar...",
    "reservations.editor.zoomIn": "Aproximar",
    "reservations.editor.zoomOut": "Afastar",
    "reservations.editor.zoomFit": "Centralizar o salão",
    "reservations.editor.drawWallsHint": "Modo paredes: toque os cantos, arraste para mover.",
    "reservations.editor.drawWallsStart": "Toque o primeiro canto da parede.",
    "reservations.editor.drawWallsNext": "Toque o próximo canto · {n} trechos",
    "reservations.editor.itemLabel": "Texto",
    "reservations.editor.itemPhoto": "Foto",
    "reservations.editor.itemWall": "Parede",
    "reservations.editor.number": "Número da mesa",
    "reservations.editor.numberPlaceholder": "1, 2, B3...",
    "reservations.editor.label": "Nome ou zona",
    "reservations.editor.labelPlaceholder": "Janela, Pátio, Bar...",
    "reservations.editor.seats": "Pessoas",
    "reservations.editor.minSeats": "Mínimo de pessoas",
    "reservations.editor.minSeatsHint": "O cliente não pode reservar esta mesa para menos pessoas que isto. 0 = sem mínimo (ex: uma mesa de 4 com mínimo 3 não é reservada para 1).",
    "reservations.editor.rotation": "Rotação",
    "reservations.editor.rotate90": "Girar 90°",
    "reservations.editor.width": "Largura",
    "reservations.editor.height": "Altura",
    "reservations.editor.diameter": "Diâmetro",
    "reservations.editor.wallLength": "Comprimento",
    "reservations.editor.wallThickness": "Espessura",
    "reservations.editor.text": "Texto",
    "reservations.editor.textPlaceholder": "JANELA",
    "reservations.editor.size": "Tamanho",
    "reservations.editor.photo": "Foto (opcional)",
    "reservations.editor.uploadPhoto": "Enviar foto",
    "reservations.editor.uploading": "Enviando...",
    "reservations.editor.uploadError": "Não foi possível enviar a foto.",
    "reservations.editor.caption": "Descrição",
    "reservations.editor.captionPlaceholder": "Vista da frente...",
    "reservations.editor.delete": "Excluir",
    "reservations.editor.deleteItem": "Excluir {item}",
    "reservations.editor.hintEmpty": "Toque numa ferramenta para adicionar mesas.",
    "reservations.editor.hintSelected": "Arraste para mover. Edite as propriedades no painel.",
    "reservations.editor.save": "Salvar mapa",
    "reservations.editor.saving": "Salvando...",
    "reservations.editor.undo": "Desfazer",
    "reservations.editor.redo": "Refazer",
    "reservations.editor.duplicate": "Duplicar",
    "reservations.editor.unsaved": "Mudanças não salvas",
    "reservations.editor.allSaved": "Tudo salvo",
    "reservations.editor.savedToast": "Mapa salvo",
    "reservations.editor.saveError": "Não foi possível salvar o mapa.",
    "reservations.editor.overrideSubtitle": "Mapa especial para {date}",
    "reservations.editor.overrideActive": "Este dia usa um mapa personalizado.",
    "reservations.editor.overrideStartHint": "Edite as mesas. As mudanças só se aplicam a este dia.",
    "reservations.editor.emptyState": "Toque uma ferramenta para adicionar sua primeira mesa.",
    "reservations.dayView.emptyTitle": "Sem reservas ainda",
    "reservations.dayView.emptyDesc": "Compartilhe seu link de reservas nas suas redes para começar a receber.",
    "reservations.editor.revertToBase": "Voltar ao mapa base",
    "reservations.editor.revertConfirm": "Apagar o mapa personalizado e voltar ao base?",
    "reservations.editor.revertedToast": "Voltou ao mapa base.",
    "reservations.dayView.editMapForDay": "Editar mapa para este dia",

    // ─── Config screen ───
    "reservations.config.cta": "Turnos e horários",
    "reservations.config.ctaDesc": "Configure quais dias aceita reservas, datas bloqueadas e mensagens automáticas.",
    "reservations.config.title": "Configuração",
    "reservations.config.subtitle": "Turnos, datas bloqueadas e mensagens.",
    "reservations.config.nameTitle": "Nome do restaurante",
    "reservations.config.nameHint": "Aparece como título na página onde seus clientes reservam.",
    "reservations.config.namePlaceholder": "Ex: Churrascaria do Don Juan",
    "reservations.config.waTitle": "📱 WhatsApp do restaurante",
    "reservations.config.waHint": "As reservas dos clientes chegam aqui.",
    "reservations.config.modeTitle": "Modo de reserva",
    "reservations.config.modeHint": "Escolha como aceita reservas.",
    "reservations.config.modeFree": "Horário livre",
    "reservations.config.modeFreeDesc": "O cliente escolhe qualquer horário dentro do seu funcionamento.",
    "reservations.config.modeTurns": "Por turnos",
    "reservations.config.modeTurnsDesc": "Defina turnos específicos (ex: 20-22 e 22:30-00:30). Cliente escolhe um.",
    "reservations.config.presetsTitle": "Modelos rápidos",
    "reservations.config.presetsHint": "Comece com um modelo e ajuste o que quiser.",
    "reservations.config.presetNone": "Sem turnos",
    "reservations.config.presetWeekendDinner": "Jantar sex/sáb/dom",
    "reservations.config.presetDinnerEveryday": "Jantar todos os dias",
    "reservations.config.presetLunchDinner": "Almoço e jantar",
    "reservations.config.daysTitle": "Dias e turnos",
    "reservations.config.daysHint": "Ative os dias que aceita reservas. Toque para definir os turnos.",
    "reservations.config.openHoursTitle": "Dias e horários de atendimento",
    "reservations.config.openHoursHint": "Ative os dias que abre. Seus clientes só vão poder escolher horários dentro destes intervalos.",
    "reservations.config.addTurn": "Adicionar turno",
    "reservations.config.addRange": "Adicionar intervalo",
    "reservations.config.removeTurn": "Remover turno",
    "reservations.config.blockedTitle": "📅 Datas bloqueadas",
    "reservations.config.blockedHint": "Feriados, dias sem atendimento, eventos privados. Nenhuma reserva nesses dias.",
    "reservations.config.blockDate": "Bloquear",
    "reservations.config.blockedEmpty": "Sem datas bloqueadas.",
    "reservations.config.unblock": "Desbloquear",
    "reservations.config.specialOpenTitle": "🗓️ Dias especiais que você abre",
    "reservations.config.specialOpenHint": "Feriados ou datas avulsas em que você abre mesmo não sendo dia habitual. Ficam disponíveis para reserva com o horário que definir.",
    "reservations.config.specialOpenAdd": "Adicionar dia",
    "reservations.config.specialOpenEmpty": "Sem dias especiais. Adicione um feriado para abrir reservas nesse dia.",
    "reservations.config.specialOpenRemove": "Remover",
    "reservations.config.specialOpenBeyondWindow": "Está além da sua janela de reservas ({days} dias): ficará disponível quando a data se aproximar.",
    "reservations.config.messagesTitle": "💬 Modelos de mensagem",
    "reservations.config.messagesHint": "Ao confirmar ou recusar, o WhatsApp abre com estas mensagens pré-prontas (sempre editáveis antes de enviar).",
    "reservations.config.variables": "Variáveis disponíveis:",
    "reservations.config.tplConfirm": "Confirmar reserva",
    "reservations.config.tplConfirmHint": "Enviado ao aceitar uma reserva.",
    "reservations.config.tplReject": "Recusar reserva",
    "reservations.config.tplRejectHint": "Quando não consegue atender.",
    "reservations.config.tplChange": "Mudança de mesa",
    "reservations.config.tplChangeHint": "Quando confirma mas atribui outra mesa.",
    "reservations.config.tplReminder": "Lembrete",
    "reservations.config.tplReminderHint": "A mensagem do botão 🔔 Lembrar (no dia da reserva).",
    "reservations.config.save": "Salvar configuração",
    "reservations.config.savedToast": "Configuração salva",
    "reservations.config.saveError": "Não foi possível salvar.",

    // ─── Public booking page ───
    "reservations.booking.title": "Reserve sua mesa",
    "reservations.booking.step1": "Escolha a data",
    "reservations.booking.step2": "Escolha o horário",
    "reservations.booking.step4": "Escolha sua mesa (opcional)",
    "reservations.booking.step4Hint": "Toque uma mesa para pedi-la. Se não, o restaurante atribui uma.",
    "reservations.booking.step5": "Seus dados",
    "reservations.booking.people": "Quantos?",
    "reservations.booking.personSingular": "pessoa",
    "reservations.booking.personPlural": "pessoas",
    "reservations.booking.yourName": "Seu nome",
    "reservations.booking.yourNamePh": "João Silva",
    "reservations.booking.yourPhone": "Seu WhatsApp",
    "reservations.booking.yourPhonePh": "11 98765 4321",
    "reservations.booking.notes": "Observações (opcional)",
    "reservations.booking.notesPh": "Aniversário, alergias, preferência indoor/outdoor...",
    "reservations.booking.submitCta": "Reservar pelo WhatsApp",
    "reservations.booking.submitHint": "O WhatsApp abre com seu pedido pré-preenchido. Envie ao restaurante e aguarde a confirmação.",
    "reservations.booking.sending": "Enviando...",
    "reservations.booking.submitError": "Não foi possível salvar sua reserva. Tente de novo.",
    "reservations.booking.tableTakenError": "Acabaram de reservar essa mesa. Escolha outra e tente de novo.",
    "reservations.booking.duplicateError": "Você já tem uma reserva para esse dia com este telefone. Para alterá-la, escreva no WhatsApp.",
    "reservations.booking.missingTime": "Falta: escolha um horário",
    "reservations.booking.missingZone": "Falta: escolha uma área",
    "reservations.booking.missingName": "Falta: seu nome",
    "reservations.booking.missingPhone": "Falta: seu telefone (WhatsApp)",
    "reservations.booking.phoneTooShort": "O telefone parece incompleto",
    "reservations.booking.outOfHoursError": "O horário escolhido está fora do horário de funcionamento. Confira os horários do dia.",
    "reservations.booking.tooSoonError": "Esse horário é muito cedo. Escolha um com mais antecedência.",
    "reservations.booking.dateChangedError": "O dia mudou. Escolha a data e o horário novamente.",
    "reservations.booking.noTurns": "Sem turnos disponíveis para este dia.",
    "reservations.booking.freeTimeLabel": "Escolha o horário",
    "reservations.booking.endsAt": "Você fica até as {time}",
    "reservations.booking.openHours": "Horário de atendimento",
    "reservations.booking.legendAvailable": "Disponível",
    "reservations.booking.legendReserved": "Reservada",
    "reservations.booking.legendPending": "Pendente",
    "reservations.booking.legendTooSmall": "Muito pequena",
    "reservations.booking.notFoundTitle": "Restaurante não encontrado",
    "reservations.booking.notFoundDesc": "Confira se o link está correto.",
    "reservations.booking.notReadyTitle": "Reservas indisponíveis",
    "reservations.booking.notReadyDesc": "Este restaurante ainda não ativou reservas online. Tente contatá-lo pelas redes sociais.",
    "reservations.booking.sentTitle": "Solicitação enviada",
    "reservations.booking.sentDesc": "Sua reserva ainda NÃO está confirmada. Envie a mensagem pelo WhatsApp e o restaurante confirma por lá.",
    "reservations.booking.sentHint": "Você vai receber a confirmação nesse mesmo WhatsApp quando o restaurante responder.",
    "reservations.booking.openWhatsApp": "📲 Abrir WhatsApp",
    "reservations.booking.bookAnother": "Fazer outra reserva",

    // ─── Day view (owner) ───
    "reservations.dayView.pending": "pendentes",
    "reservations.dayView.confirmed": "confirmadas",
    "reservations.dayView.empty": "Sem reservas para este dia.",
    "reservations.dayView.mapTitle": "Mapa do dia",
    "reservations.dayView.pendingTitle": "Pendentes",
    "reservations.dayView.confirmedTitle": "Confirmadas",
    "reservations.dayView.rejectedTitle": "Recusadas",
    "reservations.dayView.cancelledTitle": "Canceladas",
    "reservations.dayView.status_pending": "Pendente",
    "reservations.dayView.status_confirmed": "Confirmada",
    "reservations.dayView.status_rejected": "Recusada",
    "reservations.dayView.status_cancelled": "Cancelada",
    "reservations.dayView.status_expired": "Expirada",
    "reservations.dayView.confirm": "Confirmar",
    "reservations.dayView.changeTable": "Mudar mesa",
    "reservations.dayView.reject": "Recusar",
    "reservations.dayView.openWa": "WhatsApp",
    "reservations.dayView.resendConfirm": "Reenviar confirmação",
    "reservations.dayView.requestedTable": "Pediu: {name}",
    "reservations.dayView.assignedTable": "Atribuída: {name}",
    "reservations.dayView.rejectConfirm": "Recusar esta reserva? Você poderá mandar mensagem ao cliente.",
    "reservations.dayView.cancelBooking": "Cancelar reserva",
    "reservations.dayView.cancelBookingConfirm": "Cancelar esta reserva? A mesa ficará livre para outros clientes.",
    "reservations.dayView.cancelledToast": "Reserva cancelada. A mesa está livre de novo.",
    "reservations.dayView.confirmedToast": "Reserva confirmada. O WhatsApp abre.",
    "reservations.dayView.rejectedToast": "Reserva recusada. O WhatsApp abre.",
    "reservations.dayView.confirmedNoWaToast": "Reserva confirmada. (O WhatsApp não abriu porque o modelo está vazio.)",
    "reservations.dayView.rejectedNoWaToast": "Reserva recusada. (O WhatsApp não abriu porque o modelo está vazio.)",
    "reservations.dayView.invalidPhoneToast": "Salvo, mas o telefone do cliente é inválido — não consegui abrir o WhatsApp.",
    "reservations.dayView.assignedTableMissing": "A mesa atribuída foi removida do plano (era: {name})",

    "reservations.dayView.arrivedTitle": "Chegaram",
    "reservations.dayView.noShowTitle": "Não vieram",
    "reservations.dayView.status_arrived": "Chegou",
    "reservations.dayView.status_no_show": "Não veio",
    "reservations.dayView.markArrived": "Chegou",
    "reservations.dayView.markNoShow": "Não veio",
    "reservations.dayView.noShowConfirm": "Marcar como não veio? A mesa fica livre.",
    "reservations.dayView.arrivedToast": "Marcada como chegou.",
    "reservations.dayView.noShowToast": "Marcada como não veio. Mesa livre.",
    "reservations.dayView.edit": "Editar",
    "reservations.dayView.editedToast": "Reserva atualizada.",
    "reservations.dayView.newManualBooking": "Nova reserva manual",
    "reservations.dayView.manualCreatedToast": "Reserva criada.",
    "reservations.dayView.blockTable": "Bloquear mesa",
    "reservations.dayView.blockedToast": "Mesa bloqueada para este horário.",
    "reservations.dayView.sendReminder": "Lembrar",
    "reservations.dayView.defaultReminder": "Oi {name}! Só lembrando sua reserva em {date} às {time}. Até logo!",
    "reservations.dayView.pastNoShowWarn": "Este telefone faltou {count} vez(es) antes",

    "reservations.dashboard.notifEnabledToast": "Notificações ativadas",
    "reservations.dashboard.notifEnableThis": "Ativar avisos deste restaurante neste celular",
    "reservations.dashboard.notifOnThis": "Avisos deste restaurante ativados",
    "reservations.dashboard.notifOnHint": "Toque para parar de recebê-los neste celular",
    "reservations.dashboard.notifBlocked": "Avisos bloqueados — ative-os nas configurações do navegador",
    "reservations.dashboard.notifDisabledToast": "Avisos desativados neste celular",
    "reservations.dashboard.notifLegacyOffToast": "Pronto. Este celular não recebe mais avisos de todos os seus restaurantes — ative os que quiser.",
    "reservations.dashboard.searchPh": "Buscar por nome ou telefone...",
    "reservations.dashboard.upcomingTitle": "Próximas reservas",
    "reservations.dashboard.searchEmpty": "Sem reservas para isso.",

    "reservations.manualBooking.createTitle": "Nova reserva manual",
    "reservations.manualBooking.editTitle": "Editar reserva",
    "reservations.manualBooking.name": "Nome",
    "reservations.manualBooking.namePh": "Nome do cliente",
    "reservations.manualBooking.phone": "Telefone (opcional)",
    "reservations.manualBooking.phonePh": "+55 11 ...",
    "reservations.manualBooking.people": "Pessoas",
    "reservations.manualBooking.turn": "Turno",
    "reservations.manualBooking.time": "Horário",
    "reservations.manualBooking.table": "Mesa (opcional)",
    "reservations.manualBooking.noTable": "Sem mesa atribuída",
    "reservations.manualBooking.notes": "Observações",
    "reservations.manualBooking.cancel": "Cancelar",
    "reservations.manualBooking.create": "Criar reserva",
    "reservations.manualBooking.saveEdit": "Salvar alterações",
    "reservations.manualBooking.errorName": "Falta o nome.",
    "reservations.manualBooking.errorTime": "Falta o horário.",
    "reservations.manualBooking.outsideHoursWarn": "O horário está fora do horário aberto. Criar mesmo assim?",
    "reservations.manualBooking.tableOccupied": "ocupada",

    "reservations.blockTable.title": "Bloquear mesa",
    "reservations.blockTable.hint": "Use isso quando uma mesa não pode ser reservada (evento privado, reforma, etc).",
    "reservations.blockTable.table": "Mesa",
    "reservations.blockTable.from": "De",
    "reservations.blockTable.to": "Até",
    "reservations.blockTable.reason": "Motivo (opcional)",
    "reservations.blockTable.reasonPh": "Ex: evento privado",
    "reservations.blockTable.confirm": "Bloquear",
    "reservations.blockTable.errorTable": "Escolha uma mesa.",
    "reservations.blockTable.errorTime": "Faltam os horários.",
    "reservations.blockTable.errorTimeOrder": "O horário de fim tem que ser depois do de início.",
    "reservations.blockTable.errorTableTaken": "Essa mesa tem reserva nesse horário. Escolha outra.",
    "reservations.blockTable.tapTableHint": "Toque numa mesa livre no mapa para bloqueá-la",

    "reservations.stats.cta": "Estatísticas",
    "reservations.stats.ctaDesc": "Veja contagens, no-shows e mesas mais usadas.",
    "reservations.stats.title": "Estatísticas",
    "reservations.stats.subtitle": "Resumo do mês que você está vendo.",
    "reservations.stats.confirmed": "Confirmadas",
    "reservations.stats.arrived": "Chegaram",
    "reservations.stats.pending": "Pendentes",
    "reservations.stats.noShow": "Não vieram",
    "reservations.stats.cancelled": "Canceladas",
    "reservations.stats.rejected": "Recusadas",
    "reservations.stats.noShowRateTitle": "Taxa de não comparecimento",
    "reservations.stats.noShowRateHint": "Das que se fecharam (chegaram + não vieram), quantas não vieram.",
    "reservations.stats.perDayTitle": "Reservas por dia",
    "reservations.stats.topTablesTitle": "Mesas mais reservadas",
    "reservations.stats.topZonesTitle": "Áreas mais usadas",
    "reservations.stats.covers": "Cobertos",
    "reservations.stats.empty": "Ainda não há reservas neste mês.",
    "reservations.dayView.actionError": "Não foi possível atualizar. Tente de novo.",
    "reservations.dayView.assignTitle": "Escolha a mesa",
    "reservations.dayView.assignHint": "Toque na mesa que quer atribuir.",
    "reservations.dayView.assignConfirm": "Atribuir e confirmar",
    "reservations.dayView.cancel": "Cancelar",
    "reservations.dayView.legendSelected": "Selecionada",
    "reservations.dayView.legendOccupied": "Ocupada",

    "menuDashboard.qrModal.title": "Código QR do cardápio",
    "menuDashboard.qrModal.hint": "Os clientes escaneiam este código e abrem seu cardápio.",
    "menuDashboard.error": "Não foi possível carregar este cardápio.",
    "menuDashboard.errorBack": "Voltar para meus cardápios",

    "printPdf.back": "Voltar",
    "printPdf.title": "PDF para imprimir",
    "printPdf.subtitle": "Desenhe seu cardápio em papel e baixe.",
    "printPdf.loading": "Carregando dados do cardápio...",
    "printPdf.loadError": "Não foi possível carregar o cardápio.",
    "printPdf.stepper.step": "Passo {current} de {total}",
    "printPdf.stepper.1": "Design",
    "printPdf.stepper.2": "Tema",
    "printPdf.stepper.3": "Conteúdo",
    "printPdf.stepper.4": "Formato",
    "printPdf.nav.previous": "Anterior",
    "printPdf.nav.next": "Próximo",
    "printPdf.nav.finish": "Pronto",
    "printPdf.nav.togglePreview": "Ver prévia",
    "printPdf.nav.hidePreview": "Ocultar prévia",
    "printPdf.cta.download": "Baixar PDF",
    "printPdf.cta.openPdf": "📄 Abrir / baixar PDF",
    "printPdf.cta.pdfReadyHint": "Se o download não começou, toque aqui para abrir o PDF.",
    "printPdf.cta.loadingTitle": "Gerando seu PDF…",
    "printPdf.cta.loadingHint": "Pode levar alguns segundos. O download começa sozinho.",
    "printPdf.cta.generating": "Gerando...",
    "printPdf.cta.save": "Salvar design",
    "printPdf.cta.saved": "Design salvo",
    "printPdf.cta.saving": "Salvando...",
    "printPdf.cta.reset": "Restaurar design base",
    "printPdf.step1.title": "Escolha um design base",
    "printPdf.step1.subtitle": "O design define o estilo geral. Você ajusta depois.",
    "printPdf.templates.classic.name": "Clássico",
    "printPdf.templates.classic.desc": "Elegante, serif, espaçoso",
    "printPdf.templates.modern.name": "Moderno",
    "printPdf.templates.modern.desc": "Minimalista, tipografia limpa",
    "printPdf.templates.familiar.name": "Caloroso",
    "printPdf.templates.familiar.desc": "Aconchegante, legível, pratos em destaque",
    "printPdf.templates.chalkboard.name": "Lousa",
    "printPdf.templates.chalkboard.desc": "Fundo escuro, clima de bar",
    "printPdf.templates.fine.name": "Alta gastronomia",
    "printPdf.templates.fine.desc": "Serif delicado, muito espaço",
    "printPdf.step2.title": "Tema",
    "printPdf.step2.subtitle": "Escolha fundo, cores e tamanho do texto.",
    "printPdf.step2.background": "Fundo",
    "printPdf.step2.backgroundPresets": "Fundos predefinidos",
    "printPdf.step2.backgroundUpload": "Enviar meu próprio fundo",
    "printPdf.step2.backgroundUploadHint": "JPG ou PNG. Sua foto vira o fundo do cardápio.",
    "printPdf.step2.backgroundNone": "Sem fundo",
    "printPdf.step2.backgroundOpacity": "Opacidade do fundo",
    "printPdf.step2.backgroundOverlay": "Caixa clara atrás de cada prato",
    "printPdf.step2.backgroundOverlayHint": "Ajuda na leitura em fundos com imagem.",
    "printPdf.step2.colors": "Cores do texto",
    "printPdf.step2.colorTitles": "Títulos",
    "printPdf.step2.colorProducts": "Nomes dos pratos",
    "printPdf.step2.colorPrices": "Preços",
    "printPdf.step2.colorDescriptions": "Descrições",
    "printPdf.step2.fontFamily": "Tipografia",
    "printPdf.step2.fontDefault": "Conforme o design escolhido",
    "printPdf.step2.fontPreview": "Aa — Cardápio do restaurante",
    "printPdf.step2.textSize": "Tamanho do texto",
    "printPdf.step2.textSize.sm": "Pequeno",
    "printPdf.step2.textSize.md": "Normal",
    "printPdf.step2.textSize.lg": "Grande",
    "printPdf.step2.logo": "Logo do restaurante",
    "printPdf.step2.logoUpload": "Enviar logo",
    "printPdf.step2.logoRemove": "Remover logo",
    "printPdf.step3.title": "Conteúdo",
    "printPdf.step3.subtitle": "Escolha o que mostrar no PDF.",
    "printPdf.step3.showCover": "Capa com logo e nome",
    "printPdf.step3.showDescriptions": "Descrições dos pratos",
    "printPdf.step3.showPhotos": "Fotos dos pratos (se o cardápio tiver)",
    "printPdf.step3.showAllergens": "Etiquetas (sem glúten, vegano...)",
    "printPdf.step3.showRestaurantInfo": "Dados do restaurante no final",
    "printPdf.step3.showQr": "Código QR no final",
    "printPdf.step3.itemBox": "Moldura atrás de cada prato",
    "printPdf.step3.itemBoxHint": "Coloca cada prato em uma caixa suave para separá-los melhor.",
    "printPdf.step4.title": "Formato",
    "printPdf.step4.subtitle": "Tamanho do papel e orientação.",
    "printPdf.step4.paperSize": "Tamanho do papel",
    "printPdf.step4.paper.a4": "A4",
    "printPdf.step4.paper.a5": "A5",
    "printPdf.step4.paper.letter": "Carta",
    "printPdf.step4.paper.halfLetter": "Meia carta",
    "printPdf.step4.orientation": "Orientação",
    "printPdf.step4.orientation.portrait": "Retrato",
    "printPdf.step4.orientation.landscape": "Paisagem",
    "printPdf.step4.columns": "Colunas",
    "printPdf.step4.columns.one": "Uma",
    "printPdf.step4.columns.two": "Duas",
    "printPdf.step4.columns.three": "Três",
    "printPdf.stepper.5": "Textos",
    "printPdf.step5.title": "Edite os textos",
    "printPdf.step5.subtitle": "Mude nomes, descrições ou adicione notas — só para este PDF, seu cardápio digital não é alterado.",
    "printPdf.step5.hintTitle": "Dica:",
    "printPdf.step5.hintBody": "Deixe o campo vazio para manter o texto original. Você pode usar quebras de linha (Enter) em descrições e notas.",
    "printPdf.step5.categoryName": "Nome da categoria",
    "printPdf.step5.categoryDescription": "Descrição da categoria",
    "printPdf.step5.categoryDescriptionPlaceholder": "Ex: Ideais para compartilhar antes do prato principal",
    "printPdf.step5.keepTogether": "Manter junta (não dividir entre páginas)",
    "printPdf.step5.pageBreakBefore": "Começar em uma nova página",
    "printPdf.step5.productName": "Nome do produto",
    "printPdf.step5.productDescription": "Descrição",
    "printPdf.step5.productDescriptionPlaceholder": "Escreva uma descrição",
    "printPdf.step5.products": "produtos",
    "printPdf.step5.empty": "Não há categorias ou produtos no cardápio.",
    "printPdf.preview.title": "Prévia",
    "printPdf.preview.generating": "Gerando prévia...",
    "printPdf.preview.refresh": "Atualizar prévia",
    "printPdf.preview.mobileHint": "Toque para ver a prévia",
    "printPdf.toast.uploadError": "Não foi possível enviar a imagem.",
    "printPdf.toast.downloadError": "Não foi possível gerar o PDF. Tente novamente.",
    "printPdf.toast.saveError": "Não foi possível salvar o design.",
    "printPdf.toast.savedSuccess": "Design salvo.",
    "printPdfOutput.menu": "Cardápio",
    "printPdfOutput.allergens.sinTacc": "Sem glúten",
    "printPdfOutput.allergens.veg": "Vegetariano",
    "printPdfOutput.allergens.vegan": "Vegano",
    "printPdfOutput.scanQr": "Escaneie o QR para ver a versão digital",
    "printPdfOutput.findUs": "Encontre-nos",

    "menuEditor.recovery.title": "⚠️ Alterações não salvas",
    "menuEditor.recovery.message": "Foram encontradas alterações não salvas neste cardápio. Deseja recuperá-las e continuar editando?",
    "menuEditor.recovery.disclaimer": "Se escolher \"Descartar\", todas as alterações não salvas serão perdidas.",
    "menuEditor.recovery.discard": "Descartar alterações",
    "menuEditor.recovery.recover": "Recuperar e continuar",
    "menuEditor.viewMenu": "Ver Cardápio",
    "menuEditor.editPrices": "Editar Preços",
    "menuEditor.editAvailability": "Pausar Pratos",
    "menuEditor.updateMenu": "Atualizar Cardápio",
    "menuEditor.addCategory": "Categoria",

    "globalPrice.title": "Editor Global de Preços",
    "globalPrice.searchPlaceholder": "Buscar produto...",
    "globalPrice.allCategories": "Todas ({count})",
    "globalPrice.hideBulk": "Ocultar",
    "globalPrice.showBulk": "Operações em massa",
    "globalPrice.bulkPanel.title": "Aplicar alteração a todos os produtos exibidos",
    "globalPrice.bulkPanel.noProducts": "Não há produtos para aplicar alterações",
    "globalPrice.bulkPanel.productsCount": "Alterações serão aplicadas a {count} produto(s) visível(is)",
    "globalPrice.bulk.percentage": "Porcentagem (%)",
    "globalPrice.bulk.fixedAmount": "Valor fixo (R$)",
    "globalPrice.bulk.increase": "Aumentar",
    "globalPrice.bulk.decrease": "Diminuir",
    "globalPrice.bulk.valuePlaceholder": "Valor",
    "globalPrice.bulk.apply": "Aplicar",
    "globalPrice.noProductsFiltered": "Nenhum produto encontrado com os filtros aplicados",
    "globalPrice.noProductsInMenu": "Não há produtos com preços no cardápio",
    "globalPrice.table.product": "Produto",
    "globalPrice.table.category": "Categoria",
    "globalPrice.table.priceType": "Tipo de Preço",
    "globalPrice.table.currentPrice": "Preço Atual",
    "globalPrice.table.newPrice": "Novo Preço",
    "globalPrice.noName": "Sem nome",
    "globalPrice.pricesCount": "preços",
    "globalPrice.unsavedChanges": "Você tem {count} alteração(ões) não salva(s)",
    "globalPrice.modifiedCount": "{count} preço(s) modificado(s)",
    "globalPrice.cancel": "Cancelar",
    "globalPrice.saveChanges": "Salvar alterações",
    "globalPrice.discardConfirm": "Descartar todas as alterações não salvas?",
    "globalPrice.toast.noProducts": "Não há produtos para aplicar alterações",
    "globalPrice.toast.invalidValue": "Digite um valor válido maior que zero",
    "globalPrice.toast.bulkApplied": "✅ {count} alterações de preço aplicadas. Revise e pressione \"Salvar alterações\".",

    // ─── Global Availability Editor ───
    "availability.title": "Pausar / Ativar Pratos",
    "availability.searchPlaceholder": "Buscar prato...",
    "availability.allCategories": "Todas as categorias ({count})",
    "availability.filterAll": "Todos",
    "availability.filterActive": "Ativos",
    "availability.filterPaused": "Pausados",
    "availability.selectedCount": "{count} selecionado(s)",
    "availability.activateSelected": "Ativar selecionados",
    "availability.pauseSelected": "Pausar selecionados",
    "availability.noProductsFiltered": "Nenhum prato encontrado com os filtros aplicados",
    "availability.noProductsInMenu": "Não há pratos no cardápio",
    "availability.colProduct": "Prato",
    "availability.colCategory": "Categoria",
    "availability.colStatus": "Status",
    "availability.colToggle": "Ação",
    "availability.noName": "Sem nome",
    "availability.statusActive": "Ativo",
    "availability.statusPaused": "Pausado",
    "availability.toggleActive": "Ativo",
    "availability.togglePaused": "Pausado",
    "availability.pendingChanges": "{count} alteração(ões) pendente(s)",
    "availability.modifiedCount": "{count} prato(s) modificado(s)",
    "availability.pauseAll": "Pausar todos",
    "availability.activateAll": "Ativar todos",
    "availability.cancel": "Cancelar",
    "availability.saveChanges": "Salvar alterações",
    "availability.discardConfirm": "Descartar todas as alterações de disponibilidade não salvas?",


    "catEditor.unnamed": "Categoria sem nome ainda",
    "catEditor.paused": " (PAUSADA)",
    "catEditor.addProduct": "Produto",
    "catEditor.addSubCategory": "Sub-categoria",
    "catEditor.deleteCategory": "Excluir Categoria",
    "catEditor.deleteSubcategory": "Excluir Subcategoria",
    "catEditor.deleteConfirmTitle": "Confirmar Exclusão",
    "catEditor.deleteConfirmMessage": "Tem certeza de que deseja excluir esta categoria e todos os seus produtos?",
    "catEditor.activate": "Ativar",
    "catEditor.activateTitle": "Ativar categoria",
    "catEditor.pause": "Pausar",
    "catEditor.pauseTitle": "Pausar categoria",

    "productEditor.unnamed": "Prato sem nome ainda",
    "productEditor.tabInfo": "Informação",
    "productEditor.tabImage": "Imagem",
    "productEditor.tabPrices": "Preços",
    "productEditor.spanish": "Espanhol",
    "productEditor.english": "Inglês",
    "productEditor.name": "Nome",
    "productEditor.namePlaceholderEs": "Nome em espanhol",
    "productEditor.namePlaceholderEn": "Nome em inglês",
    "productEditor.description": "Descrição",
    "productEditor.descPlaceholderEs": "Descrição em espanhol",
    "productEditor.descPlaceholderEn": "Descrição em inglês",
    "productEditor.translateFailed": "Não foi possível traduzir. Tente de novo em um minuto.",
    "productEditor.translateToEnglish": "Traduzir para inglês",
    "productEditor.specialTags": "Etiquetas Especiais",
    "productEditor.tagVegan": "🌱 Vegano",
    "productEditor.tagGlutenFree": "🌾 Sem Glúten",
    "productEditor.tagsHelp": "Estas etiquetas aparecerão ao lado do nome do produto no cardápio",
    "productEditor.pricesTitle": "Preços do produto",
    "productEditor.noPrices": "Nenhum preço definido",
    "productEditor.noPricesHelp": "Adicione pelo menos um preço para que seu produto apareça no cardápio.",
    "productEditor.activate": "Ativar",
    "productEditor.pause": "Pausar",
    "productEditor.delete": "Excluir",
    "productEditor.deleteConfirmTitle": "Confirmar Exclusão",
    "productEditor.deleteConfirmMessage": "Tem certeza de que deseja excluir este produto?",

    "imageEditor.previewAlt": "Pré-visualização da imagem",
    "imageEditor.noImageAlt": "Nenhuma imagem disponível",
    "imageEditor.upload": "Enviar imagem",
    "imageEditor.view": "Ver imagem",
    "imageEditor.delete": "Excluir",
    "imageEditor.uploading": "CARREGANDO IMAGEM...",
    "imageEditor.previewTitle": "Pré-visualização da Imagem",
    "imageEditor.close": "Fechar",
    "imageEditor.deleteConfirmTitle": "Confirmar Exclusão",
    "imageEditor.deleteConfirmMessage": "Tem certeza de que deseja excluir esta imagem?",
    "imageEditor.cancel": "Cancelar",

    "priceTypes.title": "Tipos de preços",
    "priceTypes.placeholder": "Ex. Simples, Duplo, Triplo",
    "priceTypes.deleteAriaLabel": "Excluir tipo de preço",
    "priceTypes.tip": "Digite um nome descritivo para cada tipo de preço (Ex. Simples, Duplo, Triplo).",
    "priceTypes.add": "Adicionar tipo de preço",

    "bulkPrice.title": "Atualização massiva de preços",
    "bulkPrice.noProducts": "Não há produtos com preços para atualizar.",
    "bulkPrice.typeLabel": "Tipo de atualização",
    "bulkPrice.percentage": "Porcentagem (%)",
    "bulkPrice.fixedAmount": "Valor fixo (R$)",
    "bulkPrice.operationLabel": "Operação",
    "bulkPrice.increase": "Aumentar",
    "bulkPrice.decrease": "Diminuir",
    "bulkPrice.operationHelp": "Selecione se deseja aumentar ou diminuir os preços.",
    "bulkPrice.valueLabel.percentage": "Porcentagem a aplicar",
    "bulkPrice.valueLabel.fixedAmount": "Valor a aplicar",
    "bulkPrice.valueHelp.percentage": "Digite a porcentagem sem o símbolo %",
    "bulkPrice.valueHelp.fixedAmount": "Digite o valor sem o símbolo R$",
    "bulkPrice.previewTitle": "Pré-visualização de alterações ({count} produtos)",
    "bulkPrice.table.product": "Produto",
    "bulkPrice.table.priceType": "Tipo de preço",
    "bulkPrice.table.currentPrice": "Preço atual",
    "bulkPrice.table.newPrice": "Novo preço",
    "bulkPrice.noPreview": "Não há produtos com preços para atualizar ou o valor inserido não é válido.",
    "bulkPrice.cancel": "Cancelar",
    "bulkPrice.applying": "Aplicando...",
    "bulkPrice.apply": "Aplicar alterações",
    "bulkPrice.error.invalidValue": "Por favor, digite um valor válido maior que zero",
    "bulkPrice.error.noChanges": "Não há alterações para aplicar",
    "bulkPrice.noProductName": "Produto sem nome",
    "bulkPrice.variantFallback": "Variante",

    "infoEditor.nameLabel": "Nome",
    "infoEditor.namePlaceholder": "Adicione um nome",
    "infoEditor.descriptionLabel": "Descrição",
    "infoEditor.descriptionPlaceholder": "Adicione uma descrição",
    "infoEditor.translateToEnglish": "Traduzir para inglês",

    "qr.title": "Código QR - {name}",
    "qr.quantityLabel": "Quantidade de códigos QR por folha:",
    "qr.count1": "1 código QR",
    "qr.count4": "4 códigos QR",
    "qr.count6": "6 códigos QR",
    "qr.count9": "9 códigos QR",
    "qr.count12": "12 códigos QR",
    "qr.print": "Imprimir QR",
    "qr.download": "Baixar QR",
    "qr.close": "Fechar",

    "modal.cancel": "Cancelar",
    "modal.confirm": "Confirmar",

    "createMenu.comingSoon": "Em breve!",

    "testimonials.slideLabel": "Ir para depoimento {index}",

    "context.defaultPriceType": "Preço",
    "context.newPriceType": "Novo preço",
    "context.toast.maxPriceTypes": "Máximo de 5 tipos de preços permitidos",
    "context.toast.minPriceTypes": "Deve manter pelo menos um tipo de preço configurado",
    "context.toast.saveSuccess": "Seu cardápio foi salvo com sucesso no servidor",
    "context.toast.saveError": "Não foi possível salvar o cardápio. Verifique sua conexão e tente novamente.",
    "context.toast.menuNotFound": "O arquivo do cardápio não existe no servidor. Crie um novo a partir da lista.",
    "context.alert.menuFileNotFound": "O arquivo do cardápio não foi encontrado. Volte à lista e tente criá-lo novamente ou aguarde alguns segundos e recarregue.",
    "context.error.invalidImage": "O arquivo selecionado não é uma imagem suportada.",

    "constants.spanish": "Espanhol",
    "constants.english": "Inglês",
    "constants.price": "Preço",
    "constants.simple": "Simples",
    "constants.double": "Duplo",
    "constants.small": "Pequeno",
    "constants.medium": "Médio",
    "constants.large": "Grande",

    // ─── Home (landing page) ───
    "home.badge": "200+ cardápios criados",
    "home.hero.title1": "O cardápio digital",
    "home.hero.title2": "que seus clientes",
    "home.hero.title3": "vão amar",
    "home.hero.sub": "Criamos cardápios digitais premium para restaurantes em toda a Argentina. QR, multi-idioma, fotos HD, atualização instantânea.",
    "home.hero.ctaPrimary": "Quero meu cardápio",
    "home.hero.ctaGhost": "Ver exemplos",
    "home.hero.scroll": "Scroll",

    "home.stats.menus": "Cardápios criados",
    "home.stats.provinces": "Províncias",
    "home.stats.years": "Anos",
    "home.stats.google": "Google",

    "home.showcase.tag": "Portfólio",
    "home.showcase.title1": "Cardápios reais,",
    "home.showcase.title2": "ao vivo",
    "home.showcase.sub": "Cada celular mostra um cardápio real funcionando agora. Toque em qualquer um para explorar.",
    "home.showcase.prev": "Anterior",
    "home.showcase.next": "Próximo",

    "home.map.tag": "Cobertura",
    "home.map.title1": "De Jujuy à",
    "home.map.title2": "Tierra del Fuego",
    "home.map.sub": "{count} restaurantes em {provinces} províncias. Cada ponto é um cliente real.",
    "home.map.restaurants": "{count} restaurantes",
    "home.map.viewMenu": "Ver cardápio",
    "home.map.filterAll": "Todos",

    "home.rubros.restoran": "Restaurante",
    "home.rubros.parrilla": "Churrascaria",
    "home.rubros.pizzeria": "Pizzaria",
    "home.rubros.hamburgueseria": "Hamburgueria",
    "home.rubros.bar": "Bar",
    "home.rubros.sushi": "Sushi",
    "home.rubros.cafeteria": "Cafeteria",
    "home.rubros.cerveceria": "Cervejaria",
    "home.rubros.fastfood": "Fast Food",
    "home.rubros.wineBar": "Wine Bar",
    "home.rubros.italiana": "Italiana",
    "home.rubros.foodtruck": "Food truck",

    "home.proof.tag": "Avaliações",
    "home.proof.title1": "O que dizem",
    "home.proof.title2": "nossos clientes",
    "home.proof.googleLink": "Ver avaliações no Google",
    "home.proof.testimonial1.text": "Excelente serviço, muito rápidos e atentos. O cardápio digital ficou incrível, meus clientes adoram.",
    "home.proof.testimonial1.author": "Pablo M.",
    "home.proof.testimonial1.place": "Encrucijada, Santa Fé",
    "home.proof.testimonial2.text": "Super profissionais. Fizeram tudo no mesmo dia e fica perfeito no celular. Recomendo 100%.",
    "home.proof.testimonial2.author": "Ornella F.",
    "home.proof.testimonial2.place": "La Pescería, Buenos Aires",
    "home.proof.testimonial3.text": "O melhor investimento para meu restaurante. Os clientes escaneiam o QR e têm tudo na hora.",
    "home.proof.testimonial3.author": "Carolina R.",
    "home.proof.testimonial3.place": "Hotel La María, Mendoza",

    "home.features.tag": "Produto",
    "home.features.title1": "Tudo que",
    "home.features.title2": "você precisa",
    "home.features.photos.title": "Fotos HD",
    "home.features.photos.desc": "Cada prato com sua melhor imagem",
    "home.features.update.title": "Atualização instantânea",
    "home.features.update.desc": "Mude preços e pratos na hora",
    "home.features.multilang.title": "Multi-idioma",
    "home.features.multilang.desc": "Espanhol, inglês e português",
    "home.features.qr.title": "QR personalizado",
    "home.features.qr.desc": "Com seu logo e cores",
    "home.features.fast.title": "Carregamento ultrarrápido",
    "home.features.fast.desc": "Menos de 1 segundo",
    "home.features.support.title": "Suporte dedicado",
    "home.features.support.desc": "Ajudamos em tudo",

    "home.contact.tag": "Contato",
    "home.contact.title1": "Comece",
    "home.contact.title2": "hoje",
    "home.contact.desc": "Preencha o formulário e entraremos em contato em menos de 24h com seu cardápio pronto para revisar.",
    "home.contact.benefit1": "Design personalizado",
    "home.contact.benefit2": "Pronto em 24-48 horas",
    "home.contact.benefit3": "QR pronto para imprimir",
    "home.contact.benefit4": "Suporte permanente",
    "home.contact.success.title": "Mensagem enviada",
    "home.contact.success.desc": "Entraremos em contato em breve com seu cardápio pronto.",
    "home.contact.step1": "Dados",
    "home.contact.step2": "Contato",
    "home.contact.step3": "Mensagem",
    "home.contact.nameLabel": "Seu nome",
    "home.contact.namePlaceholder": "João Silva",
    "home.contact.businessLabel": "Nome do negócio",
    "home.contact.businessPlaceholder": "Meu Restaurante",
    "home.contact.phoneLabel": "Telefone",
    "home.contact.phonePlaceholder": "11 2345-6789",
    "home.contact.emailLabel": "Email",
    "home.contact.emailPlaceholder": "joao@email.com",
    "home.contact.messageLabel": "Mensagem (opcional)",
    "home.contact.messagePlaceholder": "Conte sobre seu negócio...",
    "home.contact.back": "Voltar",
    "home.contact.next": "Próximo",
    "home.contact.submit": "Enviar",
    "home.contact.submitting": "Enviando...",

    "home.footer.brandDesc": "Cardápios digitais premium para restaurantes em toda a Argentina.",
    "home.footer.product": "Produto",
    "home.footer.examples": "Ver exemplos",
    "home.footer.contact": "Contato",
    "home.footer.legal": "Legal",
    "home.footer.privacy": "Privacidade",
    "home.footer.terms": "Termos",
    "home.footer.dataDeletion": "Exclusão de dados",
    "home.footer.social": "Redes",

    "home.whatsapp.aria": "Contato por WhatsApp",
    "home.whatsapp.text": "Olá! Tenho interesse em um cardápio digital para meu restaurante",

    // ─── Custos e Lucro ───
    "costs.title": "Custos e Lucro",
    "costs.subtitle": "Carregue ingredientes e receitas para ver quanto cada prato custa e quanto de lucro fica.",
    "costs.back": "Voltar ao cardápio",
    "costs.tabs.dashboard": "Resumo",
    "costs.tabs.products": "Meus pratos",
    "costs.tabs.ingredients": "Ingredientes",
    "costs.tabs.subRecipes": "Preparados",
    "costs.tabs.settings": "Ajustes",

    "costs.empty.title": "Comece carregando ingredientes",
    "costs.empty.desc": "Adicione os ingredientes e depois monte a receita de cada prato.",
    "costs.empty.cta": "Adicionar primeiro ingrediente",

    "costs.onboarding.title": "👋 Comece em 3 passos",
    "costs.onboarding.subtitle": "Vamos te ajudar a ver quanto cada prato custa e quanto de lucro fica. Mais fácil do que parece.",
    "costs.onboarding.step1Title": "Carregue seus ingredientes",
    "costs.onboarding.step1Desc": "Coisas como farinha, óleo, carne moída... e quanto custa cada um por kilo ou litro. Temos uma lista de típicos para começar rápido.",
    "costs.onboarding.step1Cta": "Carregar ingredientes",
    "costs.onboarding.step2Title": "Diga o que cada prato leva",
    "costs.onboarding.step2Desc": "Para cada prato, indique quais ingredientes leva e quanto. Ex: hambúrguer leva 180g de carne, 1 pão, 30g de queijo.",
    "costs.onboarding.step2Cta": "Ir para meus pratos",
    "costs.onboarding.step2Locked": "Carregue ingredientes primeiro",
    "costs.onboarding.step3Title": "Veja seu lucro",
    "costs.onboarding.step3Desc": "Mostramos quanto cada prato custa, quanto de lucro fica, e te avisamos se algum estiver no prejuízo.",
    "costs.onboarding.step3Locked": "Carregue custos dos pratos primeiro",
    "costs.onboarding.simpleNote": "💡 Quer ir mais rápido? Pode pular os ingredientes e em cada prato carregar só o custo aproximado.",

    "costs.dashboard.avgFc": "Custo médio do prato",
    "costs.dashboard.avgMargin": "Lucro médio",
    "costs.dashboard.coverage": "{covered} de {total} pratos com custo carregado",
    "costs.dashboard.coverageHint": "completar o resto",
    "costs.dashboard.topRentables": "Mais lucrativos",
    "costs.dashboard.bottomRentables": "Menos lucrativos",
    "costs.dashboard.inDanger": "Quase sem lucro / no prejuízo",
    "costs.dashboard.noData": "Carregue receitas para ver o resumo",
    "costs.dashboard.noDanger": "Todos os pratos com bom lucro 👌",
    "costs.dashboard.alertsTitle": "Olhe estes pratos",
    "costs.dashboard.alertEmpty": "Nada urgente agora",
    "costs.dashboard.recalcCta": "🔄 Atualizar preços de ingredientes",

    "costs.status.healthy": "Bom lucro",
    "costs.status.warning": "Lucro justo",
    "costs.status.danger": "Quase sem lucro",
    "costs.status.unknown": "Sem dados",

    "costs.product.noCost": "Sem custo carregado",
    "costs.product.cargar": "Carregar custo",
    "costs.product.editCost": "Editar custo",
    "costs.product.deleteCost": "Remover custo",
    "costs.product.foodCost": "Quanto te custa",
    "costs.product.foodCostShort": "Custo",
    "costs.product.margin": "Lucro",
    "costs.product.suggested": "Preço sugerido",
    "costs.product.suggestedHint": "Para custo ser {target}% do preço",
    "costs.product.byPrice": "Seu preço no cardápio e o que fica",
    "costs.product.priceLabelSell": "Vende a",
    "costs.product.priceLabelLeftover": "fica",
    "costs.product.priceLabelMarginShort": "lucro",
    "costs.product.youKeep": "fica",
    "costs.product.searchPlaceholder": "Buscar prato...",
    "costs.product.filter.all": "Todos",
    "costs.product.filter.uncosted": "Sem custo",
    "costs.product.filter.danger": "Em risco",
    "costs.product.sort.name": "Nome",
    "costs.product.sort.foodCost": "% Custo",
    "costs.product.empty": "Este cardápio ainda não tem pratos. Adicione no editor.",

    "costs.drawer.title": "Custo: {productName}",
    "costs.drawer.intro": "Vamos calcular quanto este prato te custa fazer.",
    "costs.drawer.modeQuick": "Só o custo total",
    "costs.drawer.modeQuickDesc": "Coloca um número aproximado. Rápido mas não atualiza sozinho.",
    "costs.drawer.modeRecipe": "Detalhar ingredientes",
    "costs.drawer.modeRecipeDesc": "Diga quanto de cada ingrediente o prato leva. Quando um preço subir, todos os pratos que o usam recalculam sozinhos.",
    "costs.drawer.modeRecipeLocked": "🔒 Carregue ingredientes primeiro",
    "costs.drawer.modeChange": "Trocar modo",
    "costs.drawer.quickHelp": "Coloca um número aproximado de quanto custa fazer uma porção (ingredientes + gás + outros).",
    "costs.drawer.quickLabel": "Custo por porção",
    "costs.drawer.recipeHelp": "Para cada ingrediente diga quanto uma porção usa. Ex: hambúrguer leva 180g de carne, 1 pão, 30g de queijo.",
    "costs.drawer.recipeEmpty": "Adicione um ingrediente abaixo 👇",
    "costs.drawer.addIngredient": "+ Adicionar ingrediente",
    "costs.drawer.addSubRecipe": "+ Adicionar preparado",
    "costs.drawer.notes": "Notas (opcional)",
    "costs.drawer.notesPlaceholder": "Qualquer coisa que queira anotar.",
    "costs.drawer.indirectOverride": "Outros custos para este prato (luz, gás, folha)",
    "costs.drawer.indirectGlobal": "Padrão: {percent}% (ajuste em Ajustes)",
    "costs.drawer.indirectClear": "Voltar ao padrão",
    "costs.drawer.save": "Salvar",
    "costs.drawer.cancel": "Cancelar",
    "costs.drawer.close": "Fechar",
    "costs.drawer.summary": "Resumo",
    "costs.drawer.summaryDirect": "Ingredientes",
    "costs.drawer.summaryIndirect": "Outros custos",
    "costs.drawer.summaryTotal": "Total: quanto custa fazer",

    "costs.recipeLine.helpHeader": "Ingrediente · Quantidade · Perda % (se descascar/cortar perde algo)",
    "costs.recipeLine.amount": "Quantidade",
    "costs.recipeLine.unit": "Unidade",
    "costs.recipeLine.waste": "Perda %",
    "costs.recipeLine.wasteHint": "Se descascar/cortar perde algo. Ex: batata 10%, carne 5%. Senão, deixe 0.",
    "costs.recipeLine.remove": "Remover",
    "costs.recipeLine.unitMismatch": "⚠️ Unidade não combina com {ingredient}",
    "costs.recipeLine.pickIngredient": "Escolha um ingrediente",
    "costs.recipeLine.pickSubRecipe": "Escolha um preparado",
    "costs.recipeLine.cost": "Custo da linha",

    "costs.library.title": "Biblioteca de ingredientes",
    "costs.library.subtitle": "Carregue ingredientes com seus preços. Quando um preço mudar, atualize aqui e todos os pratos atualizam sozinhos.",
    "costs.library.add": "+ Adicionar ingrediente",
    "costs.library.search": "Buscar ingrediente...",
    "costs.library.empty": "Ainda sem ingredientes",
    "costs.library.emptyDesc": "Mais rápido: escolha da lista de típicos argentinos e só carregue o preço.",
    "costs.library.fromPreset": "🇦🇷 Lista de ingredientes típicos",
    "costs.library.fromScratch": "Criar novo",
    "costs.library.importFromMenu": "Importar de outro cardápio",
    "costs.library.history": "Histórico",
    "costs.library.lastUpdated": "Atualizado: {date}",
    "costs.library.usedIn": "Usado em {count}",
    "costs.library.notUsed": "Não usado",

    "costs.ingredient.modal.titleNew": "Novo ingrediente",
    "costs.ingredient.modal.titleEdit": "Editar ingrediente",
    "costs.ingredient.modal.name": "Nome",
    "costs.ingredient.modal.namePlaceholder": "Ex: Carne moída",
    "costs.ingredient.modal.cost": "Quanto te custa",
    "costs.ingredient.modal.costHint": "O que paga ao comprar. Ex: $4500 o kilo.",
    "costs.ingredient.modal.unit": "Unidade de compra",
    "costs.ingredient.modal.unitHint": "kg = kilo, g = grama, lt = litro, ml = mililitro, u = unidade.",
    "costs.ingredient.modal.supplier": "Fornecedor (opcional)",
    "costs.ingredient.modal.supplierPlaceholder": "Ex: Frigorífico X",
    "costs.ingredient.modal.save": "Salvar",
    "costs.ingredient.modal.cancel": "Cancelar",
    "costs.ingredient.modal.history": "Histórico de preços",
    "costs.ingredient.modal.noHistory": "Sem alterações registradas",

    "costs.ingredient.delete.title": "Excluir ingrediente",
    "costs.ingredient.delete.simple": "Excluir este ingrediente?",
    "costs.ingredient.delete.inUse": "Este ingrediente é usado em {count} lugares. Excluir vai removê-lo de todas as receitas que o usam.",
    "costs.ingredient.delete.confirm": "Sim, excluir",
    "costs.ingredient.delete.forceConfirm": "Excluir mesmo assim",

    "costs.preset.title": "Presets de cozinha argentina",
    "costs.preset.subtitle": "Marque os ingredientes que usa e só carregue o preço.",
    "costs.preset.cat.meats": "Carnes e aves",
    "costs.preset.cat.fish": "Peixes",
    "costs.preset.cat.dairy": "Laticínios e ovos",
    "costs.preset.cat.veggies": "Verduras e frutas",
    "costs.preset.cat.pantry": "Mercearia",
    "costs.preset.cat.oils": "Óleos e vinagres",
    "costs.preset.cat.canned": "Conservas",
    "costs.preset.cat.drinks": "Bebidas",
    "costs.preset.cat.bakery": "Padaria",
    "costs.preset.use": "Usar",
    "costs.preset.alreadyAdded": "Já está na sua biblioteca",

    "costs.subRecipe.title": "Preparados base",
    "costs.subRecipe.subtitle": "Preparações que usa em vários pratos (molhos, massas, marinadas). Carrega os ingredientes uma vez e reusa em qualquer prato como se fosse um ingrediente.",
    "costs.subRecipe.add": "+ Novo preparado",
    "costs.subRecipe.empty": "Sem preparados ainda",
    "costs.subRecipe.usedIn": "Usado em {count} pratos",
    "costs.subRecipe.modal.titleNew": "Novo preparado",
    "costs.subRecipe.modal.titleEdit": "Editar preparado",
    "costs.subRecipe.modal.name": "Nome",
    "costs.subRecipe.modal.namePlaceholder": "Ex: Molho à bolonhesa, Massa de pizza",
    "costs.subRecipe.modal.yield": "Quanto rende",
    "costs.subRecipe.modal.yieldHint": "Quanto sai no total. Ex: 2000 g de molho, 1.5 lt de suco, 12 unidades de massa.",
    "costs.subRecipe.modal.computed": "Custa {cost} no total ({perUnit} por {unit})",
    "costs.subRecipe.modal.notComputed": "Adicione ingredientes para calcular o custo",

    "costs.massRecalc.title": "Atualizar preços de ingredientes",
    "costs.massRecalc.subtitle": "Se os preços subiram, coloque os novos custos aqui. Cada prato que usa esses ingredientes recalcula sozinho.",
    "costs.massRecalc.cta": "🔄 Atualizar preços",
    "costs.massRecalc.newCost": "Novo preço",
    "costs.massRecalc.unchanged": "Sem alterações",
    "costs.massRecalc.preview": "Pré-visualização",
    "costs.massRecalc.changesCount": "{count} ingredientes com novo preço",
    "costs.massRecalc.affectedProducts": "{count} pratos serão atualizados",
    "costs.massRecalc.crossDanger": "{count} pratos perdem lucro",
    "costs.massRecalc.apply": "Aplicar alterações",
    "costs.massRecalc.cancel": "Cancelar",
    "costs.massRecalc.empty": "Sem ingredientes carregados",

    "costs.settings.title": "Ajustes",
    "costs.settings.indirect": "Outros custos por prato %",
    "costs.settings.indirectHint": "Porcentagem adicionada por padrão a cada prato para considerar gás, luz, folha. Típico: 15-20%.",
    "costs.settings.target": "Custo objetivo do prato %",
    "costs.settings.targetHint": "Quanto quer que o custo represente do preço de venda. Ideal: 28-35%. Usamos isso para sugerir preços.",
    "costs.settings.subRecipes": "Usar preparados base",
    "costs.settings.subRecipesHint": "Ative se tem molhos, massas ou caldos usados em vários pratos.",
    "costs.settings.save": "Salvar ajustes",

    "costs.import.title": "Importar de outro cardápio",
    "costs.import.desc": "Traga ingredientes (e opcionalmente sub-receitas) de outro cardápio seu. Se já tem ingredientes com o mesmo nome, eles não são sobrescritos.",
    "costs.import.menuLabel": "Cardápio origem",
    "costs.import.includeSub": "Incluir sub-receitas",
    "costs.import.btn": "Importar",
    "costs.import.cancel": "Cancelar",
    "costs.import.noOtherMenus": "Não há outros cardápios com custos carregados.",

    "costs.currency.warningTitle": "Moedas não coincidem",
    "costs.currency.warningDesc": "Seus custos estão em {costsCurrency} mas o cardápio está em {menuCurrency}. Revise os valores manualmente.",

    "costs.toast.saved": "Salvo",
    "costs.toast.saveError": "Erro ao salvar",
    "costs.toast.imported": "Dados importados",
    "costs.toast.deleted": "Excluído",

    "costs.menuDashboard.title": "Custos e Lucro",
    "costs.menuDashboard.desc": "Veja quanto cada prato custa, quanto de lucro fica, e que preço cobrar.",
    "costs.menuDashboard.cta": "Abrir calculadora",
  },
};

// PEDIDOS ONLINE (COST-03): el main.js lleva solo `pos` (la bandeja y los avisos de comandas, que
// corren también en la POS del local). config / rules / pedir / editor (300 KB) viajan en el pedazo
// de quien los usa y se suman al cargarse (pedidos/register.js). En los TESTS, todo como antes: los
// tests de claves y de pantallas leen este diccionario directo (la rama muerta no entra al build).
// eslint-disable-next-line global-require
const pedidos = process.env.NODE_ENV === "test" ? require("./pedidos").default : pedidosPos;

// Claves nuevas de la UI de reservas (es/en/pt) — viven en su propio módulo
// para no inflar este archivo. Se mergean por idioma.
// `editorV2` va ÚLTIMO a propósito: son las claves del rediseño del editor y
// algunas redefinen textos viejos de `translations` (p. ej. "editor.save").
const merged = {
  es: { ...translations.es, ...reservationsNew.es, ...cashRegister.es, ...comandas.es, ...costs.es, ...costsV3.es, ...pedidos.es, ...editorV2.es, ...(landing.es || {}) },
  en: { ...translations.en, ...reservationsNew.en, ...cashRegister.en, ...comandas.en, ...costs.en, ...costsV3.en, ...pedidos.en, ...editorV2.en, ...(landing.en || {}) },
  pt: { ...translations.pt, ...reservationsNew.pt, ...cashRegister.pt, ...comandas.pt, ...costs.pt, ...costsV3.pt, ...pedidos.pt, ...editorV2.pt, ...(landing.pt || {}) },
};

export default merged;
